export const toho = [
    {
      "a": 11,
      "b": 6,
      "c": [
        223,
        223,
        221
      ],
      "id": "TA-01-1",
      "t": "Transparent Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        233,
        233,
        233
      ],
      "id": "TA-01-1F",
      "t": "Transparent Frosted Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        224,
        177,
        69
      ],
      "id": "TA-01-2F",
      "t": "Transparent Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        181,
        115,
        28
      ],
      "id": "TA-01-2C",
      "t": "Transparent Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        0,
        121,
        225
      ],
      "id": "TA-01-3BF",
      "t": "Transparent Frosted Dark Aquamarine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        186,
        215,
        30
      ],
      "id": "TA-01-4",
      "t": "Transparent Lime Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        171,
        193,
        21
      ],
      "id": "TA-01-4F",
      "t": "Transparent Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        175,
        33,
        31
      ],
      "id": "TA-01-5B",
      "t": "Transparent Siam Ruby",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        124,
        80,
        93
      ],
      "id": "TA-01-6F",
      "t": "Transparent Frosted Lt Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        78,
        36,
        49
      ],
      "id": "TA-01-6B",
      "t": "Transparent Med Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        75,
        45,
        60
      ],
      "id": "TA-01-6BF",
      "t": "Transparent Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        7,
        131,
        51
      ],
      "id": "TA-01-7BF",
      "t": "Transparent Frosted Grass Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        6,
        71,
        89
      ],
      "id": "TA-01-7BD",
      "t": "Transparent Capri Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        7,
        79,
        106
      ],
      "id": "TA-01-7BDF",
      "t": "Transparent Frosted Teal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        30,
        29,
        154
      ],
      "id": "TA-01-8",
      "t": "Transparent Cobalt",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        58,
        46,
        182
      ],
      "id": "TA-01-8F",
      "t": "Transparent Frosted Dark Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        113,
        116,
        111
      ],
      "id": "TA-01-9",
      "t": "Transparent Black Diamond",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        108,
        112,
        110
      ],
      "id": "TA-01-9F",
      "t": "Transparent Frosted Lt Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        106,
        111,
        110
      ],
      "id": "TA-01-9BF",
      "t": "Transparent Frosted Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        228,
        104,
        40
      ],
      "id": "TA-01-10",
      "t": "Transparent Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        233,
        223,
        0
      ],
      "id": "TA-01-12F",
      "t": "Transparent Frosted Lemon",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        34,
        32,
        32
      ],
      "id": "TA-01-14",
      "t": "Transparent Root Beer",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        193,
        213,
        142
      ],
      "id": "TA-01-15",
      "t": "Transparent Citrus Spritz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        93,
        73,
        112
      ],
      "id": "TA-01-19",
      "t": "Transparent Sugar Plum",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        94,
        75,
        113
      ],
      "id": "TA-01-19F",
      "t": "Transparent Frosted Sugar Plum",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        213,
        212,
        204
      ],
      "id": "TA-01-21",
      "t": "Transparent Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        214,
        209,
        190
      ],
      "id": "TA-01-21F",
      "t": "Matte Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        216,
        212,
        196
      ],
      "id": "TA-01-PF21",
      "t": "PermaFinish Silver-Lined Transparent Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        210,
        185,
        103
      ],
      "id": "TA-01-22",
      "t": "Transparent Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        213,
        181,
        97
      ],
      "id": "TA-01-22F",
      "t": "Matte Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        171,
        122,
        49
      ],
      "id": "TA-01-22C",
      "t": "Transparent Silver-Lined Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        93,
        162,
        165
      ],
      "id": "TA-01-23",
      "t": "Transparent Silver-Lined Aquamarine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        121,
        185,
        190
      ],
      "id": "TA-01-23F",
      "t": "Matte Silver-Lined Aquamarine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        30,
        183,
        202
      ],
      "id": "TA-01-23B",
      "t": "Transparent Silver-Lined Dark Aquamarine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        178,
        192,
        37
      ],
      "id": "TA-01-24",
      "t": "Transparent Silver-Lined Lime Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        193,
        205,
        49
      ],
      "id": "TA-01-24F",
      "t": "Matte Silver-Lined Lime Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        184,
        64,
        41
      ],
      "id": "TA-01-25",
      "t": "Transparent Silver-Lined Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        178,
        50,
        46
      ],
      "id": "TA-01-25B",
      "t": "Transparent Silver-Lined Siam Ruby",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        122,
        41,
        35
      ],
      "id": "TA-01-25C",
      "t": "Transparent Silver-Lined Ruby",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        127,
        30,
        28
      ],
      "id": "TA-01-25CF",
      "t": "Matte Silver-Lined Ruby",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        91,
        51,
        42
      ],
      "id": "TA-01-25D",
      "t": "Transparent Silver-Lined Garnet",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        148,
        113,
        107
      ],
      "id": "TA-01-26",
      "t": "Transparent Silver-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        120,
        93,
        76
      ],
      "id": "TA-01-26B",
      "t": "Transparent Silver-Lined Med Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        99,
        82,
        68
      ],
      "id": "TA-01-26C",
      "t": "Transparent Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        75,
        53,
        43
      ],
      "id": "TA-01-26CF",
      "t": "Matte Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        84,
        162,
        32
      ],
      "id": "TA-01-27",
      "t": "Transparent Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        21,
        113,
        117
      ],
      "id": "TA-01-27BD",
      "t": "Transparent Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        53,
        56,
        131
      ],
      "id": "TA-01-28",
      "t": "Transparent Silver-Lined Cobalt",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        109,
        111,
        91
      ],
      "id": "TA-01-29B",
      "t": "Transparent Silver-Lined Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        224,
        141,
        23
      ],
      "id": "TA-01-30",
      "t": "Transparent Silver-Lined Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        211,
        174,
        140
      ],
      "id": "TA-01-31",
      "t": "Transparent Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        215,
        214,
        6
      ],
      "id": "TA-01-32",
      "t": "Transparent Silver-Lined Lemon",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        129,
        149,
        192
      ],
      "id": "TA-01-33F",
      "t": "Matte Silver-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        144,
        86,
        32
      ],
      "id": "TA-01-34",
      "t": "Transparent Silver-Lined Smokey Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        77,
        90,
        169
      ],
      "id": "TA-01-35",
      "t": "Transparent Silver-Lined Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        12,
        69,
        33
      ],
      "id": "TA-01-36",
      "t": "Transparent Silver-Lined Green Emerald",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        62,
        80,
        37
      ],
      "id": "TA-01-37",
      "t": "Transparent Silver-Lined Olivine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        126,
        109,
        120
      ],
      "id": "TA-01-39",
      "t": "Transparent Silver-Lined Tanzanite",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        236,
        236,
        234
      ],
      "id": "TA-01-41",
      "t": "Opaque White",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        224,
        225,
        221
      ],
      "id": "TA-01-41F",
      "t": "Opaque Frosted White",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        244,
        240,
        0
      ],
      "id": "TA-01-42",
      "t": "Opaque Dandelion",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        229,
        225,
        34
      ],
      "id": "TA-01-42F",
      "t": "Opaque Frosted Dandelion",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        134,
        203,
        231
      ],
      "id": "TA-01-43",
      "t": "Opaque Kingman Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        167,
        204,
        75
      ],
      "id": "TA-01-44",
      "t": "Opaque Sour Apple",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        186,
        218,
        70
      ],
      "id": "TA-01-44F",
      "t": "Opaque Frosted Sour Apple",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        156,
        27,
        26
      ],
      "id": "TA-01-45",
      "t": "Opaque Pepper Red",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        145,
        35,
        42
      ],
      "id": "TA-01-45F",
      "t": "Opaque Frosted Pepper Red",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        175,
        20,
        26
      ],
      "id": "TA-01-45A",
      "t": "Opaque Cherry",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        172,
        34,
        33
      ],
      "id": "TA-01-45AF",
      "t": "Opaque Frosted Cherry",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        67,
        52,
        45
      ],
      "id": "TA-01-46",
      "t": "Opaque Oxblood",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        78,
        62,
        51
      ],
      "id": "TA-01-46F",
      "t": "Opaque Frosted Oxblood",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        124,
        53,
        29
      ],
      "id": "TA-01-46L",
      "t": "Opaque Burnt Orange",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        147,
        77,
        46
      ],
      "id": "TA-01-46LF",
      "t": "Opaque Frosted Terra Cotta",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        35,
        104,
        53
      ],
      "id": "TA-01-47H",
      "t": "Opaque Pine Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        55,
        112,
        67
      ],
      "id": "TA-01-47HF",
      "t": "Opaque Frosted Pine Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        56,
        55,
        167
      ],
      "id": "TA-01-48",
      "t": "Opaque Navy-Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        25,
        25,
        25
      ],
      "id": "TA-01-49",
      "t": "Opaque Jet",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        44,
        42,
        44
      ],
      "id": "TA-01-49F",
      "t": "Opaque Matte Jet",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        224,
        45,
        17
      ],
      "id": "TA-01-50",
      "t": "Opaque Sunset Orange",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        163,
        166,
        169
      ],
      "id": "TA-01-53",
      "t": "Opaque Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        110,
        196,
        193
      ],
      "id": "TA-01-55",
      "t": "Opaque Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        100,
        184,
        178
      ],
      "id": "TA-01-55F",
      "t": "Opaque Frosted Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        74,
        82,
        99
      ],
      "id": "TA-01-81",
      "t": "Metallic Hematite",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        38,
        47,
        70
      ],
      "id": "TA-01-82",
      "t": "Metallic Nebula",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        88,
        80,
        53
      ],
      "id": "TA-01-83",
      "t": "Metallic Brown Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        65,
        91,
        85
      ],
      "id": "TA-01-84",
      "t": "Metallic Green-Brown Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        73,
        56,
        60
      ],
      "id": "TA-01-85",
      "t": "Metallic Purple Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        82,
        78,
        80
      ],
      "id": "TA-01-86",
      "t": "Metallic Iris Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        81,
        85,
        87
      ],
      "id": "TA-01-86F",
      "t": "Metallic Frosted Iris Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        55,
        42,
        150
      ],
      "id": "TA-01-87",
      "t": "Transparent Cobalt Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        54,
        66,
        82
      ],
      "id": "TA-01-88",
      "t": "Metallic Cosmos",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        53,
        54,
        51
      ],
      "id": "TA-01-89",
      "t": "Metallic Moss",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        41,
        38,
        52
      ],
      "id": "TA-01-90",
      "t": "Metallic Gunmetal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        230,
        231,
        223
      ],
      "id": "TA-01-101",
      "t": "Transparent Crystal Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        230,
        229,
        57
      ],
      "id": "TA-01-102",
      "t": "Transparent Lemon Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        208,
        177,
        98
      ],
      "id": "TA-01-103",
      "t": "Transparent Lt Topaz Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        143,
        96,
        62
      ],
      "id": "TA-01-103C",
      "t": "Transparent Topaz Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        76,
        168,
        215
      ],
      "id": "TA-01-104",
      "t": "Transparent Aquamarine Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        212,
        172,
        156
      ],
      "id": "TA-01-106",
      "t": "Transparent Rosaline Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        119,
        136,
        210
      ],
      "id": "TA-01-107",
      "t": "Transparent Lt Sapphire Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        70,
        115,
        142
      ],
      "id": "TA-01-108BD",
      "t": "Transparent Teal Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        184,
        85,
        77
      ],
      "id": "TA-01-109",
      "t": "Transparent Lt Siam Ruby Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        140,
        117,
        132
      ],
      "id": "TA-01-110",
      "t": "Transparent Lt Amethyst Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        98,
        82,
        95
      ],
      "id": "TA-01-110B",
      "t": "Transparent Med Amethyst Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        236,
        116,
        71
      ],
      "id": "TA-01-111",
      "t": "Transparent Lt Hyacinth Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        110,
        118,
        122
      ],
      "id": "TA-01-112",
      "t": "Transparent Black Diamond Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        88,
        100,
        112
      ],
      "id": "TA-01-113",
      "t": "Transparent Gray Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        60,
        60,
        169
      ],
      "id": "TA-01-116",
      "t": "Transparent Cobalt Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        73,
        100,
        103
      ],
      "id": "TA-01-118",
      "t": "Transparent Green Emerald Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        93,
        107,
        116
      ],
      "id": "TA-01-119",
      "t": "Transparent Olivine Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        233,
        234,
        233
      ],
      "id": "TA-01-121",
      "t": "Opaque White Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        220,
        220,
        202
      ],
      "id": "TA-01-122",
      "t": "Opaque Navajo White Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        226,
        205,
        164
      ],
      "id": "TA-01-123",
      "t": "Opaque Lt Beige Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        137,
        193,
        220
      ],
      "id": "TA-01-124B",
      "t": "Opaque Baby Blue Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        143,
        64,
        64
      ],
      "id": "TA-01-125",
      "t": "Opaque Cherry Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        226,
        220,
        24
      ],
      "id": "TA-01-128",
      "t": "Opaque Dandelion Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        235,
        219,
        38
      ],
      "id": "TA-01-128B",
      "t": "Opaque Sunshine Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        229,
        103,
        76
      ],
      "id": "TA-01-129",
      "t": "Opaque Pumpkin Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        114,
        166,
        109
      ],
      "id": "TA-01-130",
      "t": "Opaque Mint Green Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        89,
        154,
        122
      ],
      "id": "TA-01-130D",
      "t": "Opaque Shamrock Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        172,
        207,
        112
      ],
      "id": "TA-01-131",
      "t": "Opaque Sour Apple Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        96,
        179,
        174
      ],
      "id": "TA-01-132",
      "t": "Opaque Turquoise Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        137,
        116,
        134
      ],
      "id": "TA-01-133",
      "t": "Opaque Lavender Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        118,
        138,
        202
      ],
      "id": "TA-01-134",
      "t": "Opaque Periwinkle Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        194,
        214,
        147
      ],
      "id": "TA-01-135",
      "t": "Transparent Lemon-Lime Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        228,
        229,
        230
      ],
      "id": "TA-01-141",
      "t": "Ceylon Snowflake",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        217,
        217,
        217
      ],
      "id": "TA-01-141F",
      "t": "Ceylon Frosted Snowflake",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        223,
        215,
        125
      ],
      "id": "TA-01-142F",
      "t": "Ceylon Frosted Banana Creme",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        146,
        198,
        212
      ],
      "id": "TA-01-143",
      "t": "Ceylon Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        150,
        206,
        222
      ],
      "id": "TA-01-143F",
      "t": "Ceylon Frosted Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        121,
        189,
        155
      ],
      "id": "TA-01-144",
      "t": "Ceylon Celery Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        134,
        207,
        157
      ],
      "id": "TA-01-144F",
      "t": "Ceylon Frosted Celery",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        253,
        167,
        183
      ],
      "id": "TA-01-145",
      "t": "Ceylon Innocent Pink",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        136,
        143,
        149
      ],
      "id": "TA-01-150",
      "t": "Ceylon Smoke",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        228,
        231,
        228
      ],
      "id": "TA-01-161",
      "t": "Transparent Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        206,
        172,
        78
      ],
      "id": "TA-01-162",
      "t": "Transparent Lt Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        171,
        117,
        55
      ],
      "id": "TA-01-162C",
      "t": "Transparent Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        62,
        175,
        212
      ],
      "id": "TA-01-163",
      "t": "Transparent Aquamarine Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        178,
        210,
        74
      ],
      "id": "TA-01-164",
      "t": "Transparent Lime Green Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        115,
        39,
        49
      ],
      "id": "TA-01-165C",
      "t": "Transparent Ruby Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        134,
        105,
        115
      ],
      "id": "TA-01-166",
      "t": "Transparent Lt Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        86,
        45,
        60
      ],
      "id": "TA-01-166B",
      "t": "Transparent Med Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        101,
        89,
        106
      ],
      "id": "TA-01-166C",
      "t": "Transparent Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        116,
        106,
        137
      ],
      "id": "TA-01-166D",
      "t": "Transparent Sugar Plum Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        28,
        139,
        53
      ],
      "id": "TA-01-167",
      "t": "Transparent Peridot Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        44,
        105,
        129
      ],
      "id": "TA-01-167BD",
      "t": "Transparent Teal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        210,
        170,
        155
      ],
      "id": "TA-01-169",
      "t": "Transparent Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        191,
        214,
        153
      ],
      "id": "TA-01-173",
      "t": "Transparent Dyed Lemon Mist Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        133,
        141,
        143
      ],
      "id": "TA-01-176",
      "t": "Transparent Black Diamond Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        121,
        117,
        135
      ],
      "id": "TA-01-176B",
      "t": "Transparent Gray Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        116,
        84,
        65
      ],
      "id": "TA-01-177",
      "t": "Transparent Smokey Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        50,
        100,
        116
      ],
      "id": "TA-01-179",
      "t": "Transparent Green Emerald Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        50,
        87,
        145
      ],
      "id": "TA-01-189",
      "t": "Caribbean Blue-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        37,
        70,
        136
      ],
      "id": "TA-01-189FM",
      "t": "Frosted Caribbean Blue-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        97,
        64,
        81
      ],
      "id": "TA-01-201",
      "t": "Transparent Amethyst Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        97,
        52,
        50
      ],
      "id": "TA-01-202",
      "t": "Transparent Lilac Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        112,
        91,
        60
      ],
      "id": "TA-01-221",
      "t": "Bronze",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        135,
        114,
        66
      ],
      "id": "TA-01-221F",
      "t": "Matte Bronze",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        75,
        40,
        38
      ],
      "id": "TA-01-222",
      "t": "Dark Bronze",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        111,
        80,
        76
      ],
      "id": "TA-01-222F",
      "t": "Matte Dark Bronze",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        153,
        37,
        32
      ],
      "id": "TA-01-241FM",
      "t": "Frosted Mauve-Lined Lt Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        92,
        73,
        64
      ],
      "id": "TA-01-245",
      "t": "Jet-Lined Jonquil Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        164,
        161,
        44
      ],
      "id": "TA-01-246",
      "t": "Yellow-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        151,
        148,
        14
      ],
      "id": "TA-01-246FM",
      "t": "Frosted Yellow-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        57,
        90,
        104
      ],
      "id": "TA-01-248",
      "t": "Jet-Lined Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        168,
        169,
        163
      ],
      "id": "TA-01-261",
      "t": "Light Gray-Lined Crystal Luster Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        147,
        139,
        107
      ],
      "id": "TA-01-262",
      "t": "Gold-Lined Clear Crystal Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        92,
        137,
        166
      ],
      "id": "TA-01-263",
      "t": "Light Capri-Lined Crystal Luster Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        72,
        122,
        112
      ],
      "id": "TA-01-264",
      "t": "Teal-Lined Crystal Luster Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        75,
        64,
        102
      ],
      "id": "TA-01-265FM",
      "t": "Frosted Metallic Purple-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        14,
        148,
        0
      ],
      "id": "TA-01-306FM",
      "t": "Frosted Shamrock-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        50,
        121,
        93
      ],
      "id": "TA-01-322",
      "t": "Emerald Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        114,
        99,
        85
      ],
      "id": "TA-01-325",
      "t": "Lt Tanzanite Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        77,
        80,
        91
      ],
      "id": "TA-01-326",
      "t": "Spinach Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        113,
        64,
        40
      ],
      "id": "TA-01-329",
      "t": "African Sunset Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        85,
        41,
        44
      ],
      "id": "TA-01-331",
      "t": "Wild Berry Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        93,
        46,
        61
      ],
      "id": "TA-01-332",
      "t": "Raspberry Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        181,
        74,
        70
      ],
      "id": "TA-01-341",
      "t": "Tomato-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        61,
        60,
        58
      ],
      "id": "TA-01-344",
      "t": "Jet-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        130,
        178,
        196
      ],
      "id": "TA-01-351",
      "t": "Blue-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        155,
        137,
        143
      ],
      "id": "TA-01-353",
      "t": "Lavender-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        80,
        47,
        59
      ],
      "id": "TA-01-381FM",
      "t": "Frosted Oxblood-Lined Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        177,
        48,
        58
      ],
      "id": "TA-01-388",
      "t": "Hyacinth-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        229,
        227,
        221
      ],
      "id": "TA-01-401",
      "t": "Opaque White Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        228,
        209,
        0
      ],
      "id": "TA-01-402B",
      "t": "Opaque Daffodil Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        140,
        199,
        227
      ],
      "id": "TA-01-403",
      "t": "Opaque Blue Turquoise Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        175,
        211,
        90
      ],
      "id": "TA-01-404",
      "t": "Opaque Sour Apple Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        116,
        35,
        40
      ],
      "id": "TA-01-405",
      "t": "Opaque Cherry Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        139,
        91,
        79
      ],
      "id": "TA-01-405F",
      "t": "Opaque Matte Cherry Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        158,
        36,
        40
      ],
      "id": "TA-01-405A",
      "t": "Opaque Pepper Red Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        69,
        79,
        183
      ],
      "id": "TA-01-408",
      "t": "Opaque Navy-Blue Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        117,
        136,
        232
      ],
      "id": "TA-01-408L",
      "t": "Opaque Periwinkle Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        220,
        213,
        184
      ],
      "id": "TA-01-409",
      "t": "Opaque Lt Beige Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        229,
        221,
        196
      ],
      "id": "TA-01-409F",
      "t": "Opaque Matte Lt Beige Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        224,
        78,
        49
      ],
      "id": "TA-01-410",
      "t": "Opaque Pumpkin Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        147,
        113,
        133
      ],
      "id": "TA-01-412F",
      "t": "Opaque Matte Lavender Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        118,
        197,
        202
      ],
      "id": "TA-01-413",
      "t": "Opaque Turquoise Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        127,
        190,
        184
      ],
      "id": "TA-01-413F",
      "t": "Opaque Matte Turquoise Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        119,
        75,
        38
      ],
      "id": "TA-01-421",
      "t": "Transparent Pink Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        121,
        123,
        83
      ],
      "id": "TA-01-422",
      "t": "Dark Chocolate Bronze Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        168,
        104,
        31
      ],
      "id": "TA-01-429",
      "t": "Transparent Lt Amber Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        126,
        120,
        138
      ],
      "id": "TA-01-455",
      "t": "Pale Wisteria Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        121,
        124,
        82
      ],
      "id": "TA-01-457",
      "t": "Green Tea Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        153,
        123,
        114
      ],
      "id": "TA-01-460",
      "t": "Opaque Brown Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        108,
        51,
        147
      ],
      "id": "TA-01-461",
      "t": "Royal Purple Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        72,
        103,
        200
      ],
      "id": "TA-01-479",
      "t": "Transparent Kyanite Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        136,
        82,
        58
      ],
      "id": "TA-01-501",
      "t": "High-Metallic Cinnamon Bronze",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        85,
        46,
        79
      ],
      "id": "TA-01-503",
      "t": "High-Metallic Dark Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        48,
        70,
        109
      ],
      "id": "TA-01-504",
      "t": "High-Metallic Violet Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        49,
        114,
        150
      ],
      "id": "TA-01-505",
      "t": "High-Metallic Dragonfly",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        43,
        107,
        109
      ],
      "id": "TA-01-506",
      "t": "High-Metallic June Bug",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        101,
        119,
        83
      ],
      "id": "TA-01-507",
      "t": "High-Metallic Green Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        89,
        108,
        80
      ],
      "id": "TA-01-508",
      "t": "High-Metallic Olivine Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        107,
        114,
        82
      ],
      "id": "TA-01-509",
      "t": "High-Metallic Purple-Green Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        105,
        124,
        127
      ],
      "id": "TA-01-511",
      "t": "Galvanized Peacock Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        127,
        138,
        117
      ],
      "id": "TA-01-512",
      "t": "Galvanized Green Silver",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        121,
        139,
        120
      ],
      "id": "TA-01-512F",
      "t": "High-Metallic Matte Blue Haze",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        143,
        120,
        67
      ],
      "id": "TA-01-513",
      "t": "Galvanized Carnival",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        141,
        109,
        51
      ],
      "id": "TA-01-513F",
      "t": "High-Metallic Matte Carnival",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        127,
        80,
        83
      ],
      "id": "TA-01-514",
      "t": "Galvanized Gypsy Gold",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        133,
        83,
        74
      ],
      "id": "TA-01-514F",
      "t": "High-Metallic Matte Copper Twilight",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        111,
        83,
        133
      ],
      "id": "TA-01-515",
      "t": "Galvanized Hydrangea",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        83,
        74,
        123
      ],
      "id": "TA-01-515F",
      "t": "High-Metallic Matte Mardi Gras",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        110,
        128,
        110
      ],
      "id": "TA-01-517",
      "t": "Galvanized Peridot Hematite",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        107,
        121,
        93
      ],
      "id": "TA-01-517F",
      "t": "Galvanized Matte Peridot-Hematite",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        52,
        103,
        102
      ],
      "id": "TA-01-519",
      "t": "Galvanized Teal Hematite",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        157,
        93,
        86
      ],
      "id": "TA-01-520",
      "t": "Galvanized Merlot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        78,
        41,
        39
      ],
      "id": "TA-01-520F",
      "t": "Galvanized Matte Merlot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        100,
        58,
        33
      ],
      "id": "TA-01-522",
      "t": "Galvanized Rosy Brown",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        199,
        152,
        109
      ],
      "id": "TA-01-551",
      "t": "Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        210,
        155,
        85
      ],
      "id": "TA-01-PF551F",
      "t": "PermaFinish Galvanized Matte Rose Gold",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        206,
        158,
        140
      ],
      "id": "TA-01-552",
      "t": "Galvanized Fairy Wings",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        183,
        107,
        114
      ],
      "id": "TA-01-PF553F",
      "t": "PermaFinish Galvanized Matte Vintage Rose",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        214,
        148,
        153
      ],
      "id": "TA-01-PF553",
      "t": "PermaFinish Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        171,
        145,
        144
      ],
      "id": "TA-01-PF554F",
      "t": "PermaFinish Galvanized Matte Lavender",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        200,
        168,
        156
      ],
      "id": "TA-01-PF554",
      "t": "PermaFinish Galvanized Lilac",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        126,
        95,
        88
      ],
      "id": "TA-01-556",
      "t": "Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        131,
        99,
        83
      ],
      "id": "TA-01-PF556F",
      "t": "PermaFinish Galvanized Matte Mocha Frost",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        145,
        100,
        68
      ],
      "id": "TA-01-PF556",
      "t": "PermaFinish Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        202,
        180,
        97
      ],
      "id": "TA-01-PF557F",
      "t": "PermaFinish Galvanized Matte Starlight",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        190,
        169,
        109
      ],
      "id": "TA-01-PF557",
      "t": "PermaFinish Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        205,
        197,
        147
      ],
      "id": "TA-01-558",
      "t": "Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        196,
        189,
        135
      ],
      "id": "TA-01-PF558F",
      "t": "PermaFinish Galvanized Matte Aluminum",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        204,
        192,
        140
      ],
      "id": "TA-01-PF558",
      "t": "PermaFinish Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        184,
        174,
        97
      ],
      "id": "TA-01-559",
      "t": "Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        198,
        195,
        108
      ],
      "id": "TA-01-PF559F",
      "t": "PermaFinish Galvanized Matte Yellow Gold",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        211,
        203,
        137
      ],
      "id": "TA-01-PF559",
      "t": "PermaFinish Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        161,
        197,
        125
      ],
      "id": "TA-01-560",
      "t": "Galvanized Sea Foam",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        123,
        170,
        110
      ],
      "id": "TA-01-560F",
      "t": "Galvanized Matte Sea Foam",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        172,
        199,
        154
      ],
      "id": "TA-01-PF560",
      "t": "PermaFinish Galvanized Sea Foam",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        104,
        187,
        162
      ],
      "id": "TA-01-561",
      "t": "Galvanized Green Teal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        90,
        173,
        137
      ],
      "id": "TA-01-PF561F",
      "t": "PermaFinish Galvanized Matte Lt Teal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        109,
        197,
        157
      ],
      "id": "TA-01-PF561",
      "t": "PermaFinish Galvanized Green Teal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        190,
        84,
        36
      ],
      "id": "TA-01-PF562F",
      "t": "PermaFinish Galvanized Matte Saffron",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        198,
        85,
        31
      ],
      "id": "TA-01-PF562",
      "t": "PermaFinish Galvanized Saffron",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        200,
        53,
        143
      ],
      "id": "TA-01-563",
      "t": "Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        178,
        48,
        91
      ],
      "id": "TA-01-PF563F",
      "t": "PermaFinish Galvanized Matte Orchid",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        200,
        50,
        85
      ],
      "id": "TA-01-PF563",
      "t": "PermaFinish Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        164,
        72,
        46
      ],
      "id": "TA-01-PF564F",
      "t": "PermaFinish Galvanized Matte Burgundy Frost",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        139,
        55,
        49
      ],
      "id": "TA-01-PF564",
      "t": "PermaFinish Galvanized Brick Red",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        138,
        153,
        140
      ],
      "id": "TA-01-PF565F",
      "t": "PermaFinish Galvanized Matte Blue Slate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        140,
        157,
        149
      ],
      "id": "TA-01-PF565",
      "t": "PermaFinish Galvanized Blue Slate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        146,
        142,
        135
      ],
      "id": "TA-01-566",
      "t": "Metallic Matte Antique Silver",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        119,
        108,
        157
      ],
      "id": "TA-01-PF567F",
      "t": "PermaFinish Metallic Matte Polaris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        140,
        131,
        157
      ],
      "id": "TA-01-PF567",
      "t": "PermaFinish Metallic Polaris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        161,
        144,
        156
      ],
      "id": "TA-01-PF568",
      "t": "PermaFinish Metallic Pink Pewter",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        40,
        161,
        141
      ],
      "id": "TA-01-PF569",
      "t": "PermaFinish Galvanized Teal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        120,
        173,
        101
      ],
      "id": "TA-01-PF570",
      "t": "PermaFinish Galvanized Mint Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        89,
        82,
        74
      ],
      "id": "TA-01-602",
      "t": "Galvanized Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        116,
        112,
        106
      ],
      "id": "TA-01-602F",
      "t": "Metallic Matte Gunmetal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        85,
        60,
        91
      ],
      "id": "TA-01-607",
      "t": "Galvanized Violet",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        96,
        78,
        101
      ],
      "id": "TA-01-607F",
      "t": "Metallic Matte Soft Violet",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        66,
        71,
        81
      ],
      "id": "TA-01-611",
      "t": "Metallic Frosted Gray Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        79,
        85,
        94
      ],
      "id": "TA-01-612",
      "t": "Opaque Matte Tahitian Pearl",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        106,
        106,
        94
      ],
      "id": "TA-01-613",
      "t": "Opaque Matte Gray Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        88,
        82,
        82
      ],
      "id": "TA-01-614",
      "t": "Opaque Matte Brown Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        85,
        73,
        80
      ],
      "id": "TA-01-615",
      "t": "Opaque Matte Purple Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        89,
        93,
        55
      ],
      "id": "TA-01-617",
      "t": "Matte Black Olive",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        111,
        71,
        44
      ],
      "id": "TA-01-618",
      "t": "Matte Mudbrick",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        119,
        77,
        121
      ],
      "id": "TA-01-625F",
      "t": "Transparent Frosted Blackberry Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        95,
        155,
        112
      ],
      "id": "TA-01-660",
      "t": "Transparent Peridot Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        100,
        136,
        115
      ],
      "id": "TA-01-699",
      "t": "Shamrock-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        101,
        87,
        54
      ],
      "id": "TA-01-702",
      "t": "Matte Dark Copper",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        103,
        67,
        82
      ],
      "id": "TA-01-703",
      "t": "Matte Mauve",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        91,
        70,
        102
      ],
      "id": "TA-01-704",
      "t": "Matte Andromeda",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        67,
        84,
        101
      ],
      "id": "TA-01-705",
      "t": "Matte Blue Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        82,
        119,
        110
      ],
      "id": "TA-01-706",
      "t": "Matte Dark Emerald Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        80,
        79,
        74
      ],
      "id": "TA-01-708",
      "t": "Matte Cassiopeia",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        108,
        96,
        103
      ],
      "id": "TA-01-709",
      "t": "Matte Peacock Iris",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        75,
        114,
        92
      ],
      "id": "TA-01-710",
      "t": "Matte Aquarius",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        210,
        184,
        92
      ],
      "id": "TA-01-712",
      "t": "24K Gold Plate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        205,
        172,
        91
      ],
      "id": "TA-01-712F",
      "t": "Frosted 24K Gold Plate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        178,
        175,
        164
      ],
      "id": "TA-01-713",
      "t": "Metallic Silver",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        190,
        188,
        177
      ],
      "id": "TA-01-714",
      "t": "Metallic Chrome Silver",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        185,
        185,
        172
      ],
      "id": "TA-01-714F",
      "t": "Metallic Matte Chrome Silver",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        195,
        168,
        84
      ],
      "id": "TA-01-715",
      "t": "24K Bright Gold Plate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        206,
        178,
        98
      ],
      "id": "TA-01-715F",
      "t": "Frosted 24K Bright Gold Plate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        199,
        165,
        53
      ],
      "id": "TA-01-722",
      "t": "Metallic Gold Aurora",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        147,
        123,
        103
      ],
      "id": "TA-01-740F",
      "t": "Matte Copper-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        57,
        95,
        34
      ],
      "id": "TA-01-742",
      "t": "Copper-Lined Peridot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        62,
        101,
        112
      ],
      "id": "TA-01-748",
      "t": "Copper-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        93,
        79,
        66
      ],
      "id": "TA-01-750",
      "t": "Copper-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        47,
        94,
        82
      ],
      "id": "TA-01-756",
      "t": "Gold-Lined Tahitian Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        104,
        100,
        83
      ],
      "id": "TA-01-757",
      "t": "Gold-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        226,
        226,
        224
      ],
      "id": "TA-01-761",
      "t": "Opaque Matte White Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        225,
        222,
        189
      ],
      "id": "TA-01-762",
      "t": "Opaque Matte Ivory",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        225,
        206,
        161
      ],
      "id": "TA-01-763",
      "t": "Opaque Matte Bone",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        192,
        164,
        147
      ],
      "id": "TA-01-764",
      "t": "Opaque Matte Ebi",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        219,
        219,
        220
      ],
      "id": "TA-01-767",
      "t": "Opaque Matte Cumulus Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        232,
        218,
        121
      ],
      "id": "TA-01-770",
      "t": "Yellow-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        113,
        65,
        64
      ],
      "id": "TA-01-771FM",
      "t": "Frosted Strawberry-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        105,
        116,
        120
      ],
      "id": "TA-01-773",
      "t": "Montana Blue-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        95,
        104,
        131
      ],
      "id": "TA-01-774",
      "t": "Grape-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        105,
        180,
        100
      ],
      "id": "TA-01-775",
      "t": "Grass Green-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        117,
        93,
        142
      ],
      "id": "TA-01-776",
      "t": "Purple-Lined Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        227,
        226,
        204
      ],
      "id": "TA-01-777",
      "t": "Creme-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        98,
        172,
        201
      ],
      "id": "TA-01-781",
      "t": "Aqua-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        103,
        132,
        161
      ],
      "id": "TA-01-782",
      "t": "Capri-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        98,
        108,
        118
      ],
      "id": "TA-01-783",
      "t": "Gray-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        171,
        36,
        101
      ],
      "id": "TA-01-785",
      "t": "Hot Pink-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        146,
        44,
        119
      ],
      "id": "TA-01-790",
      "t": "Fuchsia-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        194,
        84,
        79
      ],
      "id": "TA-01-791",
      "t": "Current-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        123,
        183,
        183
      ],
      "id": "TA-01-793",
      "t": "Pale Turquoise-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        219,
        159,
        117
      ],
      "id": "TA-01-794",
      "t": "Apricot-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        105,
        177,
        73
      ],
      "id": "TA-01-795",
      "t": "White-Lined Peridot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        30,
        95,
        61
      ],
      "id": "TA-01-796",
      "t": "Dark Emerald-Lined Emerald",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        169,
        28,
        57
      ],
      "id": "TA-01-798",
      "t": "Light Topaz-Lined Siam",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        254,
        159,
        159
      ],
      "id": "TA-01-811",
      "t": "Opaque Pastel Peach Blossom Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        253,
        119,
        100
      ],
      "id": "TA-01-830",
      "t": "Neon Nectarine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        214,
        227,
        88
      ],
      "id": "TA-01-833",
      "t": "Neon Canary",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        198,
        79,
        127
      ],
      "id": "TA-01-837",
      "t": "Neon Fuchsia",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        61,
        50,
        43
      ],
      "id": "TA-01-860",
      "t": "Copper-Lined Storm Cloud",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        57,
        57,
        50
      ],
      "id": "TA-01-862",
      "t": "Copper-Lined Olive",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        227,
        204,
        126
      ],
      "id": "TA-01-903",
      "t": "Ceylon Custard",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        254,
        172,
        192
      ],
      "id": "TA-01-909",
      "t": "Ceylon Cotton Candy",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        52,
        90,
        141
      ],
      "id": "TA-01-917",
      "t": "Ceylon Denim Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        126,
        189,
        213
      ],
      "id": "TA-01-919",
      "t": "Ceylon Forget-Me-Not",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        51,
        135,
        119
      ],
      "id": "TA-01-920",
      "t": "Ceylon Light Sea Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        129,
        128,
        188
      ],
      "id": "TA-01-921",
      "t": "Ceylon Virginia Bluebell",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        131,
        109,
        168
      ],
      "id": "TA-01-922",
      "t": "Ceylon Gladiola",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        237,
        119,
        100
      ],
      "id": "TA-01-925",
      "t": "Coral Pink-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        69,
        33,
        106
      ],
      "id": "TA-01-928",
      "t": "Purple-Lined Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        95,
        67,
        107
      ],
      "id": "TA-01-928FM",
      "t": "Frosted Purple-Lined Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        58,
        63,
        81
      ],
      "id": "TA-01-929",
      "t": "Capri-Lined Lt Yellow Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        53,
        163,
        197
      ],
      "id": "TA-01-931",
      "t": "White-Lined Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        26,
        78,
        117
      ],
      "id": "TA-01-932",
      "t": "Capri-Lined Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        7,
        58,
        112
      ],
      "id": "TA-01-932FM",
      "t": "Frosted Capri-Lined Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        75,
        86,
        158
      ],
      "id": "TA-01-934",
      "t": "Purple-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        60,
        75,
        53
      ],
      "id": "TA-01-940F",
      "t": "Transparent Frosted Olivine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        100,
        49,
        25
      ],
      "id": "TA-01-941",
      "t": "Transparent Beach Glass Brown",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        85,
        53,
        35
      ],
      "id": "TA-01-941F",
      "t": "Transparent Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        61,
        70,
        196
      ],
      "id": "TA-01-942F",
      "t": "Transparent Frosted Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        212,
        191,
        131
      ],
      "id": "TA-01-948",
      "t": "White-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        227,
        149,
        29
      ],
      "id": "TA-01-950",
      "t": "Burnt Orange-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        125,
        65,
        12
      ],
      "id": "TA-01-951",
      "t": "Brick Red-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        142,
        70,
        39
      ],
      "id": "TA-01-951FM",
      "t": "Frosted Brick Red-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        52,
        168,
        154
      ],
      "id": "TA-01-954",
      "t": "Lt Jonquil-Lined Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        197,
        122,
        159
      ],
      "id": "TA-01-959",
      "t": "Pink-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        242,
        62,
        63
      ],
      "id": "TA-01-979",
      "t": "Luminous Neon Pink-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        224,
        225,
        222
      ],
      "id": "TA-01-981",
      "t": "Snow-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        139,
        120,
        88
      ],
      "id": "TA-01-989",
      "t": "Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        119,
        97,
        68
      ],
      "id": "TA-01-989FM",
      "t": "Frosted Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        98,
        123,
        121
      ],
      "id": "TA-01-990",
      "t": "Gold-Lined Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        161,
        140,
        62
      ],
      "id": "TA-01-991",
      "t": "Gold-Lined Olivine Chrysolite",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        115,
        107,
        94
      ],
      "id": "TA-01-992",
      "t": "Gold-Lined Lt Montana Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        151,
        136,
        116
      ],
      "id": "TA-01-993",
      "t": "Gold-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        144,
        127,
        97
      ],
      "id": "TA-01-994",
      "t": "Gold-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        96,
        110,
        94
      ],
      "id": "TA-01-995FM",
      "t": "Frosted Gold-Lined Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        137,
        117,
        43
      ],
      "id": "TA-01-996FM",
      "t": "Frosted Gold-Lined Clover Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        111,
        100,
        95
      ],
      "id": "TA-01-997",
      "t": "Gold-Lined Lt Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        123,
        114,
        92
      ],
      "id": "TA-01-999",
      "t": "Gold-Lined Black Diamond Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        150,
        154,
        157
      ],
      "id": "TA-01-1000",
      "t": "Silver-Lined Light Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        150,
        141,
        97
      ],
      "id": "TA-01-1003",
      "t": "Gold-Lined Luster Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        131,
        114,
        70
      ],
      "id": "TA-01-1004",
      "t": "Gold-Lined Champagne",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        147,
        143,
        144
      ],
      "id": "TA-01-1009",
      "t": "Silver-Lined Luster Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        138,
        129,
        128
      ],
      "id": "TA-01-1010",
      "t": "Silver-Lined Luster Med Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        144,
        123,
        104
      ],
      "id": "TA-01-1011",
      "t": "Antique Copper-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        128,
        107,
        82
      ],
      "id": "TA-01-1012",
      "t": "Antique Copper-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        221,
        222,
        218
      ],
      "id": "TA-01-1030",
      "t": "White-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        230,
        130,
        134
      ],
      "id": "TA-01-1035",
      "t": "Cotton Candy-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        191,
        95,
        140
      ],
      "id": "TA-01-1036",
      "t": "Hot Pink-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        161,
        54,
        33
      ],
      "id": "TA-01-1040",
      "t": "Orange-Lined Lime",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        160,
        132,
        115
      ],
      "id": "TA-01-1042",
      "t": "Orange-Lined Lt Peridot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        100,
        93,
        67
      ],
      "id": "TA-01-1043",
      "t": "Brick-Lined Lt Peridot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        133,
        127,
        90
      ],
      "id": "TA-01-1044",
      "t": "Oxblood-Lined Lt Peridot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        153,
        136,
        86
      ],
      "id": "TA-01-1046",
      "t": "Orange-Lined Peridot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        84,
        114,
        127
      ],
      "id": "TA-01-1054",
      "t": "Gray-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        85,
        135,
        183
      ],
      "id": "TA-01-1055",
      "t": "Cornflower-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        84,
        98,
        146
      ],
      "id": "TA-01-1057",
      "t": "Dk Blue-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        121,
        110,
        149
      ],
      "id": "TA-01-1058",
      "t": "Lavender-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        159,
        120,
        159
      ],
      "id": "TA-01-1060",
      "t": "Purple-Lined Crystal",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        127,
        107,
        130
      ],
      "id": "TA-01-1063",
      "t": "Fuchsia-Lined Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        231,
        232,
        229
      ],
      "id": "TA-01-1141",
      "t": "Translucent Alabaster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        149,
        169,
        214
      ],
      "id": "TA-01-1146",
      "t": "Translucent Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        199,
        194,
        186
      ],
      "id": "TA-01-1160",
      "t": "Chrome Silver Palladium Plate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        178,
        175,
        160
      ],
      "id": "TA-01-1160F",
      "t": "Frosted Silver Palladium Plate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        127,
        116,
        119
      ],
      "id": "TA-01-1203",
      "t": "Marbled Light Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        150,
        158,
        179
      ],
      "id": "TA-01-1205",
      "t": "Marbled Blue-Tone White",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        94,
        121,
        138
      ],
      "id": "TA-01-1206",
      "t": "Marbled Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        86,
        111,
        111
      ],
      "id": "TA-01-1207",
      "t": "Marbled Dark Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        99,
        114,
        119
      ],
      "id": "TA-01-1208",
      "t": "Marbled Chinese Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        144,
        118,
        127
      ],
      "id": "TA-01-1251",
      "t": "Translucent Dusty Rose Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        219,
        220,
        217
      ],
      "id": "TA-01-1301",
      "t": "Fiber-Optic Icicle",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        194,
        165,
        157
      ],
      "id": "TA-01-1312",
      "t": "Fiber-Optic French Rose",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        205,
        138,
        165
      ],
      "id": "TA-01-1315",
      "t": "Fiber-Optic Tea Rose",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        218,
        217,
        166
      ],
      "id": "TA-01-1318",
      "t": "Fiber-Optic Ivory",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        155,
        211,
        177
      ],
      "id": "TA-01-1320",
      "t": "Fiber-Optic Amazonite",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        155,
        213,
        217
      ],
      "id": "TA-01-1321",
      "t": "Fiber-Optic Powder Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        186,
        141,
        63
      ],
      "id": "TA-01-1502",
      "t": "Fiber-Optic Chai Tea",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        232,
        211,
        200
      ],
      "id": "TA-01-1503",
      "t": "Fiber-Optic Powder Pink",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        166,
        157,
        183
      ],
      "id": "TA-01-1505",
      "t": "Fiber-Optic Lt Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        194,
        216,
        105
      ],
      "id": "TA-01-1507",
      "t": "Fiber-Optic Serpentine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        149,
        193,
        112
      ],
      "id": "TA-01-1510",
      "t": "Fiber-Optic Spring Leaf",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        92,
        163,
        68
      ],
      "id": "TA-01-1512",
      "t": "Fiber-Optic Peridot",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        99,
        137,
        66
      ],
      "id": "TA-01-1515",
      "t": "Fiber-Optic Lawn Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        102,
        134,
        77
      ],
      "id": "TA-01-1516",
      "t": "Fiber-Optic Jade",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        41,
        161,
        111
      ],
      "id": "TA-01-1519",
      "t": "Fiber-Optic Jungle Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        19,
        131,
        134
      ],
      "id": "TA-01-1523",
      "t": "Fiber-Optic Marine Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        65,
        156,
        219
      ],
      "id": "TA-01-1526",
      "t": "Fiber-Optic Ultramarine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        73,
        75,
        207
      ],
      "id": "TA-01-1530",
      "t": "Fiber-Optic Sapphire",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        175,
        178,
        181
      ],
      "id": "TA-01-1531",
      "t": "Fiber-Optic Rain Cloud",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        145,
        150,
        158
      ],
      "id": "TA-01-1533",
      "t": "Fiber-Optic Smoke",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        91,
        95,
        99
      ],
      "id": "TA-01-1534",
      "t": "Fiber-Optic Shadow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        164,
        165,
        183
      ],
      "id": "TA-01-1556",
      "t": "Fiber-Optic Iridescent Med Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        67,
        66,
        172
      ],
      "id": "TA-01-1580",
      "t": "Fiber-Optic Iridescent Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        218,
        168,
        177
      ],
      "id": "TA-01-1601",
      "t": "Opaque Carnation Pink Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        204,
        156,
        132
      ],
      "id": "TA-01-1602",
      "t": "Opaque Peachy Pink Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        190,
        155,
        31
      ],
      "id": "TA-01-1605F",
      "t": "Opaque Matte Carmel",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        192,
        183,
        2
      ],
      "id": "TA-01-1607",
      "t": "Opaque Butterscotch Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        196,
        188,
        0
      ],
      "id": "TA-01-1607F",
      "t": "Opaque Matte Butterscotch",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        154,
        155,
        2
      ],
      "id": "TA-01-1608",
      "t": "Opaque Carmel Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        164,
        162,
        17
      ],
      "id": "TA-01-1609F",
      "t": "Opaque Matte Ochre",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        96,
        125,
        57
      ],
      "id": "TA-01-1610",
      "t": "Opaque Olive Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        128,
        168,
        160
      ],
      "id": "TA-01-1611",
      "t": "Opaque Lagoon Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        154,
        199,
        200
      ],
      "id": "TA-01-1612F",
      "t": "Opaque Matte Lt Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        137,
        188,
        204
      ],
      "id": "TA-01-1613F",
      "t": "Opaque Matte Lt Blue Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        150,
        174,
        190
      ],
      "id": "TA-01-1614F",
      "t": "Opaque Matte Prairie Sky",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        98,
        139,
        157
      ],
      "id": "TA-01-1615",
      "t": "Opaque Lorimar Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        144,
        168,
        193
      ],
      "id": "TA-01-1616",
      "t": "Opaque Morning Glory Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        140,
        159,
        182
      ],
      "id": "TA-01-1616F",
      "t": "Opaque Matte Morning Glory",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        133,
        159,
        189
      ],
      "id": "TA-01-1617F",
      "t": "Opaque Matte Sky Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        165,
        176,
        190
      ],
      "id": "TA-01-1618F",
      "t": "Opaque Matte French Lavender",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        150,
        148,
        177
      ],
      "id": "TA-01-1622",
      "t": "Opaque French Lilac Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        152,
        117,
        18
      ],
      "id": "TA-01-1623F",
      "t": "Opaque Matte Yellow-Gold Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        151,
        144,
        10
      ],
      "id": "TA-01-1624F",
      "t": "Opaque Matte Khaki Gold Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        113,
        67,
        58
      ],
      "id": "TA-01-1625F",
      "t": "Opaque Matte Beet Red",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        126,
        119,
        81
      ],
      "id": "TA-01-1627F",
      "t": "Opaque Matte Khaki Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        109,
        85,
        90
      ],
      "id": "TA-01-1629",
      "t": "Opaque Olive-Amethyst Luster Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        118,
        100,
        141
      ],
      "id": "TA-01-1631",
      "t": "Opaque Purple Amethyst Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        176,
        134,
        150
      ],
      "id": "TA-01-1632F",
      "t": "Opaque Matte Gold Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        134,
        119,
        119
      ],
      "id": "TA-01-1634F",
      "t": "Opaque Matte Sugar Plum Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        171,
        143,
        134
      ],
      "id": "TA-01-1700",
      "t": "Gilded Marble White",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        152,
        125,
        121
      ],
      "id": "TA-01-1701",
      "t": "Gilded Marble Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        100,
        91,
        47
      ],
      "id": "TA-01-1702",
      "t": "Gilded Marble Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        137,
        122,
        95
      ],
      "id": "TA-01-1703",
      "t": "Gilded Marble Turquoise",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        141,
        112,
        105
      ],
      "id": "TA-01-1704",
      "t": "Gilded Marble Lavender",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        101,
        77,
        49
      ],
      "id": "TA-01-1705",
      "t": "Gilded Marble Brown",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        124,
        127,
        140
      ],
      "id": "TA-01-1800",
      "t": "Silver-Lined Med Gray Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        138,
        124,
        112
      ],
      "id": "TA-01-1807",
      "t": "Silver-Lined Gray Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        128,
        99,
        92
      ],
      "id": "TA-01-1809",
      "t": "Copper-Lined Lt Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        192,
        154,
        112
      ],
      "id": "TA-01-1810",
      "t": "Antique Copper-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        167,
        160,
        53
      ],
      "id": "TA-01-1811",
      "t": "Silver-Lined Citrus Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        98,
        97,
        106
      ],
      "id": "TA-01-1820",
      "t": "Gray Line Gray Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        143,
        87,
        71
      ],
      "id": "TA-01-1825",
      "t": "Purple-Lined Hyacinth Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        237,
        144,
        48
      ],
      "id": "TA-01-1827",
      "t": "Orange-Lined Jonquil Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        101,
        176,
        114
      ],
      "id": "TA-01-1830",
      "t": "Clover-Lined Lt Jonquil Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        99,
        163,
        149
      ],
      "id": "TA-01-1832",
      "t": "Mint Julep-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        54,
        121,
        110
      ],
      "id": "TA-01-1833",
      "t": "Teal-Lined Lt Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        73,
        149,
        169
      ],
      "id": "TA-01-1834",
      "t": "Turquoise-Lined Lt Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        68,
        119,
        157
      ],
      "id": "TA-01-1836",
      "t": "Denim Blue-Lined Lt Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        93,
        113,
        162
      ],
      "id": "TA-01-1837",
      "t": "Enchanted Purple-Lined Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        138,
        117,
        194
      ],
      "id": "TA-01-1838",
      "t": "Violet-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        161,
        112,
        166
      ],
      "id": "TA-01-1839",
      "t": "Pink-Lined Alexandrite Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        150,
        115,
        141
      ],
      "id": "TA-01-1840",
      "t": "Pansy-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        219,
        119,
        124
      ],
      "id": "TA-01-1841",
      "t": "Pink-Lined Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        203,
        194,
        168
      ],
      "id": "TA-01-1900",
      "t": "Polar Pearl Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        208,
        205,
        182
      ],
      "id": "TA-01-1905",
      "t": "Vanilla Pearl Luster",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        205,
        202,
        187
      ],
      "id": "TA-01-2100",
      "t": "Translucent Silver-Lined White",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        204,
        201,
        186
      ],
      "id": "TA-01-PF2100",
      "t": "PermaFinish Translucent Silver-Lined White",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        182,
        177,
        163
      ],
      "id": "TA-01-PF2101",
      "t": "PermaFinish Translucent Silver-Lined Cloud",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        89,
        112,
        138
      ],
      "id": "TA-01-2102",
      "t": "Translucent Silver-Lined Montana Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        211,
        159,
        168
      ],
      "id": "TA-01-PF2105",
      "t": "PermaFinish Translucent Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        216,
        128,
        119
      ],
      "id": "TA-01-PF2106",
      "t": "PermaFinish Translucent Silver-Lined Mauve",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        178,
        68,
        130
      ],
      "id": "TA-01-2107",
      "t": "Translucent Silver-Lined Hot Pink",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        207,
        87,
        135
      ],
      "id": "TA-01-PF2107",
      "t": "PermaFinish Translucent Silver-Lined Hot Pink",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        139,
        97,
        144
      ],
      "id": "TA-01-2108",
      "t": "Translucent Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        195,
        161,
        89
      ],
      "id": "TA-01-2110",
      "t": "Translucent Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        202,
        169,
        83
      ],
      "id": "TA-01-PF2110",
      "t": "PermaFinish Translucent Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        213,
        145,
        111
      ],
      "id": "TA-01-2111",
      "t": "Translucent Silver-Lined Peach",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        217,
        160,
        117
      ],
      "id": "TA-01-PF2111",
      "t": "PermaFinish Translucent Silver-Lined Peach",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        149,
        76,
        61
      ],
      "id": "TA-01-PF2113",
      "t": "PermaFinish Translucent Silver-Lined Pomegranate",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        101,
        79,
        85
      ],
      "id": "TA-01-2114",
      "t": "Translucent Silver-Lined Nutmeg",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        120,
        91,
        80
      ],
      "id": "TA-01-PF2114",
      "t": "PermaFinish Translucent Silver-Lined Nutmeg",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        120,
        111,
        108
      ],
      "id": "TA-01-PF2115",
      "t": "PermaFinish Translucent Silver-Lined Gray",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        179,
        203,
        186
      ],
      "id": "TA-01-PF2116",
      "t": "PermaFinish Translucent Silver-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        116,
        120,
        175
      ],
      "id": "TA-01-PF2123",
      "t": "PermaFinish Translucent Silver-Lined Indigo",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        84,
        73,
        97
      ],
      "id": "TA-01-PF2124",
      "t": "PermaFinish Translucent Silver-Lined Tanzanite",
      "dt": ""
    },
    {
      "a": 11,
      "b": 4,
      "c": [
        73,
        49,
        7
      ],
      "id": "TA-01-2152",
      "t": "Transparent Sarsaparilla",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        102,
        55,
        23
      ],
      "id": "TA-01-2154S",
      "t": "Transparent Silver-Lined Marmalade",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        144,
        109,
        37
      ],
      "id": "TA-01-2156S",
      "t": "Transparent Silver-Lined Honey",
      "dt": ""
    },
    {
      "a": 11,
      "b": 6,
      "c": [
        44,
        69,
        135
      ],
      "id": "TA-01-2203",
      "t": "Transparent Silver-Lined Capri Blue",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        82,
        47,
        51
      ],
      "id": "TA-01-2204",
      "t": "Matte Silver-Lined Olivine",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        165,
        192,
        190
      ],
      "id": "TA-01-2243",
      "t": "Transparent Silver-Lined Avalanche",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        134,
        186,
        136
      ],
      "id": "TA-01-2244",
      "t": "Transparent Silver-Lined Mint Green",
      "dt": ""
    },
    {
      "a": 11,
      "b": 5,
      "c": [
        183,
        153,
        143
      ],
      "id": "TA-01-2251",
      "t": "Transparent Silver-Lined Milky Rose",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        222,
        222,
        220
      ],
      "id": "TR-06-1",
      "t": "Transparent Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        240,
        241,
        236
      ],
      "id": "TR-06-1F",
      "t": "Transparent-Frosted Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        228,
        164,
        35
      ],
      "id": "TR-06-2",
      "t": "Transparent Lt Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        141,
        79,
        25
      ],
      "id": "TR-06-2C",
      "t": "Transparent Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        159,
        13,
        12
      ],
      "id": "TR-06-5B",
      "t": "Transparent Siam Ruby",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        187,
        45,
        49
      ],
      "id": "TR-06-5BF",
      "t": "Transparent-Frosted Siam Ruby",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        61,
        25,
        28
      ],
      "id": "TR-06-5D",
      "t": "Transparent Garnet",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        123,
        88,
        96
      ],
      "id": "TR-06-6B",
      "t": "Transparent Med Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        122,
        83,
        99
      ],
      "id": "TR-06-6BF",
      "t": "Transparent-Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        25,
        102,
        45
      ],
      "id": "TR-06-7B",
      "t": "Transparent Grass Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        53,
        106,
        112
      ],
      "id": "TR-06-7BD",
      "t": "Transparent Capri Blue",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        20,
        102,
        105
      ],
      "id": "TR-06-7BDF",
      "t": "Transparent Frosted Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        77,
        67,
        185
      ],
      "id": "TR-06-8",
      "t": "Transparent Cobalt",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        229,
        144,
        105
      ],
      "id": "TR-06-11",
      "t": "Transparent Rosaline",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        237,
        157,
        128
      ],
      "id": "TR-06-11F",
      "t": "Transparent-Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        213,
        183,
        2
      ],
      "id": "TR-06-12",
      "t": "Transparent Lemon",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        171,
        198,
        98
      ],
      "id": "TR-06-15",
      "t": "Transparent Citrus Spritz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        74,
        63,
        78
      ],
      "id": "TR-06-19",
      "t": "Transparent Sugar Plum",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        96,
        78,
        123
      ],
      "id": "TR-06-19F",
      "t": "Transparent-Frosted Sugar Plum",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        223,
        220,
        212
      ],
      "id": "TR-06-21",
      "t": "Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        225,
        218,
        203
      ],
      "id": "TR-06-21F",
      "t": "Silver-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        208,
        202,
        185
      ],
      "id": "TR-06-PF21",
      "t": "PermaFinish - Silver-Lined Transparent Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        217,
        179,
        74
      ],
      "id": "TR-06-22",
      "t": "Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        204,
        168,
        85
      ],
      "id": "TR-06-22F",
      "t": "Silver-Lined Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        225,
        172,
        67
      ],
      "id": "TR-06-22B",
      "t": "Silver-Lined Med Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        211,
        169,
        58
      ],
      "id": "TR-06-PF22",
      "t": "PermaFinish - Silver-Lined Transparent Lt Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        82,
        175,
        223
      ],
      "id": "TR-06-23",
      "t": "Silver-Lined Aquamarine",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        46,
        97,
        90
      ],
      "id": "TR-06-23BDA",
      "t": "Silver-Lined Aqua Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        33,
        168,
        121
      ],
      "id": "TR-06-24B",
      "t": "Silver-Lined Dk Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        182,
        37,
        26
      ],
      "id": "TR-06-25B",
      "t": "Silver-Lined Siam Ruby",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        142,
        19,
        20
      ],
      "id": "TR-06-25C",
      "t": "Silver-Lined Ruby",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        153,
        49,
        49
      ],
      "id": "TR-06-25CF",
      "t": "Silver-Lined Frosted Ruby",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        98,
        46,
        42
      ],
      "id": "TR-06-25D",
      "t": "Silver-Lined Garnet",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        175,
        134,
        136
      ],
      "id": "TR-06-26",
      "t": "Silver-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        82,
        77,
        60
      ],
      "id": "TR-06-26C",
      "t": "Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        31,
        119,
        20
      ],
      "id": "TR-06-27",
      "t": "Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        27,
        95,
        103
      ],
      "id": "TR-06-27BD",
      "t": "Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        64,
        54,
        130
      ],
      "id": "TR-06-28",
      "t": "Silver-Lined Cobalt",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        75,
        83,
        68
      ],
      "id": "TR-06-29",
      "t": "Silver-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        85,
        102,
        79
      ],
      "id": "TR-06-29B",
      "t": "Silver-Lined Gray",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        73,
        78,
        71
      ],
      "id": "TR-06-29C",
      "t": "Silver-Lined Dk Gray",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        218,
        116,
        22
      ],
      "id": "TR-06-30B",
      "t": "Silver-Lined Hyacinth",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        229,
        182,
        144
      ],
      "id": "TR-06-31",
      "t": "Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        131,
        85,
        77
      ],
      "id": "TR-06-34",
      "t": "Silver-Lined Smoky Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        41,
        46,
        101
      ],
      "id": "TR-06-35",
      "t": "Silver-Lined Sapphire",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        73,
        110,
        86
      ],
      "id": "TR-06-36",
      "t": "Silver-Lined Green Emerald",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        31,
        46,
        26
      ],
      "id": "TR-06-36F",
      "t": "Silver-Lined Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        66,
        90,
        50
      ],
      "id": "TR-06-37",
      "t": "Silver-Lined Olivine",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        249,
        134,
        166
      ],
      "id": "TR-06-38",
      "t": "Silver-Lined Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        100,
        87,
        97
      ],
      "id": "TR-06-39",
      "t": "Silver-Lined Tanzanite",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        144,
        127,
        136
      ],
      "id": "TR-06-39F",
      "t": "Silver-Lined Frosted Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        230,
        230,
        227
      ],
      "id": "TR-06-41",
      "t": "Opaque White",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        242,
        243,
        239
      ],
      "id": "TR-06-41F",
      "t": "Opaque-Frosted White",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        240,
        172,
        3
      ],
      "id": "TR-06-42B",
      "t": "Opaque Sunshine",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        103,
        198,
        232
      ],
      "id": "TR-06-43",
      "t": "Opaque Blue Turquoise",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        45,
        171,
        241
      ],
      "id": "TR-06-43D",
      "t": "Opaque Cornflower",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        136,
        162,
        66
      ],
      "id": "TR-06-44",
      "t": "Opaque Sour Apple",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        221,
        13,
        18
      ],
      "id": "TR-06-45",
      "t": "Opaque Pepper Red",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        163,
        37,
        30
      ],
      "id": "TR-06-45A",
      "t": "Opaque Cherry",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        72,
        32,
        36
      ],
      "id": "TR-06-46",
      "t": "Opaque Oxblood",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        113,
        54,
        42
      ],
      "id": "TR-06-46F",
      "t": "Opaque-Frosted Oxblood",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        189,
        94,
        50
      ],
      "id": "TR-06-46L",
      "t": "Opaque Terra Cotta",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        161,
        66,
        39
      ],
      "id": "TR-06-46LF",
      "t": "Opaque-Frosted Terra Cotta",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        86,
        177,
        82
      ],
      "id": "TR-06-47",
      "t": "Opaque Mint Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        57,
        56,
        172
      ],
      "id": "TR-06-48",
      "t": "Opaque Navy Blue",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        45,
        47,
        52
      ],
      "id": "TR-06-49",
      "t": "Opaque Jet",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        48,
        48,
        48
      ],
      "id": "TR-06-49F",
      "t": "Opaque-Frosted Jet",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        248,
        64,
        30
      ],
      "id": "TR-06-50",
      "t": "Opaque Sunset Orange",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        235,
        222,
        194
      ],
      "id": "TR-06-51",
      "t": "Opaque Lt Beige",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        157,
        121,
        131
      ],
      "id": "TR-06-52",
      "t": "Opaque Lavender",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        57,
        192,
        182
      ],
      "id": "TR-06-55",
      "t": "Opaque Turquoise",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        126,
        202,
        204
      ],
      "id": "TR-06-55F",
      "t": "Opaque Frosted Turquoise",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        156,
        166,
        189
      ],
      "id": "TR-06-81",
      "t": "Metallic Hematite",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        32,
        60,
        85
      ],
      "id": "TR-06-82",
      "t": "Metallic Nebula",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        114,
        106,
        81
      ],
      "id": "TR-06-83",
      "t": "Metallic Iris - Brown",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        121,
        147,
        108
      ],
      "id": "TR-06-84",
      "t": "Metallic Iris - Green/Brown",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        39,
        21,
        26
      ],
      "id": "TR-06-85",
      "t": "Metallic Iris - Purple",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        95,
        106,
        128
      ],
      "id": "TR-06-86",
      "t": "Metallic Rainbow Iris",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        37,
        24,
        134
      ],
      "id": "TR-06-87",
      "t": "Transparent-Rainbow Cobalt",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        42,
        62,
        96
      ],
      "id": "TR-06-88",
      "t": "Metallic Cosmos",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        40,
        70,
        71
      ],
      "id": "TR-06-89",
      "t": "Metallic Moss",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        61,
        51,
        62
      ],
      "id": "TR-06-90",
      "t": "Metallic Amethyst Gun Metal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        71,
        99,
        116
      ],
      "id": "TR-06-108BD",
      "t": "Transparent-Lustered Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        117,
        119,
        110
      ],
      "id": "TR-06-120",
      "t": "Transparent-Lustered Smoke",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        216,
        216,
        209
      ],
      "id": "TR-06-121",
      "t": "Opaque-Lustered White",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        238,
        235,
        225
      ],
      "id": "TR-06-122",
      "t": "Opaque-Lustered Navajo White",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        250,
        239,
        216
      ],
      "id": "TR-06-123",
      "t": "Opaque-Lustered Lt Beige",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        105,
        206,
        199
      ],
      "id": "TR-06-132",
      "t": "Opaque-Lustered Turquoise",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        214,
        221,
        211
      ],
      "id": "TR-06-141",
      "t": "Ceylon Snowflake",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        245,
        194,
        205
      ],
      "id": "TR-06-145",
      "t": "Ceylon Innocent Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        253,
        244,
        229
      ],
      "id": "TR-06-147",
      "t": "Ceylon Lt Ivory",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        151,
        164,
        159
      ],
      "id": "TR-06-150",
      "t": "Ceylon Smoke",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        158,
        128,
        145
      ],
      "id": "TR-06-151",
      "t": "Ceylon Grape Mist",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        80,
        191,
        152
      ],
      "id": "TR-06-156",
      "t": "Ceylon Jade",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        232,
        230,
        226
      ],
      "id": "TR-06-161",
      "t": "Transparent-Rainbow Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        239,
        239,
        235
      ],
      "id": "TR-06-161F",
      "t": "Transparent-Rainbow Frosted Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        201,
        152,
        108
      ],
      "id": "TR-06-162C",
      "t": "Transparent-Rainbow Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        219,
        153,
        101
      ],
      "id": "TR-06-162CF",
      "t": "Transparent-Rainbow Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        152,
        188,
        112
      ],
      "id": "TR-06-164",
      "t": "Transparent-Rainbow Lime Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        126,
        152,
        47
      ],
      "id": "TR-06-164F",
      "t": "Transparent-Rainbow Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        158,
        43,
        57
      ],
      "id": "TR-06-165C",
      "t": "Transparent-Rainbow Ruby",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        179,
        137,
        153
      ],
      "id": "TR-06-166",
      "t": "Transparent Rainbow Lt Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        139,
        171,
        176
      ],
      "id": "TR-06-166D",
      "t": "Transparent Rainbow Sugar Plum",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        141,
        130,
        167
      ],
      "id": "TR-06-166DF",
      "t": "Transparent Rainbow Frosted Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        87,
        157,
        166
      ],
      "id": "TR-06-167BD",
      "t": "Transparent-Rainbow Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        74,
        126,
        158
      ],
      "id": "TR-06-167BDF",
      "t": "Transparent-Rainbow Frosted Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        116,
        148,
        226
      ],
      "id": "TR-06-168",
      "t": "Transparent-Rainbow Lt Sapphire",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        229,
        170,
        144
      ],
      "id": "TR-06-169",
      "t": "Transparent-Rainbow Rosaline",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        175,
        220,
        212
      ],
      "id": "TR-06-170",
      "t": "Dyed-Rainbow Alpine",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        202,
        162,
        172
      ],
      "id": "TR-06-171",
      "t": "Dyed-Rainbow Ballerina Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        253,
        194,
        207
      ],
      "id": "TR-06-171D",
      "t": "Transparent-Rainbow Ballerina Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        162,
        173,
        114
      ],
      "id": "TR-06-173",
      "t": "Dyed-Rainbow Lemon Mist",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        240,
        113,
        27
      ],
      "id": "TR-06-174",
      "t": "Transparent-Rainbow Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        135,
        161,
        164
      ],
      "id": "TR-06-176",
      "t": "Transparent-Rainbow Black Diamond",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        150,
        90,
        51
      ],
      "id": "TR-06-177",
      "t": "Transparent-Rainbow Smoky Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        85,
        67,
        75
      ],
      "id": "TR-06-177F",
      "t": "Transparent-Rainbow Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        63,
        59,
        175
      ],
      "id": "TR-06-178",
      "t": "Transparent-Rainbow Sapphire",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        108,
        124,
        176
      ],
      "id": "TR-06-181",
      "t": "Inside-Color Rainbow Crystal/Tanzanite-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        162,
        155,
        160
      ],
      "id": "TR-06-206",
      "t": "Gold-Lustered Hydrangea",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        117,
        74,
        37
      ],
      "id": "TR-06-221",
      "t": "Bronze",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        128,
        90,
        56
      ],
      "id": "TR-06-221F",
      "t": "Frosted Bronze",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        135,
        79,
        63
      ],
      "id": "TR-06-222",
      "t": "Dk Bronze",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        111,
        76,
        41
      ],
      "id": "TR-06-223",
      "t": "Antique Bronze",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        118,
        114,
        67
      ],
      "id": "TR-06-225",
      "t": "Bronze Antique Gold",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        89,
        114,
        74
      ],
      "id": "TR-06-242F",
      "t": "Inside-Color Frosted Jonquil/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        88,
        92,
        36
      ],
      "id": "TR-06-246",
      "t": "Inside-Color Luster Black Diamond/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        109,
        120,
        193
      ],
      "id": "TR-06-252",
      "t": "Inside-Color Aqua/Purple-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        74,
        75,
        139
      ],
      "id": "TR-06-252F",
      "t": "Inside-Color Frosted Aqua/Purple-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        181,
        168,
        129
      ],
      "id": "TR-06-262",
      "t": "Inside-Color Crystal/Gold-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        97,
        162,
        186
      ],
      "id": "TR-06-263",
      "t": "Inside-Color Rainbow Crystal/Lt Capri-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        129,
        124,
        170
      ],
      "id": "TR-06-265",
      "t": "Inside-Color Rainbow Crystal/Metallic Purple-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        156,
        118,
        122
      ],
      "id": "TR-06-267",
      "t": "Inside-Color Crystal/Rose Gold-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        74,
        161,
        177
      ],
      "id": "TR-06-274",
      "t": "Inside-Color Rainbow Crystal/Green Teal-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        185,
        146,
        109
      ],
      "id": "TR-06-278",
      "t": "Gold-Lined Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        159,
        169,
        164
      ],
      "id": "TR-06-288",
      "t": "Inside-Color Crystal/Metallic Blue-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        193,
        169,
        73
      ],
      "id": "TR-06-302",
      "t": "Inside-Color Jonquil/Apricot-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        166,
        103,
        86
      ],
      "id": "TR-06-303",
      "t": "Inside-Color Jonquil/Hyacinth-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        171,
        108,
        144
      ],
      "id": "TR-06-304",
      "t": "Inside-Color Lt Sapphire/Hyacinth-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        69,
        171,
        71
      ],
      "id": "TR-06-307",
      "t": "Inside-Color Aqua/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        74,
        104,
        119
      ],
      "id": "TR-06-321",
      "t": "Gold-Lustered Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        74,
        109,
        92
      ],
      "id": "TR-06-322",
      "t": "Gold-Lustered Emerald",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        152,
        64,
        47
      ],
      "id": "TR-06-329",
      "t": "Gold-Lustered African Sunset",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        103,
        49,
        81
      ],
      "id": "TR-06-332",
      "t": "Gold-Lustered Raspberry",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        123,
        141,
        81
      ],
      "id": "TR-06-333",
      "t": "Gold-Lustered Fern",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        217,
        99,
        98
      ],
      "id": "TR-06-341",
      "t": "Inside-Color Crystal/Tomato-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        196,
        170,
        170
      ],
      "id": "TR-06-353",
      "t": "Inside-Color Crystal/Lavender-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        204,
        190,
        136
      ],
      "id": "TR-06-369",
      "t": "Inside-Color Black Diamond/Orange Creme-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        188,
        156,
        59
      ],
      "id": "TR-06-375",
      "t": "Inside-Color Topaz/Lt Gray-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        106,
        71,
        30
      ],
      "id": "TR-06-421",
      "t": "Gold-Lustered Transparent Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        130,
        127,
        69
      ],
      "id": "TR-06-422",
      "t": "Gold-Lustered Dk Antique Bronze",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        106,
        116,
        136
      ],
      "id": "TR-06-455",
      "t": "Gold-Lustered Pale Wisteria",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        150,
        144,
        108
      ],
      "id": "TR-06-457",
      "t": "Gold-Lustered Green Tea",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        117,
        88,
        56
      ],
      "id": "TR-06-459",
      "t": "Gold-Lustered Dk Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        142,
        99,
        168
      ],
      "id": "TR-06-461",
      "t": "Higher-Metallic Grape",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        89,
        63,
        64
      ],
      "id": "TR-06-502",
      "t": "Higher-Metallic Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        21,
        62,
        78
      ],
      "id": "TR-06-505",
      "t": "Higher-Metallic Dragonfly",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        123,
        185,
        150
      ],
      "id": "TR-06-507",
      "t": "Higher-Metallic Iris - Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        199,
        136,
        97
      ],
      "id": "TR-06-PF551F",
      "t": "PermaFinish - Galvanized Matte Rose Gold",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        214,
        161,
        102
      ],
      "id": "TR-06-PF551",
      "t": "PermaFinish - Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        195,
        146,
        133
      ],
      "id": "TR-06-PF552F",
      "t": "PermaFinish - Matte Galvanized Peach Coral",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        224,
        187,
        189
      ],
      "id": "TR-06-PF552",
      "t": "PermaFinish - Galvanized Sweet Blush",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        201,
        113,
        128
      ],
      "id": "TR-06-PF553F",
      "t": "PermaFinish - Galvanized Matte Vintage Rose",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        236,
        169,
        196
      ],
      "id": "TR-06-PF553",
      "t": "PermaFinish - Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        170,
        125,
        135
      ],
      "id": "TR-06-PF554F",
      "t": "PermaFinish - Galvanized Matte Lavender",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        184,
        142,
        156
      ],
      "id": "TR-06-PF554",
      "t": "PermaFinish - Galvanized Lilac",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        138,
        104,
        89
      ],
      "id": "TR-06-PF556F",
      "t": "PermaFinish - Galvanized Matte Mocha Frost",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        199,
        180,
        84
      ],
      "id": "TR-06-557",
      "t": "Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        217,
        177,
        92
      ],
      "id": "TR-06-PF557F",
      "t": "PermaFinish - Matte Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        224,
        186,
        93
      ],
      "id": "TR-06-PF557",
      "t": "PermaFinish - Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        198,
        202,
        167
      ],
      "id": "TR-06-558",
      "t": "Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        226,
        207,
        173
      ],
      "id": "TR-06-PF558F",
      "t": "PermaFinish - Matte Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        223,
        214,
        182
      ],
      "id": "TR-06-PF558",
      "t": "PermaFinish - Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        216,
        203,
        128
      ],
      "id": "TR-06-PF559F",
      "t": "PermaFinish - Galvanized Matte Yellow Gold",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        204,
        186,
        95
      ],
      "id": "TR-06-PF559",
      "t": "PermaFinish - Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        140,
        178,
        129
      ],
      "id": "TR-06-PF560F",
      "t": "PermaFinish - Galvanized Matte Seafoam",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        147,
        185,
        129
      ],
      "id": "TR-06-PF560",
      "t": "PermaFinish - Galvanized Sea Foam",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        77,
        159,
        132
      ],
      "id": "TR-06-PF561F",
      "t": "PermaFinish - Galvanized Matte Lt Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        92,
        177,
        149
      ],
      "id": "TR-06-PF561",
      "t": "PermaFinish - Galvanized Green Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        193,
        87,
        59
      ],
      "id": "TR-06-PF562F",
      "t": "PermaFinish - Galvanized Matte Saffron",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        210,
        77,
        40
      ],
      "id": "TR-06-PF562",
      "t": "PermaFinish - Galvanized Saffron",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        193,
        48,
        95
      ],
      "id": "TR-06-PF563F",
      "t": "PermaFinish - Galvanized Matte Orchid",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        220,
        45,
        117
      ],
      "id": "TR-06-PF563",
      "t": "PermaFinish - Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        164,
        74,
        64
      ],
      "id": "TR-06-PF564F",
      "t": "PermaFinish - Galvanized Matte Burgundy Frost",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        111,
        117,
        123
      ],
      "id": "TR-06-PF565F",
      "t": "PermaFinish - Galvanized Matte Blue Slate",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        107,
        118,
        111
      ],
      "id": "TR-06-PF565",
      "t": "PermaFinish - Galvanized Blue Slate",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        117,
        97,
        144
      ],
      "id": "TR-06-PF567F",
      "t": "PermaFinish - Metallic Matte Polaris",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        114,
        91,
        146
      ],
      "id": "TR-06-PF567",
      "t": "PermaFinish - Metallic Polaris",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        133,
        115,
        131
      ],
      "id": "TR-06-PF568F",
      "t": "PermaFinish - Metallic Matte Pink Pewter",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        147,
        124,
        138
      ],
      "id": "TR-06-PF568",
      "t": "PermaFinish - Metallic Pink Pewter",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        103,
        208,
        225
      ],
      "id": "TR-06-PF569F",
      "t": "PermaFinish - Frosted Galvanized Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        5,
        181,
        165
      ],
      "id": "TR-06-PF569",
      "t": "PermaFinish - Galvanized Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        120,
        180,
        126
      ],
      "id": "TR-06-PF570F",
      "t": "PermaFinish - Galvanized Matte Mint Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        102,
        165,
        104
      ],
      "id": "TR-06-PF570",
      "t": "PermaFinish - Galvanized Mint Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        86,
        93,
        101
      ],
      "id": "TR-06-611",
      "t": "Matte-Color Opaque Gray",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        165,
        162,
        139
      ],
      "id": "TR-06-613",
      "t": "Matte-Color Iris - Gray",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        158,
        136,
        115
      ],
      "id": "TR-06-614",
      "t": "Matte-Color Iris - Brown",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        88,
        93,
        131
      ],
      "id": "TR-06-615",
      "t": "Matte-Color Iris - Purple",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        124,
        127,
        70
      ],
      "id": "TR-06-617",
      "t": "Matte-Color Dk Olive",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        147,
        115,
        74
      ],
      "id": "TR-06-702",
      "t": "Matte-Color Dk Copper",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        166,
        97,
        109
      ],
      "id": "TR-06-703",
      "t": "Matte-Color Mauve Mocha",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        133,
        100,
        135
      ],
      "id": "TR-06-704",
      "t": "Matte-Color Andromeda",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        89,
        128,
        153
      ],
      "id": "TR-06-705",
      "t": "Matte-Color Iris - Blue",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        152,
        146,
        138
      ],
      "id": "TR-06-711",
      "t": "Nickel",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        147,
        142,
        105
      ],
      "id": "TR-06-721",
      "t": "Galvanized Blue Gold",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        226,
        239,
        232
      ],
      "id": "TR-06-761",
      "t": "Matte-Color Opaque-Rainbow White",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        179,
        116,
        125
      ],
      "id": "TR-06-771",
      "t": "Inside-Color Rainbow Crystal/Strawberry-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        199,
        127,
        113
      ],
      "id": "TR-06-784",
      "t": "Inside-Color Rainbow Crystal/Sandstone-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        205,
        85,
        185
      ],
      "id": "TR-06-790",
      "t": "Inside-Color Crystal/Opaque Fuchsia-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        251,
        180,
        79
      ],
      "id": "TR-06-801",
      "t": "Luminous Neon Tangerine",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        250,
        133,
        86
      ],
      "id": "TR-06-802",
      "t": "Luminous Neon Orange",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        251,
        131,
        132
      ],
      "id": "TR-06-803",
      "t": "Luminous Neon Salmon",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        119,
        229,
        153
      ],
      "id": "TR-06-805",
      "t": "Luminous Neon Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        252,
        217,
        221
      ],
      "id": "TR-06-811",
      "t": "Opaque-Pastel Peach Blossom",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        253,
        181,
        206
      ],
      "id": "TR-06-910",
      "t": "Ceylon Hot Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        165,
        168,
        203
      ],
      "id": "TR-06-922",
      "t": "Ceylon Gladiola",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        145,
        114,
        174
      ],
      "id": "TR-06-928",
      "t": "Inside-Color Rainbow Rosaline/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        85,
        139,
        177
      ],
      "id": "TR-06-931",
      "t": "Inside-Color Aqua/White-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        46,
        119,
        189
      ],
      "id": "TR-06-932",
      "t": "Inside-Color Aqua/Capri-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        168,
        188,
        229
      ],
      "id": "TR-06-933",
      "t": "Inside-Color Lt Sapphire/White-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        111,
        115,
        215
      ],
      "id": "TR-06-934",
      "t": "Inside-Color Lt Sapphire/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        211,
        151,
        230
      ],
      "id": "TR-06-937",
      "t": "Inside-Color Aqua/Bubble Gum Pink-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        33,
        52,
        37
      ],
      "id": "TR-06-939",
      "t": "Transparent Green Emerald",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        52,
        83,
        66
      ],
      "id": "TR-06-939F",
      "t": "Transparent-Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        67,
        87,
        56
      ],
      "id": "TR-06-940",
      "t": "Transparent Olivine",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        80,
        98,
        61
      ],
      "id": "TR-06-940F",
      "t": "Transparent-Frosted Olivine",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        78,
        69,
        186
      ],
      "id": "TR-06-942",
      "t": "Transparent Sapphire",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        206,
        168,
        221
      ],
      "id": "TR-06-943",
      "t": "Inside-Color Crystal/Lilac-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        156,
        196,
        123
      ],
      "id": "TR-06-945",
      "t": "Inside-Color Jonquil/Mint Julep-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        242,
        159,
        70
      ],
      "id": "TR-06-950",
      "t": "Inside-Color Jonquil/Burnt Orange-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        140,
        169,
        144
      ],
      "id": "TR-06-952",
      "t": "Inside-Color Rainbow Lt Topaz/Sea Foam-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        54,
        206,
        198
      ],
      "id": "TR-06-954",
      "t": "Inside-Color Aqua/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        191,
        147,
        154
      ],
      "id": "TR-06-960",
      "t": "Inside-Color Lt Topaz/Pink-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        250,
        125,
        166
      ],
      "id": "TR-06-978",
      "t": "Luminous Neon Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        194,
        186,
        147
      ],
      "id": "TR-06-989",
      "t": "Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        154,
        130,
        101
      ],
      "id": "TR-06-989F",
      "t": "Gold-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        168,
        193,
        191
      ],
      "id": "TR-06-990",
      "t": "Gold-Lined Aqua",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        175,
        170,
        165
      ],
      "id": "TR-06-992",
      "t": "Gold-Lined Lt Montana Blue",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        197,
        183,
        159
      ],
      "id": "TR-06-993",
      "t": "Gold-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        210,
        188,
        175
      ],
      "id": "TR-06-994",
      "t": "Gold-Lined Rainbow Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        142,
        179,
        181
      ],
      "id": "TR-06-995",
      "t": "Gold-Lined Rainbow Aqua",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        167,
        162,
        75
      ],
      "id": "TR-06-996",
      "t": "Gold-Lined Rainbow Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        148,
        159,
        168
      ],
      "id": "TR-06-997",
      "t": "Gold-Lined Rainbow Lt Sapphire",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        191,
        185,
        130
      ],
      "id": "TR-06-998",
      "t": "Gold-Lined Rainbow Lt Jonquil",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        101,
        122,
        114
      ],
      "id": "TR-06-999",
      "t": "Gold-Lined Rainbow Black Diamond",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        95,
        96,
        74
      ],
      "id": "TR-06-999F",
      "t": "Gold-Lined Frosted Black Diamond",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        65,
        53,
        69
      ],
      "id": "TR-06-1076",
      "t": "Inside-Color Gray/Magenta-Lined",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        123,
        84,
        23
      ],
      "id": "TR-06-1708",
      "t": "Gilded Marble Red",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        214,
        226,
        218
      ],
      "id": "TR-06-2100",
      "t": "Silver-Lined Milky White",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        209,
        208,
        201
      ],
      "id": "TR-06-PF2100",
      "t": "PermaFinish - Translucent Silver-Lined White",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        193,
        187,
        184
      ],
      "id": "TR-06-PF2101",
      "t": "PermaFinish - Translucent Silver-Lined Cloud",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        97,
        138,
        175
      ],
      "id": "TR-06-2102",
      "t": "Silver-Lined Milky Montana Blue",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        110,
        123,
        146
      ],
      "id": "TR-06-PF2102",
      "t": "PermaFinish - Translucent Silver-Lined Montana Blue",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        121,
        190,
        147
      ],
      "id": "TR-06-PF2103",
      "t": "PermaFinish - Translucent Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        16,
        188,
        155
      ],
      "id": "TR-06-2104",
      "t": "Silver-Lined Milky Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        84,
        213,
        214
      ],
      "id": "TR-06-PF2104",
      "t": "PermaFinish - Translucent Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        220,
        157,
        183
      ],
      "id": "TR-06-PF2105",
      "t": "PermaFinish - Translucent Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        206,
        116,
        159
      ],
      "id": "TR-06-2106",
      "t": "Silver-Lined Milky Mauve",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        217,
        126,
        155
      ],
      "id": "TR-06-PF2106",
      "t": "PermaFinish - Translucent Silver-Lined Mauve",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        204,
        72,
        170
      ],
      "id": "TR-06-2107",
      "t": "Silver-Lined Milky Hot Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        225,
        78,
        161
      ],
      "id": "TR-06-PF2107",
      "t": "PermaFinish - Translucent Silver-Lined Hot Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        160,
        116,
        169
      ],
      "id": "TR-06-2108",
      "t": "Silver-Lined Milky Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        125,
        83,
        118
      ],
      "id": "TR-06-PF2108",
      "t": "PermaFinish - Translucent Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        206,
        196,
        120
      ],
      "id": "TR-06-PF2109",
      "t": "PermaFinish - Translucent Silver-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        201,
        165,
        71
      ],
      "id": "TR-06-2110",
      "t": "Silver-Lined Milky Lt Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        225,
        182,
        115
      ],
      "id": "TR-06-PF2110",
      "t": "PermaFinish - Translucent Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        209,
        146,
        113
      ],
      "id": "TR-06-2111",
      "t": "Silver-Lined Milky Peach",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        228,
        164,
        135
      ],
      "id": "TR-06-PF2111",
      "t": "PermaFinish - Translucent Silver-Lined Peach",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        207,
        102,
        63
      ],
      "id": "TR-06-2112",
      "t": "Silver-Lined Milky Grapefruit",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        215,
        113,
        69
      ],
      "id": "TR-06-PF2112",
      "t": "PermaFinish - Translucent Silver-Lined Grapefruit",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        123,
        36,
        35
      ],
      "id": "TR-06-2113",
      "t": "Silver-Lined Milky Pomegranate",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        135,
        56,
        44
      ],
      "id": "TR-06-PF2113",
      "t": "PermaFinish - Translucent Silver-Lined Pomegranate",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        101,
        74,
        74
      ],
      "id": "TR-06-2114",
      "t": "Silver-Lined Milky Nutmeg",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        133,
        100,
        105
      ],
      "id": "TR-06-PF2114",
      "t": "PermaFinish - Translucent Silver-Lined Nutmeg",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        128,
        123,
        129
      ],
      "id": "TR-06-PF2115",
      "t": "PermaFinish - Translucent Silver-Lined Gray",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        164,
        198,
        192
      ],
      "id": "TR-06-PF2116",
      "t": "PermaFinish - Translucent Silver-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        57,
        180,
        194
      ],
      "id": "TR-06-2117",
      "t": "Silver-Lined Milky Aqua",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        90,
        188,
        198
      ],
      "id": "TR-06-PF2117",
      "t": "PermaFinish - Translucent Silver-Lined Aqua",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        154,
        211,
        172
      ],
      "id": "TR-06-2118",
      "t": "Silver-Lined Milky Lt Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        146,
        190,
        178
      ],
      "id": "TR-06-PF2118",
      "t": "PermaFinish - Translucent Silver-Lined Lt Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        60,
        177,
        148
      ],
      "id": "TR-06-2119",
      "t": "Silver-Lined Milky Dk Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        89,
        172,
        153
      ],
      "id": "TR-06-PF2119",
      "t": "PermaFinish - Translucent Silver-Lined Dk Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        222,
        178,
        188
      ],
      "id": "TR-06-PF2120",
      "t": "PermaFinish - Translucent Silver-Lined Soft Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        207,
        178,
        195
      ],
      "id": "TR-06-PF2121",
      "t": "PermaFinish - Translucent Silver-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        119,
        97,
        127
      ],
      "id": "TR-06-PF2122",
      "t": "PermaFinish - Translucent Silver-Lined Alexandrite",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        130,
        127,
        187
      ],
      "id": "TR-06-PF2123",
      "t": "PermaFinish - Translucent Silver-Lined Indigo",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        102,
        90,
        132
      ],
      "id": "TR-06-PF2124",
      "t": "PermaFinish - Translucent Silver-Lined Tanzanite",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        216,
        212,
        177
      ],
      "id": "TR-06-PF2125",
      "t": "PermaFinish - Translucent Silver-Lined Lt Jonquil",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        215,
        181,
        163
      ],
      "id": "TR-06-PF2126",
      "t": "PermaFinish - Translucent Silver-Lined Peachy Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        128,
        98,
        97
      ],
      "id": "TR-06-2204",
      "t": "Dyed Silver-Lined Pink Frosted Olivine",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        150,
        65,
        35
      ],
      "id": "TR-06-2208",
      "t": "Silver-Lined Burnt Orange",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        164,
        73,
        82
      ],
      "id": "TR-06-2218",
      "t": "Silver-Lined Mauve",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        142,
        70,
        117
      ],
      "id": "TR-06-2219",
      "t": "Silver-Lined Lt Grape",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        64,
        50,
        95
      ],
      "id": "TR-06-2224",
      "t": "Silver-Lined Purple",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        73,
        54,
        44
      ],
      "id": "TR-06-Y304F",
      "t": "HYBRID Frosted Pepper Red - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        112,
        105,
        16
      ],
      "id": "TR-06-Y310",
      "t": "HYBRID Sour Apple - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        145,
        121,
        77
      ],
      "id": "TR-06-Y311F",
      "t": "HYBRID Opaque-Frosted Lavender - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        73,
        65,
        58
      ],
      "id": "TR-06-Y313",
      "t": "HYBRID Transparent Lt Topaz - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        74,
        65,
        51
      ],
      "id": "TR-06-Y313F",
      "t": "HYBRID Transparent Frosted Lt Topaz - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        74,
        76,
        33
      ],
      "id": "TR-06-Y315",
      "t": "HYBRID Transparent Lime Green - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        68,
        64,
        42
      ],
      "id": "TR-06-Y315F",
      "t": "HYBRID Transparent Frosted Lime Green - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        54,
        54,
        52
      ],
      "id": "TR-06-Y316",
      "t": "HYBRID Transparent Siam Ruby - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        64,
        63,
        61
      ],
      "id": "TR-06-Y316F",
      "t": "HYBRID Transparent Frosted Siam Ruby - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        54,
        33,
        24
      ],
      "id": "TR-06-Y317",
      "t": "HYBRID Transparent Lt Amethyst - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        71,
        53,
        42
      ],
      "id": "TR-06-Y317F",
      "t": "HYBRID Transparent Frosted Lt Amethyst - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        79,
        102,
        55
      ],
      "id": "TR-06-Y318F",
      "t": "HYBRID Transparent Frosted Peridot - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        118,
        110,
        35
      ],
      "id": "TR-06-Y319",
      "t": "HYBRID Opaque Dandelion - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        83,
        115,
        41
      ],
      "id": "TR-06-Y321",
      "t": "HYBRID Opaque Mint Green - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        109,
        128,
        74
      ],
      "id": "TR-06-Y321F",
      "t": "HYBRID Opaque-Frosted Mint Green - Picasso",
      "dt": ""
    },
    {
      "a": 7,
      "b": 3,
      "c": [
        246,
        242,
        237
      ],
      "id": "TR-06-Y610",
      "t": "HYBRID Sueded Gold Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        160,
        156,
        109
      ],
      "id": "TR-06-Y615",
      "t": "HYBRID Metallic Suede - Gold",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        136,
        115,
        133
      ],
      "id": "TR-06-Y617",
      "t": "HYBRID Metallic Suede - Pink",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        176,
        194,
        62
      ],
      "id": "TR-06-Y620",
      "t": "HYBRID Sueded Gold Transparent Lime Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        147,
        195,
        93
      ],
      "id": "TR-06-Y624",
      "t": "HYBRID Sueded Gold Opaque Mint Green",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        196,
        65,
        41
      ],
      "id": "TR-06-Y625",
      "t": "HYBRID Sueded Gold Siam Ruby",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        156,
        134,
        133
      ],
      "id": "TR-06-Y628",
      "t": "HYBRID Sueded Gold Transparent Amethyst",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        97,
        145,
        55
      ],
      "id": "TR-06-Y629",
      "t": "HYBRID Sueded Gold Transparent Peridot",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        214,
        219,
        190
      ],
      "id": "TR-06-Y630",
      "t": "HYBRID Sueded Gold Crystal",
      "dt": ""
    },
    {
      "a": 7,
      "b": 1,
      "c": [
        224,
        196,
        80
      ],
      "id": "TR-06-Y631",
      "t": "HYBRID Sueded Gold Lame",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        86,
        100,
        95
      ],
      "id": "TR-06-Y632",
      "t": "HYBRID Sueded Gold Transparent Capri Blue",
      "dt": ""
    },
    {
      "a": 7,
      "b": 2,
      "c": [
        136,
        126,
        97
      ],
      "id": "TR-06-Y864F",
      "t": "HYBRID Frosted Oxidized Bronze Clay",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        189,
        201,
        195
      ],
      "id": "TR-08-1",
      "t": "Transparent Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        229,
        229,
        223
      ],
      "id": "TR-08-1F",
      "t": "Transparent-Frosted Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        210,
        123,
        30
      ],
      "id": "TR-08-2",
      "t": "Transparent Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        204,
        139,
        38
      ],
      "id": "TR-08-2F",
      "t": "Transparent-Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        192,
        97,
        26
      ],
      "id": "TR-08-2C",
      "t": "Transparent Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        199,
        123,
        61
      ],
      "id": "TR-08-2CF",
      "t": "Transparent-Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        30,
        177,
        224
      ],
      "id": "TR-08-3",
      "t": "Transparent Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        14,
        177,
        245
      ],
      "id": "TR-08-3F",
      "t": "Transparent-Frosted Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        14,
        142,
        241
      ],
      "id": "TR-08-3B",
      "t": "Transparent Dk Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        3,
        151,
        253
      ],
      "id": "TR-08-3BF",
      "t": "Transparent-Frosted Med Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        2,
        112,
        252
      ],
      "id": "TR-08-3CF",
      "t": "Transparent-Frosted Dk Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        137,
        179,
        38
      ],
      "id": "TR-08-4",
      "t": "Transparent Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        164,
        199,
        56
      ],
      "id": "TR-08-4F",
      "t": "Transparent-Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        231,
        52,
        35
      ],
      "id": "TR-08-5",
      "t": "Transparent Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        235,
        28,
        29
      ],
      "id": "TR-08-5F",
      "t": "Transparent-Frosted Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        216,
        73,
        73
      ],
      "id": "TR-08-5B",
      "t": "Transparent Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        149,
        37,
        42
      ],
      "id": "TR-08-5BF",
      "t": "Transparent-Frosted Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        167,
        47,
        52
      ],
      "id": "TR-08-5C",
      "t": "Transparent Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        138,
        42,
        47
      ],
      "id": "TR-08-5CF",
      "t": "Transparent-Frosted Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        174,
        139,
        155
      ],
      "id": "TR-08-6",
      "t": "Transparent Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        168,
        120,
        139
      ],
      "id": "TR-08-6F",
      "t": "Transparent-Frosted Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        102,
        64,
        79
      ],
      "id": "TR-08-6B",
      "t": "Transparent Med Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        101,
        62,
        77
      ],
      "id": "TR-08-6BF",
      "t": "Transparent-Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        68,
        53,
        64
      ],
      "id": "TR-08-6C",
      "t": "Transparent Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        77,
        63,
        68
      ],
      "id": "TR-08-6CF",
      "t": "Transparent-Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        18,
        125,
        30
      ],
      "id": "TR-08-7",
      "t": "Transparent Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        28,
        106,
        35
      ],
      "id": "TR-08-7B",
      "t": "Transparent Grass Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        30,
        91,
        101
      ],
      "id": "TR-08-7BD",
      "t": "Transparent Capri Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        12,
        104,
        109
      ],
      "id": "TR-08-7BDF",
      "t": "Transparent Frosted Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        45,
        28,
        98
      ],
      "id": "TR-08-8",
      "t": "Transparent Cobalt",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        56,
        44,
        116
      ],
      "id": "TR-08-8F",
      "t": "Transparent-Frosted Dk Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        53,
        36,
        102
      ],
      "id": "TR-08-8DF",
      "t": "Transparent-Frosted Cobalt",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        81,
        91,
        90
      ],
      "id": "TR-08-9F",
      "t": "Transparent-Frosted Lt Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        96,
        102,
        101
      ],
      "id": "TR-08-9B",
      "t": "Transparent Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        56,
        65,
        62
      ],
      "id": "TR-08-9BF",
      "t": "Transparent-Frosted Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        248,
        139,
        5
      ],
      "id": "TR-08-10",
      "t": "Transparent Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        238,
        44,
        6
      ],
      "id": "TR-08-10B",
      "t": "Transparent Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        238,
        60,
        13
      ],
      "id": "TR-08-10BF",
      "t": "Transparent-Frosted Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        226,
        186,
        177
      ],
      "id": "TR-08-11",
      "t": "Transparent Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        230,
        187,
        182
      ],
      "id": "TR-08-11F",
      "t": "Transparent-Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        242,
        221,
        22
      ],
      "id": "TR-08-12",
      "t": "Transparent Lemon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        231,
        217,
        55
      ],
      "id": "TR-08-12F",
      "t": "Transparent-Frosted Lemon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        93,
        122,
        198
      ],
      "id": "TR-08-13",
      "t": "Transparent Lt Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        107,
        149,
        233
      ],
      "id": "TR-08-13F",
      "t": "Transparent-Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        35,
        23,
        19
      ],
      "id": "TR-08-14",
      "t": "Transparent Root Beer",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        180,
        195,
        134
      ],
      "id": "TR-08-15",
      "t": "Transparent Citrus Spritz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        126,
        161,
        96
      ],
      "id": "TR-08-15F",
      "t": "Transparent-Frosted Citrus Spritz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        62,
        47,
        82
      ],
      "id": "TR-08-19",
      "t": "Transparent Sugar Plum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        127,
        105,
        148
      ],
      "id": "TR-08-19F",
      "t": "Transparent-Frosted Sugar Plum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        217,
        212,
        200
      ],
      "id": "TR-08-21",
      "t": "Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        218,
        211,
        196
      ],
      "id": "TR-08-21F",
      "t": "Silver-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        221,
        218,
        211
      ],
      "id": "TR-08-PF21F",
      "t": "PermaFinish - Silver-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        202,
        202,
        193
      ],
      "id": "TR-08-PF21",
      "t": "PermaFinish - Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        235,
        197,
        96
      ],
      "id": "TR-08-22",
      "t": "Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        216,
        180,
        107
      ],
      "id": "TR-08-22F",
      "t": "Silver-Lined Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        230,
        166,
        51
      ],
      "id": "TR-08-22B",
      "t": "Silver-Lined Med Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        230,
        184,
        91
      ],
      "id": "TR-08-22BF",
      "t": "Silver-Lined Frosted Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        171,
        112,
        57
      ],
      "id": "TR-08-22C",
      "t": "Silver-Lined Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        204,
        129,
        39
      ],
      "id": "TR-08-22CF",
      "t": "Silver-Lined Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        191,
        161,
        67
      ],
      "id": "TR-08-PF22",
      "t": "PermaFinish - Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        99,
        207,
        216
      ],
      "id": "TR-08-23",
      "t": "Silver-Lined Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        98,
        182,
        207
      ],
      "id": "TR-08-23F",
      "t": "Silver-Lined Frosted Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        45,
        169,
        205
      ],
      "id": "TR-08-23B",
      "t": "Silver-Lined Dk Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        49,
        179,
        217
      ],
      "id": "TR-08-23BF",
      "t": "Silver-Lined Frosted Dk Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        31,
        164,
        186
      ],
      "id": "TR-08-23BDA",
      "t": "Silver-Lined Aqua Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        111,
        131,
        8
      ],
      "id": "TR-08-24",
      "t": "Silver-Lined Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        200,
        212,
        82
      ],
      "id": "TR-08-24F",
      "t": "Silver-Lined Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        43,
        162,
        103
      ],
      "id": "TR-08-24B",
      "t": "Silver-Lined Dk Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        99,
        196,
        156
      ],
      "id": "TR-08-24BF",
      "t": "Silver-Lined Frosted Dk Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        220,
        57,
        46
      ],
      "id": "TR-08-25",
      "t": "Silver-Lined Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        197,
        61,
        48
      ],
      "id": "TR-08-25B",
      "t": "Silver-Lined Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        184,
        75,
        66
      ],
      "id": "TR-08-25BF",
      "t": "Silver-Lined Frosted Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        138,
        27,
        34
      ],
      "id": "TR-08-25C",
      "t": "Silver-Lined Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        212,
        59,
        61
      ],
      "id": "TR-08-25CF",
      "t": "Silver-Lined Frosted Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        182,
        143,
        136
      ],
      "id": "TR-08-26",
      "t": "Silver-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        143,
        122,
        121
      ],
      "id": "TR-08-26F",
      "t": "Silver-Lined Frosted Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        138,
        99,
        101
      ],
      "id": "TR-08-26B",
      "t": "Silver-Lined Med Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        91,
        69,
        63
      ],
      "id": "TR-08-26C",
      "t": "Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        139,
        94,
        96
      ],
      "id": "TR-08-26CF",
      "t": "Silver-Lined Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        54,
        154,
        51
      ],
      "id": "TR-08-27",
      "t": "Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        85,
        143,
        59
      ],
      "id": "TR-08-27F",
      "t": "Silver-Lined Frosted Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        49,
        136,
        58
      ],
      "id": "TR-08-27B",
      "t": "Silver-Lined Grass Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        66,
        131,
        125
      ],
      "id": "TR-08-27BD",
      "t": "Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        39,
        59,
        143
      ],
      "id": "TR-08-28",
      "t": "Silver-Lined Cobalt",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        68,
        62,
        129
      ],
      "id": "TR-08-28F",
      "t": "Silver-Lined Frosted Dk Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        65,
        75,
        190
      ],
      "id": "TR-08-28DF",
      "t": "Silver-Lined Frosted Cobalt",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        57,
        68,
        53
      ],
      "id": "TR-08-29",
      "t": "Silver-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        193,
        190,
        176
      ],
      "id": "TR-08-29AF",
      "t": "Silver-Lined Frosted Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        113,
        116,
        109
      ],
      "id": "TR-08-29B",
      "t": "Silver-Lined Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        108,
        107,
        86
      ],
      "id": "TR-08-29BF",
      "t": "Silver-Lined Frosted Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        58,
        59,
        54
      ],
      "id": "TR-08-29C",
      "t": "Silver-Lined Dk Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        182,
        109,
        25
      ],
      "id": "TR-08-30F",
      "t": "Silver-Lined Frosted Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        247,
        77,
        16
      ],
      "id": "TR-08-30B",
      "t": "Silver-Lined Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        236,
        109,
        25
      ],
      "id": "TR-08-30BF",
      "t": "Silver-Lined Frosted Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        225,
        190,
        166
      ],
      "id": "TR-08-31",
      "t": "Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        233,
        193,
        174
      ],
      "id": "TR-08-31F",
      "t": "Silver-Lined Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        148,
        173,
        210
      ],
      "id": "TR-08-33",
      "t": "Silver-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        170,
        183,
        232
      ],
      "id": "TR-08-33F",
      "t": "Silver-Lined Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        154,
        83,
        53
      ],
      "id": "TR-08-34",
      "t": "Silver-Lined Smoky Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        198,
        124,
        43
      ],
      "id": "TR-08-34F",
      "t": "Silver-Lined Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        30,
        38,
        126
      ],
      "id": "TR-08-35",
      "t": "Silver-Lined Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        64,
        141,
        94
      ],
      "id": "TR-08-36",
      "t": "Silver-Lined Green Emerald",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        46,
        140,
        82
      ],
      "id": "TR-08-36F",
      "t": "Silver-Lined Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        91,
        100,
        81
      ],
      "id": "TR-08-37",
      "t": "Silver-Lined Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        111,
        136,
        69
      ],
      "id": "TR-08-37F",
      "t": "Silver-Lined Frosted Olive",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        52,
        71,
        23
      ],
      "id": "TR-08-37A",
      "t": "Silver-Lined Lt Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        242,
        134,
        166
      ],
      "id": "TR-08-38",
      "t": "Silver-Lined Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        137,
        128,
        112
      ],
      "id": "TR-08-39",
      "t": "Silver-Lined Tanzanite",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        174,
        160,
        159
      ],
      "id": "TR-08-39F",
      "t": "Silver-Lined Frosted Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        232,
        232,
        229
      ],
      "id": "TR-08-41",
      "t": "Opaque White",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        239,
        239,
        237
      ],
      "id": "TR-08-41F",
      "t": "Opaque-Frosted White",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        228,
        172,
        4
      ],
      "id": "TR-08-42B",
      "t": "Opaque Sunshine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        213,
        192,
        8
      ],
      "id": "TR-08-42BF",
      "t": "Opaque-Frosted Sunshine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        231,
        107,
        15
      ],
      "id": "TR-08-42D",
      "t": "Opaque Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        248,
        139,
        13
      ],
      "id": "TR-08-42DF",
      "t": "Opaque-Frosted Cantaloupe",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        91,
        207,
        244
      ],
      "id": "TR-08-43",
      "t": "Opaque Blue Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        113,
        218,
        248
      ],
      "id": "TR-08-43F",
      "t": "Opaque-Frosted Blue Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        69,
        145,
        234
      ],
      "id": "TR-08-43D",
      "t": "Opaque Cornflower",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        68,
        160,
        249
      ],
      "id": "TR-08-43DF",
      "t": "Opaque-Frosted Cornflower",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        131,
        158,
        56
      ],
      "id": "TR-08-44",
      "t": "Opaque Sour Apple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        186,
        217,
        116
      ],
      "id": "TR-08-44F",
      "t": "Opaque-Frosted Sour Apple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        201,
        30,
        39
      ],
      "id": "TR-08-45",
      "t": "Opaque Pepper Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        212,
        39,
        36
      ],
      "id": "TR-08-45F",
      "t": "Opaque-Frosted Pepper Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        222,
        31,
        31
      ],
      "id": "TR-08-45A",
      "t": "Opaque Cherry",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        230,
        26,
        30
      ],
      "id": "TR-08-45AF",
      "t": "Opaque-Frosted Cherry",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        94,
        65,
        55
      ],
      "id": "TR-08-46",
      "t": "Opaque Oxblood",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        95,
        54,
        48
      ],
      "id": "TR-08-46F",
      "t": "Opaque-Frosted Oxblood",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        98,
        44,
        24
      ],
      "id": "TR-08-46L",
      "t": "Opaque Terra Cotta",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        194,
        79,
        35
      ],
      "id": "TR-08-46LF",
      "t": "Opaque-Frosted Terra Cotta",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        74,
        197,
        93
      ],
      "id": "TR-08-47",
      "t": "Opaque Mint Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        105,
        156,
        60
      ],
      "id": "TR-08-47F",
      "t": "Opaque-Frosted Mint Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        33,
        175,
        107
      ],
      "id": "TR-08-47D",
      "t": "Opaque Shamrock",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        61,
        141,
        83
      ],
      "id": "TR-08-47DF",
      "t": "Opaque-Frosted Shamrock",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        35,
        73,
        40
      ],
      "id": "TR-08-47HF",
      "t": "Opaque-Frosted Pine Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        60,
        51,
        158
      ],
      "id": "TR-08-48",
      "t": "Opaque Navy Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        63,
        45,
        171
      ],
      "id": "TR-08-48F",
      "t": "Opaque-Frosted Navy Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        77,
        97,
        179
      ],
      "id": "TR-08-48L",
      "t": "Opaque Periwinkle",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        119,
        136,
        229
      ],
      "id": "TR-08-48LF",
      "t": "Opaque-Frosted Periwinkle",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        26,
        27,
        27
      ],
      "id": "TR-08-49",
      "t": "Opaque Jet",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        36,
        37,
        39
      ],
      "id": "TR-08-49F",
      "t": "Opaque-Frosted Jet",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        244,
        72,
        42
      ],
      "id": "TR-08-50",
      "t": "Opaque Sunset Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        238,
        82,
        47
      ],
      "id": "TR-08-50F",
      "t": "Opaque-Frosted Sunset Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        248,
        94,
        1
      ],
      "id": "TR-08-50A",
      "t": "Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        252,
        83,
        52
      ],
      "id": "TR-08-50AF",
      "t": "Opaque-Frosted Pumpkin",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        242,
        234,
        218
      ],
      "id": "TR-08-51",
      "t": "Opaque Lt Beige",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        185,
        150,
        165
      ],
      "id": "TR-08-52",
      "t": "Opaque Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        193,
        170,
        182
      ],
      "id": "TR-08-52F",
      "t": "Opaque-Frosted Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        197,
        201,
        200
      ],
      "id": "TR-08-53",
      "t": "Opaque Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        190,
        195,
        198
      ],
      "id": "TR-08-53F",
      "t": "Opaque-Frosted Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        107,
        113,
        104
      ],
      "id": "TR-08-53D",
      "t": "Opaque Dk Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        83,
        211,
        199
      ],
      "id": "TR-08-55",
      "t": "Opaque Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        60,
        205,
        190
      ],
      "id": "TR-08-55F",
      "t": "Opaque-Frosted Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        57,
        117,
        77
      ],
      "id": "TR-08-72F",
      "t": "Transparent-Frosted Dk Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        124,
        141,
        157
      ],
      "id": "TR-08-81",
      "t": "Metallic Hematite",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        36,
        60,
        97
      ],
      "id": "TR-08-82",
      "t": "Metallic Nebula",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        58,
        69,
        109
      ],
      "id": "TR-08-82F",
      "t": "Frosted Metallic Nebula",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        135,
        117,
        86
      ],
      "id": "TR-08-83",
      "t": "Metallic Iris - Brown",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        107,
        97,
        72
      ],
      "id": "TR-08-83F",
      "t": "Frosted Metallic Iris - Brown",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        77,
        112,
        81
      ],
      "id": "TR-08-84",
      "t": "Metallic Iris - Green/Brown",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        76,
        99,
        89
      ],
      "id": "TR-08-84F",
      "t": "Frosted Metallic Iris - Green/Brown",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        137,
        97,
        108
      ],
      "id": "TR-08-85",
      "t": "Metallic Iris - Purple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        121,
        93,
        88
      ],
      "id": "TR-08-85F",
      "t": "Frosted Metallic Iris - Purple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        106,
        133,
        157
      ],
      "id": "TR-08-86",
      "t": "Metallic Rainbow Iris",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        80,
        81,
        90
      ],
      "id": "TR-08-86F",
      "t": "Opaque-Frosted-Rainbow Iris",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        133,
        126,
        187
      ],
      "id": "TR-08-87F",
      "t": "Transparent-Rainbow Frosted Dk Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        30,
        52,
        65
      ],
      "id": "TR-08-88",
      "t": "Metallic Cosmos",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        133,
        130,
        147
      ],
      "id": "TR-08-90",
      "t": "Metallic Amethyst Gun Metal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        223,
        231,
        224
      ],
      "id": "TR-08-101",
      "t": "Transparent-Lustered Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        219,
        213,
        73
      ],
      "id": "TR-08-102",
      "t": "Wild Yellow Rose",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        178,
        155,
        107
      ],
      "id": "TR-08-103",
      "t": "Transparent-Lustered Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        109,
        165,
        217
      ],
      "id": "TR-08-104",
      "t": "Transparent-Luster - Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        134,
        161,
        71
      ],
      "id": "TR-08-105",
      "t": "Transparent-Lustered Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        199,
        175,
        160
      ],
      "id": "TR-08-106",
      "t": "Transparent-Lustered Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        96,
        139,
        145
      ],
      "id": "TR-08-108BD",
      "t": "Transparent-Lustered Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        124,
        117,
        127
      ],
      "id": "TR-08-110",
      "t": "Transparent-Lustered Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        212,
        131,
        84
      ],
      "id": "TR-08-111",
      "t": "Transparent-Lustered Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        179,
        179,
        175
      ],
      "id": "TR-08-112",
      "t": "Transparent-Lustered Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        105,
        125,
        129
      ],
      "id": "TR-08-113",
      "t": "Transparent-Lustered Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        97,
        98,
        106
      ],
      "id": "TR-08-114",
      "t": "Transparent-Lustered Smoky Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        90,
        90,
        94
      ],
      "id": "TR-08-115",
      "t": "Crystal/Pink/Aventurine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        69,
        83,
        85
      ],
      "id": "TR-08-119",
      "t": "Transparent-Lustered Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        74,
        82,
        80
      ],
      "id": "TR-08-120",
      "t": "Transparent-Lustered Smoke",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        243,
        243,
        239
      ],
      "id": "TR-08-121",
      "t": "Opaque-Lustered White",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        244,
        235,
        218
      ],
      "id": "TR-08-122",
      "t": "Opaque-Lustered Navajo White",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        221,
        204,
        186
      ],
      "id": "TR-08-123",
      "t": "Opaque-Lustered Lt Beige",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        191,
        162,
        90
      ],
      "id": "TR-08-123D",
      "t": "Opaque-Lustered Dk Beige",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        174,
        215,
        228
      ],
      "id": "TR-08-124",
      "t": "Opaque-Lustered Pale Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        197,
        82,
        80
      ],
      "id": "TR-08-125",
      "t": "Opaque-Lustered Cherry",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        247,
        223,
        236
      ],
      "id": "TR-08-126",
      "t": "Opaque-Lustered Baby Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        198,
        198,
        66
      ],
      "id": "TR-08-128",
      "t": "Opaque-Lustered Dandelion",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        240,
        140,
        124
      ],
      "id": "TR-08-129",
      "t": "Opaque-Lustered Pumpkin",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        166,
        193,
        104
      ],
      "id": "TR-08-131",
      "t": "Opaque-Lustered Sour Apple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        131,
        211,
        202
      ],
      "id": "TR-08-132",
      "t": "Opaque-Lustered Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        152,
        142,
        160
      ],
      "id": "TR-08-133",
      "t": "Opaque-Lustered Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        238,
        237,
        238
      ],
      "id": "TR-08-141",
      "t": "Ceylon Snowflake",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        232,
        241,
        234
      ],
      "id": "TR-08-141F",
      "t": "Ceylon Frosted Snowflake",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        227,
        220,
        185
      ],
      "id": "TR-08-142",
      "t": "Ceylon Banana Cream",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        224,
        218,
        178
      ],
      "id": "TR-08-142F",
      "t": "Ceylon Frosted Banana Cream",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        173,
        213,
        223
      ],
      "id": "TR-08-143",
      "t": "Ceylon Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        160,
        208,
        222
      ],
      "id": "TR-08-143F",
      "t": "Ceylon Frosted Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        129,
        204,
        179
      ],
      "id": "TR-08-144",
      "t": "Ceylon Celery",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        91,
        212,
        176
      ],
      "id": "TR-08-144F",
      "t": "Ceylon Frosted Celery",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        239,
        167,
        176
      ],
      "id": "TR-08-145",
      "t": "Ceylon Innocent Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        244,
        183,
        198
      ],
      "id": "TR-08-145F",
      "t": "Ceylon Frosted Innocent Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        158,
        187,
        231
      ],
      "id": "TR-08-146",
      "t": "Ceylon Glacier",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        146,
        176,
        237
      ],
      "id": "TR-08-146F",
      "t": "Ceylon Frosted Glacier",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        228,
        213,
        190
      ],
      "id": "TR-08-147",
      "t": "Ceylon Lt Ivory",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        239,
        212,
        189
      ],
      "id": "TR-08-147F",
      "t": "Ceylon Frosted Lt Ivory",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        239,
        197,
        140
      ],
      "id": "TR-08-148",
      "t": "Ceylon Peach Cobbler",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        252,
        190,
        49
      ],
      "id": "TR-08-148F",
      "t": "Ceylon Frosted Peach Cobbler",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        175,
        185,
        189
      ],
      "id": "TR-08-150",
      "t": "Ceylon Smoke",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        116,
        127,
        123
      ],
      "id": "TR-08-150F",
      "t": "Ceylon Frosted Smoke",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        203,
        192,
        197
      ],
      "id": "TR-08-151",
      "t": "Ceylon Grape Mist",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        179,
        141,
        157
      ],
      "id": "TR-08-151F",
      "t": "Ceylon Frosted Grape Mist",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        220,
        216,
        212
      ],
      "id": "TR-08-161",
      "t": "Transparent-Rainbow Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        218,
        215,
        212
      ],
      "id": "TR-08-161F",
      "t": "Transparent-Rainbow Frosted Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        165,
        138,
        96
      ],
      "id": "TR-08-162",
      "t": "Transparent-Rainbow Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        227,
        175,
        113
      ],
      "id": "TR-08-162F",
      "t": "Transparent-Rainbow Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        224,
        164,
        123
      ],
      "id": "TR-08-162B",
      "t": "Transparent-Rainbow Med Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        173,
        132,
        115
      ],
      "id": "TR-08-162C",
      "t": "Transparent-Rainbow Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        208,
        153,
        113
      ],
      "id": "TR-08-162CF",
      "t": "Transparent-Rainbow Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        76,
        199,
        234
      ],
      "id": "TR-08-163",
      "t": "Transparent-Rainbow Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        94,
        185,
        237
      ],
      "id": "TR-08-163B",
      "t": "Transparent-Rainbow Dk Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        89,
        196,
        244
      ],
      "id": "TR-08-163BF",
      "t": "Transparent-Rainbow Frosted Dk Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        213,
        228,
        129
      ],
      "id": "TR-08-164",
      "t": "Transparent-Rainbow Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        203,
        220,
        117
      ],
      "id": "TR-08-164F",
      "t": "Transparent-Rainbow Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        19,
        162,
        146
      ],
      "id": "TR-08-164B",
      "t": "Transparent-Rainbow Dk Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        46,
        191,
        168
      ],
      "id": "TR-08-164BF",
      "t": "Transparent-Rainbow Frosted Dk Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        162,
        61,
        78
      ],
      "id": "TR-08-165",
      "t": "Transparent-Rainbow Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        216,
        104,
        123
      ],
      "id": "TR-08-165B",
      "t": "Transparent-Rainbow Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        190,
        138,
        159
      ],
      "id": "TR-08-165BF",
      "t": "Transparent-Rainbow Frosted Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        222,
        78,
        107
      ],
      "id": "TR-08-165C",
      "t": "Transparent-Rainbow Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        178,
        102,
        113
      ],
      "id": "TR-08-165CF",
      "t": "Transparent-Rainbow Frosted Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        176,
        135,
        162
      ],
      "id": "TR-08-166",
      "t": "Transparent Rainbow Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        186,
        155,
        158
      ],
      "id": "TR-08-166F",
      "t": "Transparent Rainbow Frosted Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        149,
        139,
        173
      ],
      "id": "TR-08-166B",
      "t": "Transparent Rainbow Med Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        185,
        155,
        150
      ],
      "id": "TR-08-166BF",
      "t": "Transparent Rainbow-Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        125,
        142,
        145
      ],
      "id": "TR-08-166C",
      "t": "Transparent Rainbow Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        161,
        159,
        175
      ],
      "id": "TR-08-166CF",
      "t": "Transparent Rainbow Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        131,
        125,
        149
      ],
      "id": "TR-08-166D",
      "t": "Transparent Rainbow Sugar Plum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        138,
        145,
        168
      ],
      "id": "TR-08-166DF",
      "t": "Transparent Rainbow Frosted Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        98,
        197,
        141
      ],
      "id": "TR-08-167",
      "t": "Transparent-Rainbow Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        89,
        185,
        135
      ],
      "id": "TR-08-167F",
      "t": "Transparent-Rainbow Frosted Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        36,
        143,
        96
      ],
      "id": "TR-08-167B",
      "t": "Transparent-Rainbow Grass Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        95,
        179,
        149
      ],
      "id": "TR-08-167BF",
      "t": "Transparent-Rainbow Frosted Grass Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        90,
        138,
        154
      ],
      "id": "TR-08-167BD",
      "t": "Transparent-Rainbow Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        66,
        153,
        159
      ],
      "id": "TR-08-167BDF",
      "t": "Transparent-Rainbow Frosted Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        155,
        172,
        239
      ],
      "id": "TR-08-168F",
      "t": "Transparent-Rainbow Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        235,
        190,
        185
      ],
      "id": "TR-08-169",
      "t": "Transparent-Rainbow Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        240,
        200,
        194
      ],
      "id": "TR-08-169F",
      "t": "Transparent-Rainbow Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        148,
        206,
        222
      ],
      "id": "TR-08-170D",
      "t": "Transparent-Rainbow Aqua Frost",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        224,
        160,
        160
      ],
      "id": "TR-08-171",
      "t": "Dyed-Rainbow Ballerina Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        157,
        189,
        145
      ],
      "id": "TR-08-172",
      "t": "Transparent-Rainbow Lemon Lime",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        204,
        224,
        165
      ],
      "id": "TR-08-173",
      "t": "Dyed-Rainbow Lemon Mist",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        237,
        92,
        22
      ],
      "id": "TR-08-174",
      "t": "Transparent-Rainbow Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        251,
        126,
        90
      ],
      "id": "TR-08-174BF",
      "t": "Transparent-Rainbow Frosted Hyacinth",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        232,
        212,
        80
      ],
      "id": "TR-08-175",
      "t": "Transparent-Rainbow Lemon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        224,
        206,
        89
      ],
      "id": "TR-08-175F",
      "t": "Transparent-Rainbow Frosted Lemon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        160,
        168,
        162
      ],
      "id": "TR-08-176",
      "t": "Transparent-Rainbow Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        180,
        186,
        189
      ],
      "id": "TR-08-176AF",
      "t": "Transparent-Rainbow Frosted Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        122,
        150,
        154
      ],
      "id": "TR-08-176B",
      "t": "Transparent-Rainbow Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        133,
        153,
        163
      ],
      "id": "TR-08-176BF",
      "t": "Transparent-Rainbow Frosted Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        96,
        61,
        31
      ],
      "id": "TR-08-177",
      "t": "Transparent-Rainbow Smoky Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        161,
        132,
        119
      ],
      "id": "TR-08-177F",
      "t": "Transparent-Rainbow Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        43,
        42,
        148
      ],
      "id": "TR-08-178",
      "t": "Transparent-Rainbow Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        96,
        95,
        186
      ],
      "id": "TR-08-178F",
      "t": "Transparent-Rainbow Frosted Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        108,
        154,
        127
      ],
      "id": "TR-08-179",
      "t": "Transparent-Rainbow Green Emerald",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        123,
        155,
        135
      ],
      "id": "TR-08-179F",
      "t": "Transparent-Rainbow Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        72,
        86,
        64
      ],
      "id": "TR-08-180",
      "t": "Transparent-Rainbow Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        141,
        159,
        135
      ],
      "id": "TR-08-180F",
      "t": "Transparent-Rainbow Frosted Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        126,
        134,
        185
      ],
      "id": "TR-08-181",
      "t": "Inside-Color Rainbow Crystal/Tanzanite-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        116,
        192,
        230
      ],
      "id": "TR-08-183",
      "t": "Inside-Color Luster Crystal/Opaque Aqua-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        174,
        94,
        92
      ],
      "id": "TR-08-185",
      "t": "Inside-Color Luster Crystal/Poppy-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        59,
        79,
        108
      ],
      "id": "TR-08-188",
      "t": "Inside-Color Luster Crystal/Capri Blue-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        67,
        89,
        149
      ],
      "id": "TR-08-189",
      "t": "Inside-Color Luster Crystal/Caribbean Blue-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        209,
        63,
        50
      ],
      "id": "TR-08-190",
      "t": "Inside-Color Luster Crystal/Tropical Sunset-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        220,
        149,
        175
      ],
      "id": "TR-08-191C",
      "t": "Inside-Color Crystal/Hot Pink-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        197,
        134,
        142
      ],
      "id": "TR-08-201",
      "t": "Gold-Lustered Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        115,
        81,
        74
      ],
      "id": "TR-08-202",
      "t": "Gold-Lustered Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        176,
        104,
        91
      ],
      "id": "TR-08-203",
      "t": "Gold-Lustered Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        127,
        113,
        76
      ],
      "id": "TR-08-204",
      "t": "Gold-Lustered Montana Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        107,
        138,
        156
      ],
      "id": "TR-08-206",
      "t": "Gold-Lustered Hydrangea",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        186,
        127,
        53
      ],
      "id": "TR-08-221",
      "t": "Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        123,
        93,
        54
      ],
      "id": "TR-08-221F",
      "t": "Frosted Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        204,
        113,
        92
      ],
      "id": "TR-08-222",
      "t": "Dk Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        119,
        74,
        80
      ],
      "id": "TR-08-222F",
      "t": "Frosted Dk Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        140,
        96,
        47
      ],
      "id": "TR-08-223",
      "t": "Antique Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        100,
        79,
        32
      ],
      "id": "TR-08-223F",
      "t": "Frosted Antique Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        117,
        74,
        53
      ],
      "id": "TR-08-224",
      "t": "Olympic Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        102,
        96,
        53
      ],
      "id": "TR-08-225",
      "t": "Bronze Antique Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        126,
        64,
        60
      ],
      "id": "TR-08-241",
      "t": "Inside-Color Rainbow Lt Topaz/Mauve-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        80,
        102,
        55
      ],
      "id": "TR-08-242",
      "t": "Inside-Color Luster Jonquil/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        78,
        103,
        66
      ],
      "id": "TR-08-242F",
      "t": "Inside-Color Frosted Jonquil/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        137,
        144,
        110
      ],
      "id": "TR-08-244",
      "t": "Inside-Color Rainbow Lt Topaz/Jet-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        73,
        61,
        51
      ],
      "id": "TR-08-245",
      "t": "Inside-Color Rainbow Jonquil/Jet-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        154,
        160,
        102
      ],
      "id": "TR-08-246",
      "t": "Inside-Color Luster Black Diamond/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        61,
        64,
        52
      ],
      "id": "TR-08-247",
      "t": "Inside-Color Peridot/Oxblood-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        52,
        76,
        94
      ],
      "id": "TR-08-248",
      "t": "Inside-Color Aqua/Jet-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        50,
        86,
        71
      ],
      "id": "TR-08-249",
      "t": "Inside-Color Peridot/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        118,
        134,
        98
      ],
      "id": "TR-08-250",
      "t": "Inside-Color Peridot/Fuchsia-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        118,
        112,
        143
      ],
      "id": "TR-08-251",
      "t": "Inside-Color Luster Lt Amethyst/Jet-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        120,
        117,
        172
      ],
      "id": "TR-08-252",
      "t": "Inside-Color Aqua/Purple-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        180,
        182,
        180
      ],
      "id": "TR-08-261",
      "t": "Inside-Color Rainbow Crystal/Gray-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        177,
        164,
        135
      ],
      "id": "TR-08-262",
      "t": "Inside-Color Crystal/Gold-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        124,
        192,
        219
      ],
      "id": "TR-08-263",
      "t": "Inside-Color Rainbow Crystal/Lt Capri-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        96,
        178,
        170
      ],
      "id": "TR-08-264",
      "t": "Inside-Color Rainbow Crystal/Teal-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        102,
        103,
        129
      ],
      "id": "TR-08-265",
      "t": "Inside-Color Rainbow Crystal/Metallic Purple-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        144,
        136,
        136
      ],
      "id": "TR-08-267",
      "t": "Inside-Color Crystal/Rose Gold-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        94,
        161,
        152
      ],
      "id": "TR-08-270F",
      "t": "Inside-Color Frosted Crystal/Prairie Green-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        137,
        88,
        52
      ],
      "id": "TR-08-278",
      "t": "Gold-Lined Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        123,
        151,
        136
      ],
      "id": "TR-08-284",
      "t": "Inside-Color Aqua/Gold-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        149,
        185,
        199
      ],
      "id": "TR-08-285",
      "t": "Inside-Color Aqua/Tin-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        168,
        170,
        170
      ],
      "id": "TR-08-288",
      "t": "Inside-Color Crystal/Metallic Blue-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        82,
        114,
        147
      ],
      "id": "TR-08-294",
      "t": "Inside-Color Blue Raspberry",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        209,
        192,
        73
      ],
      "id": "TR-08-302",
      "t": "Inside-Color Jonquil/Apricot-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        205,
        76,
        35
      ],
      "id": "TR-08-303",
      "t": "Inside-Color Jonquil/Hyacinth-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        166,
        76,
        108
      ],
      "id": "TR-08-304",
      "t": "Inside-Color Lt Sapphire/Hyacinth-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        132,
        215,
        134
      ],
      "id": "TR-08-307",
      "t": "Inside-Color Aqua/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        54,
        121,
        198
      ],
      "id": "TR-08-309",
      "t": "Inside-Color Lt Sapphire/Opaque Blue-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        60,
        89,
        96
      ],
      "id": "TR-08-321",
      "t": "Gold-Lustered Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        103,
        92,
        105
      ],
      "id": "TR-08-326",
      "t": "Gold-Lustered Orion",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        62,
        75,
        98
      ],
      "id": "TR-08-328",
      "t": "Gold-Lustered Moon Shadow",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        124,
        42,
        24
      ],
      "id": "TR-08-329",
      "t": "Gold-Lustered African Sunset",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        110,
        84,
        81
      ],
      "id": "TR-08-331",
      "t": "Gold-Lustered Wild Berry",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        189,
        88,
        117
      ],
      "id": "TR-08-332",
      "t": "Gold-Lustered Raspberry",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        52,
        67,
        18
      ],
      "id": "TR-08-333",
      "t": "Gold-Lustered Fern",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        247,
        154,
        140
      ],
      "id": "TR-08-341",
      "t": "Inside-Color Crystal/Tomato-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        201,
        122,
        104
      ],
      "id": "TR-08-342",
      "t": "Inside-Color Crystal/Dried Raspberry-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        88,
        93,
        88
      ],
      "id": "TR-08-344",
      "t": "Inside-Color Crystal/Dk Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        207,
        120,
        152
      ],
      "id": "TR-08-350",
      "t": "Inside-Color Crystal/Fuchsia-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        243,
        216,
        176
      ],
      "id": "TR-08-352",
      "t": "Inside-Color Crystal/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        237,
        129,
        143
      ],
      "id": "TR-08-355",
      "t": "PermaFinish - Inside-Color Crystal/Siam-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        171,
        155,
        164
      ],
      "id": "TR-08-367",
      "t": "Inside-Color Lustered Black Diamond/Pink-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        184,
        182,
        153
      ],
      "id": "TR-08-369",
      "t": "Inside-Color Black Diamond/Orange Creme-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        166,
        187,
        130
      ],
      "id": "TR-08-380",
      "t": "Inside-Color Topaz/Mint Julep-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        95,
        108,
        153
      ],
      "id": "TR-08-381",
      "t": "Inside-Color Aqua/Oxblood-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        79,
        84,
        96
      ],
      "id": "TR-08-383",
      "t": "Inside-Color Navy/White-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        247,
        249,
        250
      ],
      "id": "TR-08-401",
      "t": "Opaque-Rainbow White",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        223,
        220,
        44
      ],
      "id": "TR-08-402F",
      "t": "Opaque-Rainbow-Frosted Dandelion",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        144,
        196,
        244
      ],
      "id": "TR-08-403",
      "t": "Opaque-Rainbow Blue Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        167,
        195,
        106
      ],
      "id": "TR-08-404",
      "t": "Opaque-Rainbow Sour Apple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        106,
        102,
        102
      ],
      "id": "TR-08-406F",
      "t": "Opaque-Rainbow-Frosted Oxblood",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        120,
        166,
        67
      ],
      "id": "TR-08-407",
      "t": "Opaque-Rainbow Mint Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        117,
        126,
        243
      ],
      "id": "TR-08-408F",
      "t": "Opaque-Rainbow-Frosted Navy Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        215,
        108,
        89
      ],
      "id": "TR-08-410F",
      "t": "Opaque-Rainbow-Frosted Pumpkin",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        189,
        171,
        193
      ],
      "id": "TR-08-412",
      "t": "Opaque-Rainbow Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        176,
        100,
        34
      ],
      "id": "TR-08-421",
      "t": "Gold-Lustered Transparent Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        73,
        71,
        30
      ],
      "id": "TR-08-422",
      "t": "Gold-Lustered Dk Antique Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        128,
        135,
        142
      ],
      "id": "TR-08-455",
      "t": "Gold-Lustered Pale Wisteria",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        167,
        160,
        86
      ],
      "id": "TR-08-457",
      "t": "Gold-Lustered Green Tea",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        131,
        108,
        90
      ],
      "id": "TR-08-459",
      "t": "Gold-Lustered Dk Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        105,
        56,
        59
      ],
      "id": "TR-08-460",
      "t": "PermaFinish - Opaque Brown Gold Luster",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        164,
        85,
        190
      ],
      "id": "TR-08-461",
      "t": "Higher-Metallic Grape",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        189,
        174,
        204
      ],
      "id": "TR-08-477",
      "t": "Dyed-Rainbow Lavender Mist",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        134,
        118,
        158
      ],
      "id": "TR-08-477D",
      "t": "Transparent-Rainbow Foxglove",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        68,
        28,
        26
      ],
      "id": "TR-08-502",
      "t": "Higher-Metallic Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        146,
        110,
        159
      ],
      "id": "TR-08-504",
      "t": "Higher-Metallic Iris - Violet",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        56,
        99,
        123
      ],
      "id": "TR-08-505",
      "t": "Higher-Metallic Dragonfly",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        41,
        184,
        179
      ],
      "id": "TR-08-506",
      "t": "Higher-Metallic June Bug",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        86,
        148,
        108
      ],
      "id": "TR-08-507",
      "t": "Higher-Metallic Iris - Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        175,
        157,
        135
      ],
      "id": "TR-08-508",
      "t": "Higher-Metallic Iris - Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        184,
        138,
        156
      ],
      "id": "TR-08-509",
      "t": "Higher-Metallic Iris - Purple/Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        91,
        157,
        192
      ],
      "id": "TR-08-511F",
      "t": "Higher-Metallic Frosted Mediterranean Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        185,
        198,
        181
      ],
      "id": "TR-08-512F",
      "t": "Higher-Metallic Frosted Blue Haze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        199,
        171,
        86
      ],
      "id": "TR-08-513F",
      "t": "Higher-Metallic Frosted Carnival",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        157,
        93,
        189
      ],
      "id": "TR-08-515F",
      "t": "Higher-Metallic Frosted Mardi Gras",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        183,
        151,
        105
      ],
      "id": "TR-08-551",
      "t": "Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        190,
        143,
        89
      ],
      "id": "TR-08-PF551F",
      "t": "PermaFinish - Matte Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        223,
        171,
        117
      ],
      "id": "TR-08-PF551",
      "t": "PermaFinish - Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        208,
        188,
        174
      ],
      "id": "TR-08-552",
      "t": "Galvanized Peach Coral",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        208,
        156,
        150
      ],
      "id": "TR-08-PF552F",
      "t": "PermaFinish - Matte Galvanized Peach Coral",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        242,
        194,
        178
      ],
      "id": "TR-08-PF552",
      "t": "PermaFinish - Galvanized Sweet Blush",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        246,
        176,
        197
      ],
      "id": "TR-08-553",
      "t": "Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        212,
        130,
        139
      ],
      "id": "TR-08-PF553F",
      "t": "PermaFinish - Matte Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        243,
        148,
        182
      ],
      "id": "TR-08-PF553",
      "t": "PermaFinish - Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        182,
        163,
        170
      ],
      "id": "TR-08-554",
      "t": "Galvanized Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        172,
        132,
        150
      ],
      "id": "TR-08-PF554F",
      "t": "PermaFinish - Matte Galvanized Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        213,
        182,
        173
      ],
      "id": "TR-08-PF554",
      "t": "PermaFinish - Galvanized Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        174,
        136,
        116
      ],
      "id": "TR-08-PF556",
      "t": "PermaFinish - Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        222,
        202,
        140
      ],
      "id": "TR-08-557",
      "t": "Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        189,
        144,
        73
      ],
      "id": "TR-08-PF557F",
      "t": "PermaFinish - Matte Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        235,
        195,
        98
      ],
      "id": "TR-08-PF557",
      "t": "PermaFinish - Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        230,
        224,
        200
      ],
      "id": "TR-08-558",
      "t": "Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        215,
        203,
        174
      ],
      "id": "TR-08-PF558F",
      "t": "PermaFinish - Matte Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        235,
        227,
        200
      ],
      "id": "TR-08-PF558",
      "t": "PermaFinish - Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        215,
        200,
        147
      ],
      "id": "TR-08-559F",
      "t": "Galvanized-Matte Yellow Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        227,
        206,
        130
      ],
      "id": "TR-08-PF559F",
      "t": "PermaFinish - Frosted Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        177,
        207,
        160
      ],
      "id": "TR-08-560F",
      "t": "Galvanized-Matte Sea Foam",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        150,
        195,
        166
      ],
      "id": "TR-08-561",
      "t": "Galvanized Green Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        69,
        176,
        142
      ],
      "id": "TR-08-PF561F",
      "t": "PermaFinish - Matte Galvanized Green Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        122,
        210,
        176
      ],
      "id": "TR-08-PF561",
      "t": "PermaFinish - Galvanized Green Tea",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        222,
        123,
        90
      ],
      "id": "TR-08-PF562F",
      "t": "PermaFinish - Matte Galvanized Saffron",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        238,
        105,
        31
      ],
      "id": "TR-08-PF562",
      "t": "PermaFinish - Galvanized Saffron",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        195,
        73,
        144
      ],
      "id": "TR-08-563",
      "t": "Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        235,
        144,
        167
      ],
      "id": "TR-08-563F",
      "t": "Galvanized-Matte Orchid",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        211,
        92,
        126
      ],
      "id": "TR-08-PF563F",
      "t": "PermaFinish - Matte Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        230,
        34,
        101
      ],
      "id": "TR-08-PF563",
      "t": "PermaFinish - Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        108,
        62,
        62
      ],
      "id": "TR-08-564",
      "t": "Galvanized Brick Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        167,
        60,
        66
      ],
      "id": "TR-08-PF564F",
      "t": "PermaFinish - Matte Galvanized Brick Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        178,
        82,
        77
      ],
      "id": "TR-08-PF564",
      "t": "PermaFinish - Galvanized Brick Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        137,
        161,
        161
      ],
      "id": "TR-08-565",
      "t": "Galvanized Blue Slate",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        142,
        155,
        146
      ],
      "id": "TR-08-PF565F",
      "t": "PermaFinish - Frosted Galvanized Blue Slate",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        185,
        174,
        163
      ],
      "id": "TR-08-566",
      "t": "Metallic Frosted Antique Silver",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        100,
        96,
        120
      ],
      "id": "TR-08-567F",
      "t": "Frosted Metallic Polaris",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        113,
        119,
        150
      ],
      "id": "TR-08-PF567F",
      "t": "PermaFinish - Frosted Metallic Polaris",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        131,
        142,
        182
      ],
      "id": "TR-08-PF567",
      "t": "PermaFinish - Metallic Polaris",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        147,
        193,
        144
      ],
      "id": "TR-08-PF570F",
      "t": "PermaFinish - Frosted Galvanized Mint Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        158,
        203,
        148
      ],
      "id": "TR-08-PF570",
      "t": "PermaFinish - Galvanized Mint Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        41,
        176,
        150
      ],
      "id": "TR-08-PF578F",
      "t": "PermaFinish - Frosted Galvanized Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        166,
        127,
        157
      ],
      "id": "TR-08-PF579F",
      "t": "PermaFinish - Matte Galvanized Pale Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        168,
        145,
        187
      ],
      "id": "TR-08-PF579",
      "t": "PermaFinish - Galvanized Pale Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        185,
        104,
        163
      ],
      "id": "TR-08-PF580F",
      "t": "PermaFinish - Matte Galvanized Sugar Plum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        210,
        137,
        185
      ],
      "id": "TR-08-PF580",
      "t": "PermaFinish - Galvanized Sugar Plum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        122,
        99,
        176
      ],
      "id": "TR-08-PF581F",
      "t": "PermaFinish - Matte Galvanized Violet",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        107,
        100,
        212
      ],
      "id": "TR-08-PF581",
      "t": "PermaFinish - Galvanized Violet",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        25,
        143,
        175
      ],
      "id": "TR-08-PF582F",
      "t": "PermaFinish - Matte Galvanized Aqua Sky",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        79,
        154,
        218
      ],
      "id": "TR-08-PF582",
      "t": "PermaFinish - Galvanized Aqua Sky",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        11,
        124,
        188
      ],
      "id": "TR-08-PF583F",
      "t": "PermaFinish - Matte Galvanized Caribbean Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        4,
        165,
        207
      ],
      "id": "TR-08-PF583",
      "t": "PermaFinish - Galvanized Caribbean Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        8,
        97,
        149
      ],
      "id": "TR-08-PF584F",
      "t": "PermaFinish - Matte Galvanized Turkish Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        28,
        107,
        169
      ],
      "id": "TR-08-PF584",
      "t": "PermaFinish - Galvanized Turkish Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        21,
        96,
        159
      ],
      "id": "TR-08-PF585F",
      "t": "PermaFinish - Matte Galvanized Ocean Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        1,
        114,
        210
      ],
      "id": "TR-08-PF585",
      "t": "PermaFinish - Galvanized Ocean Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        49,
        95,
        159
      ],
      "id": "TR-08-PF586F",
      "t": "PermaFinish - Matte Galvanized Denim Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        27,
        112,
        193
      ],
      "id": "TR-08-PF586",
      "t": "PermaFinish - Galvanized Denim Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        128,
        198,
        117
      ],
      "id": "TR-08-PF587F",
      "t": "PermaFinish - Matte Galvanized Green Apple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        131,
        198,
        117
      ],
      "id": "TR-08-PF587",
      "t": "PermaFinish - Galvanized Green Apple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        61,
        175,
        117
      ],
      "id": "TR-08-PF588F",
      "t": "PermaFinish - Matte Galvanized Spring Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        58,
        196,
        120
      ],
      "id": "TR-08-PF588",
      "t": "PermaFinish - Galvanized Spring Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        104,
        156,
        126
      ],
      "id": "TR-08-PF589F",
      "t": "PermaFinish - Matte Galvanized Jade Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        149,
        187,
        154
      ],
      "id": "TR-08-PF589",
      "t": "PermaFinish - Galvanized Jade Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        204,
        201,
        83
      ],
      "id": "TR-08-PF590F",
      "t": "PermaFinish - Matte Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        196,
        203,
        106
      ],
      "id": "TR-08-PF590",
      "t": "PermaFinish - Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        179,
        120,
        45
      ],
      "id": "TR-08-PF591F",
      "t": "PermaFinish - Matte Galvanized Old Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        218,
        165,
        61
      ],
      "id": "TR-08-PF591",
      "t": "PermaFinish - Galvanized Old Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        181,
        150,
        88
      ],
      "id": "TR-08-PF592F",
      "t": "PermaFinish - Matte Galvanized Golden Fleece",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        219,
        199,
        142
      ],
      "id": "TR-08-PF592",
      "t": "PermaFinish - Galvanized Golden Fleece",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        141,
        115,
        76
      ],
      "id": "TR-08-PF593F",
      "t": "PermaFinish - Matte Galvanized Almond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        179,
        147,
        103
      ],
      "id": "TR-08-PF593",
      "t": "PermaFinish - Galvanized Almond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        124,
        96,
        42
      ],
      "id": "TR-08-PF594F",
      "t": "PermaFinish - Matte Galvanized Medal Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        180,
        142,
        58
      ],
      "id": "TR-08-PF594",
      "t": "PermaFinish - Galvanized Medal Bronze",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        79,
        77,
        75
      ],
      "id": "TR-08-PF595F",
      "t": "PermaFinish - Matte Galvanized Cool Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        105,
        104,
        96
      ],
      "id": "TR-08-PF595",
      "t": "PermaFinish - Galvanized Cool Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        128,
        143,
        150
      ],
      "id": "TR-08-611",
      "t": "Matte-Color Opaque Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        73,
        86,
        93
      ],
      "id": "TR-08-612",
      "t": "Matte-Color Gun Metal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        73,
        88,
        79
      ],
      "id": "TR-08-613",
      "t": "Matte-Color Iris - Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        133,
        114,
        106
      ],
      "id": "TR-08-614",
      "t": "Matte-Color Iris - Brown",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        136,
        116,
        139
      ],
      "id": "TR-08-615",
      "t": "Matte-Color Iris - Purple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        136,
        132,
        71
      ],
      "id": "TR-08-617",
      "t": "Matte-Color Dk Olive",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        109,
        65,
        43
      ],
      "id": "TR-08-618",
      "t": "Opaque-Pastel-Frosted Mudbrick",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        114,
        65,
        103
      ],
      "id": "TR-08-625F",
      "t": "Gold-Lustered Matte Plum",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        117,
        88,
        97
      ],
      "id": "TR-08-628",
      "t": "Gold Luster - Pink Rose",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        175,
        145,
        108
      ],
      "id": "TR-08-629",
      "t": "Gold Luster - Peach",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        192,
        153,
        131
      ],
      "id": "TR-08-630",
      "t": "Transparent Lt Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        208,
        162,
        135
      ],
      "id": "TR-08-631",
      "t": "Transparent Luster - Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        197,
        188,
        220
      ],
      "id": "TR-08-632",
      "t": "Transparent Gold Luster - Lt Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        231,
        239,
        199
      ],
      "id": "TR-08-663",
      "t": "Gold Luster - Cream",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        167,
        197,
        180
      ],
      "id": "TR-08-699",
      "t": "Inside-Color Rainbow Crystal/Shamrock-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        201,
        160,
        95
      ],
      "id": "TR-08-701",
      "t": "24K Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        144,
        118,
        66
      ],
      "id": "TR-08-702",
      "t": "Matte-Color Dk Copper",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        144,
        108,
        120
      ],
      "id": "TR-08-703",
      "t": "Matte-Color Mauve Mocha",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        98,
        86,
        143
      ],
      "id": "TR-08-705",
      "t": "Matte-Color Iris - Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        72,
        156,
        160
      ],
      "id": "TR-08-706",
      "t": "Matte-Color Iris - Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        125,
        138,
        96
      ],
      "id": "TR-08-707",
      "t": "Matte-Color Iris - Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        147,
        151,
        126
      ],
      "id": "TR-08-708",
      "t": "Matte-Color Cassiopeia",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        127,
        120,
        101
      ],
      "id": "TR-08-709",
      "t": "Matte-Color Iris - Violet",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        75,
        94,
        84
      ],
      "id": "TR-08-710",
      "t": "Matte-Color Aquarius",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        183,
        181,
        176
      ],
      "id": "TR-08-711",
      "t": "Nickel",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        230,
        176,
        68
      ],
      "id": "TR-08-712",
      "t": "Metallic 24K Gold Plated",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        206,
        166,
        77
      ],
      "id": "TR-08-712F",
      "t": "Metallic Frosted 24K Gold Plated",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        97,
        122,
        94
      ],
      "id": "TR-08-721",
      "t": "Galvanized Blue Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        202,
        149,
        128
      ],
      "id": "TR-08-740",
      "t": "Copper-Lined Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        215,
        187,
        191
      ],
      "id": "TR-08-741",
      "t": "Copper-Lined Alabaster",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        47,
        58,
        29
      ],
      "id": "TR-08-742",
      "t": "Copper-Lined Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        143,
        92,
        33
      ],
      "id": "TR-08-744",
      "t": "Copper-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        150,
        126,
        11
      ],
      "id": "TR-08-745",
      "t": "Copper-Lined Marigold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        110,
        84,
        71
      ],
      "id": "TR-08-746",
      "t": "Copper-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        106,
        103,
        32
      ],
      "id": "TR-08-747",
      "t": "Copper-Lined Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        188,
        174,
        133
      ],
      "id": "TR-08-751",
      "t": "Gold-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        154,
        125,
        40
      ],
      "id": "TR-08-752",
      "t": "Gold-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        156,
        114,
        52
      ],
      "id": "TR-08-753",
      "t": "Gold-Lined Rose Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        81,
        115,
        91
      ],
      "id": "TR-08-755",
      "t": "Gold-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        88,
        94,
        75
      ],
      "id": "TR-08-757",
      "t": "Gold-Lined Sky Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        245,
        245,
        242
      ],
      "id": "TR-08-761",
      "t": "Matte-Color Opaque-Rainbow White",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        230,
        221,
        201
      ],
      "id": "TR-08-762",
      "t": "Opaque-Pastel-Frosted Egg Shell",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        240,
        220,
        193
      ],
      "id": "TR-08-763",
      "t": "Opaque-Pastel-Frosted Apricot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        179,
        154,
        136
      ],
      "id": "TR-08-764",
      "t": "Opaque-Pastel-Frosted Shrimp",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        156,
        134,
        138
      ],
      "id": "TR-08-765",
      "t": "Opaque-Pastel-Frosted Plumeria",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        185,
        164,
        176
      ],
      "id": "TR-08-766",
      "t": "Opaque-Pastel-Frosted Lt Lilac",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        157,
        96,
        93
      ],
      "id": "TR-08-768",
      "t": "Opaque-Rainbow-Frosted Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        209,
        182,
        184
      ],
      "id": "TR-08-771",
      "t": "Inside-Color Rainbow Crystal/Strawberry-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        98,
        131,
        159
      ],
      "id": "TR-08-773",
      "t": "Inside-Color Rainbow Crystal/Montana Blue-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        132,
        132,
        128
      ],
      "id": "TR-08-774",
      "t": "Inside-Color Rainbow Crystal/Grape-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        228,
        240,
        227
      ],
      "id": "TR-08-777",
      "t": "Inside-Color Rainbow Crystal/Creme-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        209,
        150,
        143
      ],
      "id": "TR-08-779",
      "t": "Inside-Color Rainbow Crystal/Salmon-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        102,
        118,
        126
      ],
      "id": "TR-08-782",
      "t": "Inside-Color Rainbow Crystal/Capri-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        185,
        134,
        128
      ],
      "id": "TR-08-784",
      "t": "Inside-Color Rainbow Crystal/Sandstone-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        252,
        174,
        70
      ],
      "id": "TR-08-801",
      "t": "Luminous Neon Tangerine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        242,
        162,
        21
      ],
      "id": "TR-08-801F",
      "t": "Frosted Luminous Neon Tangerine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        253,
        136,
        77
      ],
      "id": "TR-08-802",
      "t": "Luminous Neon Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        251,
        134,
        132
      ],
      "id": "TR-08-803",
      "t": "Luminous Neon Salmon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        231,
        107,
        77
      ],
      "id": "TR-08-803F",
      "t": "Frosted Luminous Neon Salmon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        97,
        231,
        135
      ],
      "id": "TR-08-805",
      "t": "Luminous Neon Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        177,
        187,
        187
      ],
      "id": "TR-08-820",
      "t": "Inside-Color Opaque Gray/Black-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        217,
        236,
        144
      ],
      "id": "TR-08-833",
      "t": "Ceylon Neon Yellow",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        222,
        208,
        142
      ],
      "id": "TR-08-901",
      "t": "Ceylon Rice Pudding",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        228,
        208,
        144
      ],
      "id": "TR-08-902",
      "t": "Ceylon Lemon Chiffon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        225,
        211,
        87
      ],
      "id": "TR-08-902F",
      "t": "Ceylon Frosted Lemon Chiffon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        248,
        186,
        167
      ],
      "id": "TR-08-904",
      "t": "Ceylon Apricot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        252,
        187,
        180
      ],
      "id": "TR-08-905",
      "t": "Ceylon Peach Blush",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        212,
        152,
        160
      ],
      "id": "TR-08-906",
      "t": "Ceylon Tomato Soup",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        181,
        162,
        174
      ],
      "id": "TR-08-907",
      "t": "Ceylon Petunia",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        234,
        182,
        195
      ],
      "id": "TR-08-908",
      "t": "Dyed Ceylon Baby Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        253,
        134,
        191
      ],
      "id": "TR-08-910",
      "t": "Ceylon Hot Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        237,
        132,
        166
      ],
      "id": "TR-08-910F",
      "t": "Ceylon Frosted Hot Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        251,
        181,
        196
      ],
      "id": "TR-08-911",
      "t": "Ceylon Impatiens Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        128,
        162,
        160
      ],
      "id": "TR-08-915",
      "t": "Ceylon Dk Seafoam",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        170,
        163,
        211
      ],
      "id": "TR-08-916",
      "t": "Ceylon Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        159,
        180,
        229
      ],
      "id": "TR-08-917",
      "t": "Ceylon Denim Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        142,
        177,
        199
      ],
      "id": "TR-08-918",
      "t": "Ceylon English Bluebell",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        162,
        201,
        212
      ],
      "id": "TR-08-919",
      "t": "Ceylon Forget-Me-Not",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        129,
        180,
        171
      ],
      "id": "TR-08-920",
      "t": "Ceylon Seafoam",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        146,
        157,
        191
      ],
      "id": "TR-08-922",
      "t": "Ceylon Gladiola",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        224,
        159,
        143
      ],
      "id": "TR-08-924",
      "t": "Inside-Color Jonquil/Peach-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        152,
        153,
        171
      ],
      "id": "TR-08-926",
      "t": "Inside-Color Lt Topaz/Opaque Lavender-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        99,
        94,
        122
      ],
      "id": "TR-08-927",
      "t": "Inside-Color Lt Topaz/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        143,
        97,
        189
      ],
      "id": "TR-08-928",
      "t": "Inside-Color Rainbow Rosaline/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        75,
        57,
        101
      ],
      "id": "TR-08-928F",
      "t": "Inside-Color Rainbow Frosted Rosaline/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        97,
        152,
        182
      ],
      "id": "TR-08-931",
      "t": "Inside-Color Aqua/White-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        68,
        125,
        191
      ],
      "id": "TR-08-932",
      "t": "Inside-Color Aqua/Capri-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        150,
        181,
        215
      ],
      "id": "TR-08-933",
      "t": "Inside-Color Lt Sapphire/White-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        185,
        133,
        199
      ],
      "id": "TR-08-935",
      "t": "Inside-Color Crystal/Wisteria-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        56,
        96,
        71
      ],
      "id": "TR-08-939",
      "t": "Transparent Green Emerald",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        53,
        85,
        64
      ],
      "id": "TR-08-939F",
      "t": "Transparent-Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        119,
        128,
        94
      ],
      "id": "TR-08-940",
      "t": "Transparent Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        47,
        62,
        42
      ],
      "id": "TR-08-940F",
      "t": "Transparent-Frosted Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        54,
        33,
        19
      ],
      "id": "TR-08-941",
      "t": "Transparent Smoky Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        69,
        42,
        22
      ],
      "id": "TR-08-941F",
      "t": "Transparent-Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        79,
        66,
        193
      ],
      "id": "TR-08-942",
      "t": "Transparent Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        46,
        35,
        140
      ],
      "id": "TR-08-942F",
      "t": "Transparent-Frosted Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        173,
        148,
        201
      ],
      "id": "TR-08-943",
      "t": "Inside-Color Crystal/Lilac-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        166,
        193,
        115
      ],
      "id": "TR-08-945",
      "t": "Inside-Color Jonquil/Mint Julep-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        86,
        126,
        79
      ],
      "id": "TR-08-947",
      "t": "Inside-Color Lime Green/Opaque Green-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        238,
        210,
        162
      ],
      "id": "TR-08-948",
      "t": "Inside-Color Jonquil/White-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        216,
        132,
        51
      ],
      "id": "TR-08-950",
      "t": "Inside-Color Jonquil/Burnt Orange-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        197,
        106,
        99
      ],
      "id": "TR-08-951",
      "t": "Inside-Color Jonquil/Brick Red-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        117,
        174,
        152
      ],
      "id": "TR-08-952",
      "t": "Inside-Color Rainbow Lt Topaz/Sea Foam-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        109,
        136,
        139
      ],
      "id": "TR-08-953",
      "t": "Inside-Color Jonquil/Turquoise-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        121,
        227,
        219
      ],
      "id": "TR-08-954",
      "t": "Inside-Color Aqua/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        117,
        181,
        187
      ],
      "id": "TR-08-954F",
      "t": "Inside-Color Frosted Aqua/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        251,
        146,
        77
      ],
      "id": "TR-08-957",
      "t": "Inside-Color Hyacinth/White-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        214,
        135,
        164
      ],
      "id": "TR-08-959",
      "t": "Inside-Color Lt Amethyst/Pink-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        177,
        116,
        153
      ],
      "id": "TR-08-959F",
      "t": "Inside-Color Frosted Lt Amethyst/Pink-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        154,
        106,
        108
      ],
      "id": "TR-08-960",
      "t": "Inside-Color Lt Topaz/Pink-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        205,
        185,
        87
      ],
      "id": "TR-08-961",
      "t": "Inside-Color Crystal/Butter-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        206,
        118,
        88
      ],
      "id": "TR-08-963",
      "t": "Inside-Color Crystal/Apricot-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        246,
        84,
        129
      ],
      "id": "TR-08-971",
      "t": "Inside-Color Matte Crystal/Neon Pink-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        179,
        229,
        163
      ],
      "id": "TR-08-975",
      "t": "Inside-Color Crystal/Neon Sea Foam-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        113,
        164,
        195
      ],
      "id": "TR-08-976",
      "t": "Inside-Color Crystal/Neon Ice Blue-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        156,
        148,
        239
      ],
      "id": "TR-08-977",
      "t": "Inside-Color Crystal/Neon Purple-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        249,
        94,
        147
      ],
      "id": "TR-08-978",
      "t": "Luminous Neon Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        245,
        92,
        106
      ],
      "id": "TR-08-979",
      "t": "Luminous Lt Topaz/Neon Pink-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        201,
        86,
        153
      ],
      "id": "TR-08-980",
      "t": "Luminous Lt Sapphire/Neon Pink-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        237,
        212,
        111
      ],
      "id": "TR-08-983",
      "t": "Inside-Color Crystal/Custard Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        154,
        148,
        114
      ],
      "id": "TR-08-989",
      "t": "Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        170,
        145,
        123
      ],
      "id": "TR-08-989F",
      "t": "Gold-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        166,
        188,
        184
      ],
      "id": "TR-08-990",
      "t": "Gold-Lined Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        148,
        143,
        78
      ],
      "id": "TR-08-991",
      "t": "Gold-Lined Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        147,
        154,
        147
      ],
      "id": "TR-08-992",
      "t": "Gold-Lined Lt Montana Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        183,
        163,
        140
      ],
      "id": "TR-08-993",
      "t": "Gold-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        215,
        182,
        147
      ],
      "id": "TR-08-994",
      "t": "Gold-Lined Rainbow Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        139,
        190,
        193
      ],
      "id": "TR-08-995",
      "t": "Gold-Lined Rainbow Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        73,
        104,
        101
      ],
      "id": "TR-08-995F",
      "t": "Gold-Lined Frosted Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        171,
        156,
        92
      ],
      "id": "TR-08-996",
      "t": "Gold-Lined Rainbow Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        79,
        94,
        125
      ],
      "id": "TR-08-997F",
      "t": "Gold-Lined Rainbow Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        182,
        166,
        119
      ],
      "id": "TR-08-998",
      "t": "Gold-Lined Rainbow Lt Jonquil",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        111,
        106,
        95
      ],
      "id": "TR-08-999",
      "t": "Gold-Lined Rainbow Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        108,
        111,
        99
      ],
      "id": "TR-08-999F",
      "t": "Gold-Lined Frosted Black Diamond",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        91,
        108,
        77
      ],
      "id": "TR-08-1014",
      "t": "Silver-Lined Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        191,
        215,
        186
      ],
      "id": "TR-08-1065",
      "t": "Inside-Color Crystal/Mint-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        168,
        142,
        121
      ],
      "id": "TR-08-1067",
      "t": "Inside-Color Crystal/Mauve-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        208,
        185,
        162
      ],
      "id": "TR-08-1068",
      "t": "Inside-Color Crystal/Blush-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        189,
        157,
        139
      ],
      "id": "TR-08-1069",
      "t": "Lt Topaz/Dk Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        81,
        111,
        90
      ],
      "id": "TR-08-1070",
      "t": "Inside-Color Crystal/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        106,
        120,
        117
      ],
      "id": "TR-08-1072",
      "t": "Inside-Color Crystal Blue/Coffee-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        176,
        161,
        107
      ],
      "id": "TR-08-1073",
      "t": "",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        47,
        68,
        107
      ],
      "id": "TR-08-1074",
      "t": "Inside-Color Crystal/Deep Blue-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        141,
        97,
        105
      ],
      "id": "TR-08-1076",
      "t": "Inside-Color Gray/Magenta-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        132,
        205,
        172
      ],
      "id": "TR-08-1144",
      "t": "Milky Kiwi",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        227,
        199,
        202
      ],
      "id": "TR-08-1200",
      "t": "Marbled Opaque White/Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        193,
        154,
        140
      ],
      "id": "TR-08-1201",
      "t": "Marbled Opaque Beige/Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        164,
        157,
        151
      ],
      "id": "TR-08-1203",
      "t": "Marbled Opaque Pink/Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        172,
        192,
        199
      ],
      "id": "TR-08-1205",
      "t": "Marbled Opaque White/Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        84,
        116,
        127
      ],
      "id": "TR-08-1207",
      "t": "Marbled Opaque Turquoise/Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        130,
        151,
        152
      ],
      "id": "TR-08-1208",
      "t": "Marbled Opaque Turquoise/Luster - Transparent Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        180,
        160,
        88
      ],
      "id": "TR-08-1209",
      "t": "Marbled Opaque Avocado/Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        153,
        128,
        158
      ],
      "id": "TR-08-1300",
      "t": "Transparent Alexandrite",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        144,
        207,
        191
      ],
      "id": "TR-08-1611",
      "t": "Opaque-Lustered Lagoon",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        146,
        118,
        144
      ],
      "id": "TR-08-1633F",
      "t": "Opaque-Rainbow-Frosted Blackberry",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        161,
        133,
        112
      ],
      "id": "TR-08-1701",
      "t": "Gilded Marble Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        132,
        135,
        68
      ],
      "id": "TR-08-1702",
      "t": "Gilded Marble Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        134,
        131,
        106
      ],
      "id": "TR-08-1703",
      "t": "Gilded Marble Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        134,
        123,
        91
      ],
      "id": "TR-08-1704",
      "t": "Gilded Marble Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        85,
        73,
        38
      ],
      "id": "TR-08-1705",
      "t": "Gilded Marble Brown",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        102,
        97,
        57
      ],
      "id": "TR-08-1706",
      "t": "Gilded Marble Black",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        196,
        142,
        83
      ],
      "id": "TR-08-1708",
      "t": "Gilded Marble Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        169,
        167,
        182
      ],
      "id": "TR-08-1807",
      "t": "Silver-Lined Gray Rainbow",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        204,
        162,
        137
      ],
      "id": "TR-08-1813",
      "t": "Transparent-Rainbow Peach",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        133,
        130,
        115
      ],
      "id": "TR-08-1814",
      "t": "Transparent-Rainbow Ash",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        127,
        97,
        33
      ],
      "id": "TR-08-1815",
      "t": "Transparent-Rainbow Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        182,
        154,
        109
      ],
      "id": "TR-08-1816",
      "t": "Transparent-Rainbow Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        86,
        146,
        135
      ],
      "id": "TR-08-1833",
      "t": "Inside-Color Rainbow Lt Sapphire/Opaque Teal-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        239,
        216,
        223
      ],
      "id": "TR-08-1844",
      "t": "Transparent-Rainbow Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        183,
        106,
        117
      ],
      "id": "TR-08-1845",
      "t": "Inside-Color Rainbow Crystal/Rose-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        173,
        140,
        130
      ],
      "id": "TR-08-1847",
      "t": "Inside-Color Rainbow Crystal/Lt Mauve-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        144,
        158,
        131
      ],
      "id": "TR-08-1848",
      "t": "Inside-Color Rainbow Crystal/Blue Mint-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        161,
        133,
        76
      ],
      "id": "TR-08-1849",
      "t": "Inside-Color Rainbow Topaz/Lavender-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        115,
        86,
        72
      ],
      "id": "TR-08-1850",
      "t": "Inside-Color Rainbow Topaz/Mauve-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        97,
        111,
        96
      ],
      "id": "TR-08-1851",
      "t": "Inside-Color Rainbow Aqua/Brick-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        48,
        79,
        89
      ],
      "id": "TR-08-1852",
      "t": "Inside-Color Rainbow Capri/Aqua-Lined",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        162,
        107,
        62
      ],
      "id": "TR-08-1853",
      "t": "Transparent Rainbow Honey Comb",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        111,
        163,
        67
      ],
      "id": "TR-08-2024",
      "t": "Silver-Lined Rainbow Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        231,
        200,
        184
      ],
      "id": "TR-08-2031F",
      "t": "Silver-Lined Rainbow Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        128,
        124,
        83
      ],
      "id": "TR-08-2034",
      "t": "Silver-Lined Rainbow Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        220,
        219,
        210
      ],
      "id": "TR-08-2100",
      "t": "Silver-Lined Milky White",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        176,
        190,
        188
      ],
      "id": "TR-08-2101",
      "t": "Silver-Lined Milky Cloud",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        106,
        161,
        172
      ],
      "id": "TR-08-PF2102",
      "t": "PermaFinish - Silver-Lined Milky Montana Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        134,
        178,
        123
      ],
      "id": "TR-08-2103",
      "t": "Silver-Lined Milky Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        68,
        200,
        154
      ],
      "id": "TR-08-PF2103",
      "t": "PermaFinish - Silver-Lined Milky Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        12,
        159,
        147
      ],
      "id": "TR-08-2104",
      "t": "Silver-Lined Milky Teal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        249,
        181,
        209
      ],
      "id": "TR-08-2105",
      "t": "Silver-Lined Milky Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        185,
        139,
        160
      ],
      "id": "TR-08-PF2105",
      "t": "PermaFinish - Silver-Lined Milky Baby Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        172,
        91,
        125
      ],
      "id": "TR-08-2106",
      "t": "Silver-Lined Milky Mauve",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        166,
        78,
        155
      ],
      "id": "TR-08-2107",
      "t": "Silver-Lined Milky Hot Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        233,
        79,
        144
      ],
      "id": "TR-08-PF2107",
      "t": "PermaFinish - Silver-Lined Milky Electric Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        202,
        165,
        215
      ],
      "id": "TR-08-2108",
      "t": "Silver-Lined Milky Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        116,
        86,
        111
      ],
      "id": "TR-08-PF2108",
      "t": "PermaFinish - Silver-Lined Milky Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        237,
        233,
        153
      ],
      "id": "TR-08-PF2109",
      "t": "PermaFinish - Silver-Lined Milky Jonquil",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        235,
        186,
        119
      ],
      "id": "TR-08-2110",
      "t": "Silver-Lined Milky Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        241,
        208,
        163
      ],
      "id": "TR-08-PF2110",
      "t": "PermaFinish - Silver-Lined Milky Lt Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        246,
        179,
        152
      ],
      "id": "TR-08-2111",
      "t": "Silver-Lined Milky Peach",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        250,
        201,
        166
      ],
      "id": "TR-08-PF2111",
      "t": "PermaFinish - Silver-Lined Milky Peach",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        232,
        148,
        108
      ],
      "id": "TR-08-PF2112",
      "t": "PermaFinish - Silver-Lined Milky Grapefruit",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        190,
        90,
        103
      ],
      "id": "TR-08-2113",
      "t": "Silver-Lined Milky Pomegranate",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        146,
        77,
        70
      ],
      "id": "TR-08-PF2113",
      "t": "PermaFinish - Silver-Lined Milky Pomegranate",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        177,
        128,
        133
      ],
      "id": "TR-08-2114",
      "t": "Silver-Lined Milky Nutmeg",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        145,
        123,
        111
      ],
      "id": "TR-08-PF2114",
      "t": "PermaFinish - Silver-Lined Milky Nutmeg",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        129,
        140,
        137
      ],
      "id": "TR-08-2115",
      "t": "Silver-Lined Milky Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        146,
        187,
        191
      ],
      "id": "TR-08-2116",
      "t": "Silver-Lined Milky Lt Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        159,
        211,
        202
      ],
      "id": "TR-08-PF2116",
      "t": "PermaFinish - Translucent Silver-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        43,
        199,
        213
      ],
      "id": "TR-08-2117",
      "t": "Silver-Lined Milky Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        209,
        237,
        219
      ],
      "id": "TR-08-2118",
      "t": "Silver-Lined Milky Lt Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        134,
        222,
        194
      ],
      "id": "TR-08-PF2118",
      "t": "PermaFinish - Silver-Lined Milky Lt Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        58,
        186,
        165
      ],
      "id": "TR-08-2119",
      "t": "Silver-Lined Milky Dk Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        253,
        215,
        222
      ],
      "id": "TR-08-PF2120",
      "t": "PermaFinish - Silver-Lined Milky Soft Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        152,
        161,
        189
      ],
      "id": "TR-08-2122",
      "t": "Silver-Lined Milky Alexandrite",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        133,
        143,
        204
      ],
      "id": "TR-08-2123",
      "t": "Silver-Lined Milky Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        134,
        150,
        209
      ],
      "id": "TR-08-PF2123",
      "t": "PermaFinish - Silver-Lined Milky Sapphire",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        127,
        128,
        171
      ],
      "id": "TR-08-2124",
      "t": "Silver-Lined Milky Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        245,
        236,
        205
      ],
      "id": "TR-08-2125",
      "t": "Silver-Lined Milky Lt Jonquil",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        230,
        239,
        206
      ],
      "id": "TR-08-PF2125",
      "t": "PermaFinish - Silver-Lined Milky Lt Jonquil",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        243,
        213,
        186
      ],
      "id": "TR-08-PF2126",
      "t": "PermaFinish - Silver-Lined Milky Peachy Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        164,
        145,
        59
      ],
      "id": "TR-08-2151",
      "t": "Transparent Champagne",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        159,
        147,
        54
      ],
      "id": "TR-08-2151S",
      "t": "Silver-Lined Champagne",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        154,
        103,
        32
      ],
      "id": "TR-08-2152S",
      "t": "Silver-Lined Sasparilla",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        62,
        52,
        47
      ],
      "id": "TR-08-2153",
      "t": "Inside-Color Transparent Ruby Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        91,
        45,
        23
      ],
      "id": "TR-08-2154",
      "t": "Transparent Marmalade",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        126,
        86,
        50
      ],
      "id": "TR-08-2154S",
      "t": "Silver-Lined Marmalade",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        192,
        136,
        17
      ],
      "id": "TR-08-2155",
      "t": "Transparent Chamomile",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        93,
        66,
        23
      ],
      "id": "TR-08-2156",
      "t": "Transparent Honey",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        108,
        77,
        23
      ],
      "id": "TR-08-2156S",
      "t": "Silver-Lined Transparent Honey",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        204,
        110,
        102
      ],
      "id": "TR-08-2201",
      "t": "Silver-Lined Almond Blossom",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        75,
        99,
        75
      ],
      "id": "TR-08-2202",
      "t": "Silver-Lined Prairie Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        24,
        40,
        85
      ],
      "id": "TR-08-2203",
      "t": "Silver-Lined Navy",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        132,
        125,
        100
      ],
      "id": "TR-08-2204",
      "t": "Dyed Silver-Lined Pink Frosted Olivine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        38,
        26,
        22
      ],
      "id": "TR-08-2205",
      "t": "Silver-Lined Root Beer",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        27,
        34,
        152
      ],
      "id": "TR-08-2206C",
      "t": "Silver-Lined Dk Aqua",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        199,
        80,
        21
      ],
      "id": "TR-08-2208",
      "t": "Silver-Lined Burnt Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        28,
        27,
        15
      ],
      "id": "TR-08-2210",
      "t": "Silver-Lined Jet",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        182,
        57,
        81
      ],
      "id": "TR-08-2218",
      "t": "Silver-Lined Mauve",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        120,
        75,
        105
      ],
      "id": "TR-08-2219",
      "t": "Silver-Lined Lt Grape",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        80,
        47,
        55
      ],
      "id": "TR-08-2223",
      "t": "Silver-Lined Dragonfruit",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        125,
        84,
        154
      ],
      "id": "TR-08-2224",
      "t": "Silver-Lined Purple",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        229,
        240,
        224
      ],
      "id": "TR-08-2500",
      "t": "Reflection - White",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        165,
        174,
        175
      ],
      "id": "TR-08-2501",
      "t": "Reflection - Gray",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        226,
        240,
        228
      ],
      "id": "TR-08-2502",
      "t": "Reflection - Honeydew",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        182,
        238,
        150
      ],
      "id": "TR-08-2503",
      "t": "Reflection - Neon Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        238,
        223,
        170
      ],
      "id": "TR-08-2504",
      "t": "Reflection - Cream",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        251,
        206,
        152
      ],
      "id": "TR-08-2505",
      "t": "Reflection - Cantaloupe",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        236,
        195,
        231
      ],
      "id": "TR-08-2508",
      "t": "Reflection - Orchid",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        156,
        152,
        15
      ],
      "id": "TR-08-2600F",
      "t": "Semi Glazed - Lemongrass",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        112,
        110,
        10
      ],
      "id": "TR-08-2601F",
      "t": "Semi Glazed - Olive",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        132,
        141,
        79
      ],
      "id": "TR-08-2602F",
      "t": "Semi Glazed - Honeydew",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        83,
        109,
        51
      ],
      "id": "TR-08-2603F",
      "t": "Semi Glazed - Clover",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        109,
        143,
        142
      ],
      "id": "TR-08-2604F",
      "t": "Semi Glazed - Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        79,
        99,
        108
      ],
      "id": "TR-08-2605F",
      "t": "Semi Glazed - Blue Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        119,
        130,
        183
      ],
      "id": "TR-08-2606F",
      "t": "Semi Glazed - Soft Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        52,
        56,
        110
      ],
      "id": "TR-08-2607F",
      "t": "Semi Glazed - Navy Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        123,
        112,
        112
      ],
      "id": "TR-08-2608F",
      "t": "Semi Glazed - Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        101,
        35,
        28
      ],
      "id": "TR-08-2609F",
      "t": "Semi Glazed - Dk Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        103,
        41,
        22
      ],
      "id": "TR-08-2610F",
      "t": "Semi Glazed - Burnt Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        153,
        57,
        23
      ],
      "id": "TR-08-2611F",
      "t": "Semi Glazed - Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        177,
        172,
        79
      ],
      "id": "TR-08-2630F",
      "t": "Semi Glazed Rainbow - Lemongrass",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        141,
        145,
        96
      ],
      "id": "TR-08-2631F",
      "t": "Semi Glazed Rainbow - Olive",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        160,
        168,
        129
      ],
      "id": "TR-08-2632F",
      "t": "Semi Glazed Rainbow - Honeydew",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        104,
        126,
        103
      ],
      "id": "TR-08-2633F",
      "t": "Semi Glazed Rainbow - Clover",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        114,
        145,
        159
      ],
      "id": "TR-08-2634F",
      "t": "Semi Glazed Rainbow - Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        111,
        128,
        144
      ],
      "id": "TR-08-2635F",
      "t": "Semi Glazed Rainbow - Blue Turquoise",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        134,
        142,
        179
      ],
      "id": "TR-08-2636F",
      "t": "Semi Glazed Rainbow - Soft Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        137,
        126,
        144
      ],
      "id": "TR-08-2637F",
      "t": "Semi Glazed Rainbow - Navy Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        144,
        133,
        147
      ],
      "id": "TR-08-2638F",
      "t": "Semi Glazed Rainbow - Lavender",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        99,
        69,
        96
      ],
      "id": "TR-08-2639F",
      "t": "Semi Glazed Rainbow - Dk Red",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        122,
        86,
        81
      ],
      "id": "TR-08-2640F",
      "t": "Semi Glazed Rainbow - Burnt Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        163,
        113,
        102
      ],
      "id": "TR-08-2641F",
      "t": "Semi Glazed Rainbow - Orange",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        169,
        176,
        158
      ],
      "id": "TR-08-2700",
      "t": "Glow In The Dark - Crystal/Glow Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        170,
        178,
        166
      ],
      "id": "TR-08-PF2700S",
      "t": "Glow In The Dark - Silver-Lined Crystal/Glow Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        184,
        183,
        178
      ],
      "id": "TR-08-2701",
      "t": "Glow In The Dark - Crystal/Glow Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        167,
        165,
        153
      ],
      "id": "TR-08-PF2701S",
      "t": "Glow In The Dark - Silver-Lined Crystal/Glow Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        190,
        201,
        168
      ],
      "id": "TR-08-2710",
      "t": "Glow In The Dark - Yellow Crystal/Bright Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        211,
        215,
        199
      ],
      "id": "TR-08-2711",
      "t": "Glow In The Dark - Crystal/Bright Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        193,
        141,
        138
      ],
      "id": "TR-08-2720",
      "t": "Glow In The Dark - Pink/Yellow Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        195,
        200,
        133
      ],
      "id": "TR-08-2721",
      "t": "Glow In The Dark - Yellow/Bright Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        171,
        205,
        180
      ],
      "id": "TR-08-2722",
      "t": "Glow In The Dark - Mint Green/Bright Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        163,
        205,
        195
      ],
      "id": "TR-08-2723",
      "t": "Glow In The Dark - Baby Blue/Bright Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        173,
        154,
        178
      ],
      "id": "TR-08-2724",
      "t": "Glow In The Dark - Dark Pink/Green Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        153,
        154,
        154
      ],
      "id": "TR-08-2725",
      "t": "Glow In The Dark - Gray Crystal/Bright Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        83,
        69,
        58
      ],
      "id": "TR-08-Y301F",
      "t": "HYBRID Frosted Natural - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        35,
        39,
        38
      ],
      "id": "TR-08-Y302",
      "t": "HYBRID Jet - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        42,
        45,
        45
      ],
      "id": "TR-08-Y302F",
      "t": "HYBRID Frosted Jet - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        83,
        40,
        33
      ],
      "id": "TR-08-Y304",
      "t": "HYBRID Pepper Red - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        59,
        35,
        32
      ],
      "id": "TR-08-Y304F",
      "t": "HYBRID Frosted Pepper Red - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        100,
        121,
        86
      ],
      "id": "TR-08-Y307",
      "t": "HYBRID Turquoise - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        102,
        116,
        70
      ],
      "id": "TR-08-Y309",
      "t": "HYBRID Opaque Cornflower - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        100,
        108,
        72
      ],
      "id": "TR-08-Y309F",
      "t": "HYBRID Opaque-Frosted Cornflower - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        137,
        139,
        62
      ],
      "id": "TR-08-Y310F",
      "t": "HYBRID Frosted Sour Apple - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        107,
        93,
        54
      ],
      "id": "TR-08-Y311F",
      "t": "HYBRID Opaque-Frosted Lavender - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        54,
        50,
        50
      ],
      "id": "TR-08-Y313",
      "t": "HYBRID Transparent Lt Topaz - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        84,
        64,
        29
      ],
      "id": "TR-08-Y315",
      "t": "HYBRID Transparent Lime Green - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        39,
        39,
        39
      ],
      "id": "TR-08-Y316",
      "t": "HYBRID Transparent Siam Ruby - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        33,
        32,
        34
      ],
      "id": "TR-08-Y316F",
      "t": "HYBRID Transparent Frosted Siam Ruby - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        73,
        57,
        43
      ],
      "id": "TR-08-Y317",
      "t": "HYBRID Transparent Lt Amethyst - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        63,
        53,
        48
      ],
      "id": "TR-08-Y317F",
      "t": "HYBRID Transparent Frosted Lt Amethyst - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        63,
        70,
        47
      ],
      "id": "TR-08-Y318",
      "t": "HYBRID Transparent Peridot - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        61,
        63,
        45
      ],
      "id": "TR-08-Y318F",
      "t": "HYBRID Transparent Frosted Peridot - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        99,
        90,
        26
      ],
      "id": "TR-08-Y319",
      "t": "HYBRID Opaque Dandelion - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        80,
        70,
        16
      ],
      "id": "TR-08-Y319F",
      "t": "HYBRID Opaque-Frosted Dandelion - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        111,
        134,
        56
      ],
      "id": "TR-08-Y321",
      "t": "HYBRID Opaque Mint Green - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        94,
        111,
        50
      ],
      "id": "TR-08-Y321F",
      "t": "HYBRID Opaque-Frosted Mint Green - Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        130,
        111,
        107
      ],
      "id": "TR-08-Y508F",
      "t": "HYBRID Opaque Luster - Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        243,
        240,
        238
      ],
      "id": "TR-08-Y610",
      "t": "HYBRID Sueded Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        74,
        108,
        97
      ],
      "id": "TR-08-Y614",
      "t": "HYBRID Metallic Suede - Lt Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        84,
        79,
        61
      ],
      "id": "TR-08-Y615",
      "t": "HYBRID Metallic Suede - Gold",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        35,
        30,
        38
      ],
      "id": "TR-08-Y617",
      "t": "HYBRID Metallic Suede - Pink",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        209,
        171,
        62
      ],
      "id": "TR-08-Y618",
      "t": "HYBRID Sueded Gold Topaz",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        124,
        186,
        254
      ],
      "id": "TR-08-Y619",
      "t": "HYBRID Sueded Gold Transparent Aquamarine",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        168,
        186,
        60
      ],
      "id": "TR-08-Y620",
      "t": "HYBRID Sueded Gold Transparent Lime Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        236,
        227,
        14
      ],
      "id": "TR-08-Y621",
      "t": "HYBRID Sueded Gold Opaque Dandelion",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        109,
        171,
        63
      ],
      "id": "TR-08-Y624",
      "t": "HYBRID Sueded Gold Opaque Mint Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        211,
        97,
        65
      ],
      "id": "TR-08-Y625",
      "t": "HYBRID Sueded Gold Siam Ruby",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        145,
        126,
        124
      ],
      "id": "TR-08-Y628",
      "t": "HYBRID Sueded Gold Transparent Amethyst",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        107,
        142,
        61
      ],
      "id": "TR-08-Y629",
      "t": "HYBRID Sueded Gold Transparent Peridot",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        239,
        238,
        217
      ],
      "id": "TR-08-Y630",
      "t": "HYBRID Sueded Gold Crystal",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        227,
        213,
        136
      ],
      "id": "TR-08-Y631",
      "t": "HYBRID Lt Sueded Gold Lt Lame'",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        97,
        108,
        95
      ],
      "id": "TR-08-Y632",
      "t": "HYBRID Sueded Gold Transparent Capri Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        43,
        42,
        38
      ],
      "id": "TR-08-Y633",
      "t": "HYBRID Metallic Suede - Dk Green",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        102,
        103,
        92
      ],
      "id": "TR-08-Y867",
      "t": "HYBRID Slate - Bronze Picasso",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        50,
        39,
        44
      ],
      "id": "TR-08-Y911",
      "t": "HYBRID Metallic Suede - Red Copper",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        65,
        65,
        56
      ],
      "id": "TR-08-Y912",
      "t": "HYBRID Polychrome - Olive Mauve",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        239,
        243,
        245
      ],
      "id": "TR-08-Y914",
      "t": "HYBRID Luster Snowflake",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        239,
        217,
        164
      ],
      "id": "TR-08-Y915",
      "t": "HYBRID Sueded Gold Opaque Lt. Beige",
      "dt": ""
    },
    {
      "a": 8,
      "b": 3,
      "c": [
        158,
        133,
        151
      ],
      "id": "TR-08-YPS0014",
      "t": "HYBRID ColorTrends: Metallic - Dusty Cedar",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        64,
        81,
        194
      ],
      "id": "TR-08-YPS0015",
      "t": "HYBRID ColorTrends: Metallic - Riverside",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        211,
        183,
        95
      ],
      "id": "TR-08-YPS0017",
      "t": "HYBRID ColorTrends: Metallic - Spicy Mustard",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        164,
        133,
        111
      ],
      "id": "TR-08-YPS0020",
      "t": "HYBRID ColorTrends: Metallic - Warm Taupe",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        120,
        83,
        186
      ],
      "id": "TR-08-YPS0021",
      "t": "HYBRID ColorTrends: Milky - Bodacious",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        122,
        101,
        127
      ],
      "id": "TR-08-YPS0023",
      "t": "HYBRID ColorTrends: Milky - Dusty Cedar",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        182,
        208,
        254
      ],
      "id": "TR-08-YPS0024",
      "t": "HYBRID ColorTrends: Milky - Airy Blue",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        41,
        96,
        49
      ],
      "id": "TR-08-YPS0028",
      "t": "HYBRID ColorTrends: Milky - Kale",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        121,
        151,
        108
      ],
      "id": "TR-08-YPS0033",
      "t": "HYBRID ColorTrends: Milky - Greenery",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        36,
        47,
        153
      ],
      "id": "TR-08-YPS0065",
      "t": "HYBRID ColorTrends: Milky - Riverside",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        44,
        129,
        96
      ],
      "id": "TR-08-YPS0066",
      "t": "HYBRID ColorTrends: Milky - Lush Meadow",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        202,
        175,
        117
      ],
      "id": "TR-08-YPS0067",
      "t": "HYBRID ColorTrends: Milky - Spicy Mustard",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        84,
        85,
        86
      ],
      "id": "TR-08-YPS0068",
      "t": "HYBRID ColorTrends: Milky - Shark Skin",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        111,
        71,
        59
      ],
      "id": "TR-08-YPS0069",
      "t": "HYBRID ColorTrends: Milky - Potters Clay",
      "dt": ""
    },
    {
      "a": 8,
      "b": 1,
      "c": [
        212,
        184,
        177
      ],
      "id": "TR-08-YPS0070",
      "t": "HYBRID ColorTrends: Milky - Warm Taupe",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        216,
        154,
        94
      ],
      "id": "TR-08-YPS0082",
      "t": "HYBRID ColorTrends: Metallic - Flame",
      "dt": ""
    },
    {
      "a": 8,
      "b": 2,
      "c": [
        183,
        199,
        137
      ],
      "id": "TR-08-YPS0083",
      "t": "HYBRID ColorTrends: Metallic - Greenery",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        218,
        217,
        222
      ],
      "id": "TR-11-1",
      "t": "Transparent Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        233,
        232,
        227
      ],
      "id": "TR-11-1F",
      "t": "Transparent-Frosted Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        213,
        134,
        18
      ],
      "id": "TR-11-2",
      "t": "Transparent Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        208,
        140,
        40
      ],
      "id": "TR-11-2F",
      "t": "Transparent-Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        221,
        183,
        76
      ],
      "id": "TR-11-2AF",
      "t": "Transparent-Frosted Pale Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        185,
        146,
        45
      ],
      "id": "TR-11-2BF",
      "t": "Transparent Frosted Med Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        189,
        105,
        42
      ],
      "id": "TR-11-2C",
      "t": "Transparent Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        146,
        90,
        33
      ],
      "id": "TR-11-2CF",
      "t": "Transparent-Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        18,
        183,
        236
      ],
      "id": "TR-11-3",
      "t": "Transparent Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        5,
        175,
        241
      ],
      "id": "TR-11-3F",
      "t": "Transparent-Frosted Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        9,
        142,
        244
      ],
      "id": "TR-11-3B",
      "t": "Transparent Dk Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        1,
        158,
        254
      ],
      "id": "TR-11-3BF",
      "t": "Transparent-Frosted Med Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        70,
        123,
        229
      ],
      "id": "TR-11-3CF",
      "t": "Transparent-Frosted Dk Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        146,
        192,
        23
      ],
      "id": "TR-11-4",
      "t": "Transparent Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        160,
        207,
        56
      ],
      "id": "TR-11-4F",
      "t": "Transparent-Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        235,
        53,
        33
      ],
      "id": "TR-11-5",
      "t": "Transparent Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        240,
        24,
        26
      ],
      "id": "TR-11-5F",
      "t": "Transparent-Frosted Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        184,
        48,
        52
      ],
      "id": "TR-11-5B",
      "t": "Transparent Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        193,
        42,
        51
      ],
      "id": "TR-11-5BF",
      "t": "Transparent-Frosted Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        185,
        54,
        59
      ],
      "id": "TR-11-5C",
      "t": "Transparent Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        171,
        64,
        69
      ],
      "id": "TR-11-5CF",
      "t": "Transparent-Frosted Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        99,
        50,
        55
      ],
      "id": "TR-11-5D",
      "t": "Transparent Garnet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        169,
        127,
        144
      ],
      "id": "TR-11-6",
      "t": "Transparent Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        154,
        112,
        131
      ],
      "id": "TR-11-6F",
      "t": "Transparent-Frosted Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        58,
        29,
        52
      ],
      "id": "TR-11-6B",
      "t": "Transparent Med Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        113,
        71,
        93
      ],
      "id": "TR-11-6BF",
      "t": "Transparent-Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        92,
        72,
        79
      ],
      "id": "TR-11-6C",
      "t": "Transparent Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        74,
        58,
        71
      ],
      "id": "TR-11-6CF",
      "t": "Transparent-Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        39,
        150,
        50
      ],
      "id": "TR-11-7",
      "t": "Transparent Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        59,
        165,
        69
      ],
      "id": "TR-11-7F",
      "t": "Transparent-Frosted Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        48,
        122,
        66
      ],
      "id": "TR-11-7B",
      "t": "Transparent Grass Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        17,
        135,
        59
      ],
      "id": "TR-11-7BF",
      "t": "Transparent-Frosted Grass Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        22,
        99,
        116
      ],
      "id": "TR-11-7BD",
      "t": "Transparent Capri Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        19,
        87,
        90
      ],
      "id": "TR-11-7BDF",
      "t": "Transparent Frosted Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        35,
        24,
        89
      ],
      "id": "TR-11-8",
      "t": "Transparent Cobalt",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        45,
        29,
        97
      ],
      "id": "TR-11-8F",
      "t": "Transparent-Frosted Dk Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        28,
        27,
        63
      ],
      "id": "TR-11-8D",
      "t": "Transparent Cobalt",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        61,
        44,
        112
      ],
      "id": "TR-11-8DF",
      "t": "Transparent-Frosted Cobalt",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        134,
        142,
        141
      ],
      "id": "TR-11-9",
      "t": "Transparent Black Diamond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        126,
        134,
        132
      ],
      "id": "TR-11-9F",
      "t": "Transparent-Frosted Lt Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        107,
        115,
        113
      ],
      "id": "TR-11-9B",
      "t": "Transparent Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        248,
        97,
        28
      ],
      "id": "TR-11-10",
      "t": "Transparent Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        251,
        97,
        37
      ],
      "id": "TR-11-10B",
      "t": "Transparent Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        211,
        50,
        2
      ],
      "id": "TR-11-10BF",
      "t": "Transparent-Frosted Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        229,
        185,
        177
      ],
      "id": "TR-11-11",
      "t": "Transparent Rosaline",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        231,
        186,
        179
      ],
      "id": "TR-11-11F",
      "t": "Transparent-Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        234,
        218,
        58
      ],
      "id": "TR-11-12",
      "t": "Transparent Lemon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        220,
        207,
        43
      ],
      "id": "TR-11-12F",
      "t": "Transparent-Frosted Lemon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        103,
        131,
        208
      ],
      "id": "TR-11-13",
      "t": "Transparent Lt Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        121,
        156,
        236
      ],
      "id": "TR-11-13F",
      "t": "Transparent-Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        27,
        26,
        24
      ],
      "id": "TR-11-14",
      "t": "Transparent - Root Beer",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        196,
        217,
        141
      ],
      "id": "TR-11-15",
      "t": "Citrus Spritz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        221,
        236,
        184
      ],
      "id": "TR-11-15F",
      "t": "Transparent-Frosted Citrus Spritz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        129,
        110,
        149
      ],
      "id": "TR-11-19",
      "t": "Transparent Sugar Plum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        141,
        119,
        157
      ],
      "id": "TR-11-19F",
      "t": "Transparent-Frosted Sugar Plum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        219,
        216,
        206
      ],
      "id": "TR-11-21",
      "t": "Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        214,
        204,
        189
      ],
      "id": "TR-11-21F",
      "t": "Silver-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        222,
        219,
        214
      ],
      "id": "TR-11-PF21F",
      "t": "PermaFinish - Silver-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        219,
        205,
        184
      ],
      "id": "TR-11-PF21",
      "t": "PermaFinish - Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        228,
        192,
        105
      ],
      "id": "TR-11-22",
      "t": "Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        211,
        184,
        121
      ],
      "id": "TR-11-22F",
      "t": "Silver-Lined Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        216,
        160,
        83
      ],
      "id": "TR-11-22B",
      "t": "Silver-Lined Med Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        219,
        182,
        90
      ],
      "id": "TR-11-22BF",
      "t": "Silver-Lined Frosted Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        198,
        150,
        79
      ],
      "id": "TR-11-22C",
      "t": "Silver-Lined Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        192,
        129,
        49
      ],
      "id": "TR-11-22CF",
      "t": "Silver-Lined Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        222,
        170,
        69
      ],
      "id": "TR-11-PF22",
      "t": "PermaFinish - Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        127,
        212,
        218
      ],
      "id": "TR-11-23",
      "t": "Silver-Lined Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        124,
        190,
        201
      ],
      "id": "TR-11-23F",
      "t": "Silver-Lined Frosted Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        73,
        183,
        208
      ],
      "id": "TR-11-23B",
      "t": "Silver-Lined Dk Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        31,
        151,
        204
      ],
      "id": "TR-11-23BF",
      "t": "Silver-Lined Frosted Dk Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        13,
        149,
        148
      ],
      "id": "TR-11-23BDA",
      "t": "Silver-Lined Aqua Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        28,
        163,
        167
      ],
      "id": "TR-11-23BDAF",
      "t": "Silver-Lined Lt. Green Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        8,
        96,
        162
      ],
      "id": "TR-11-23C",
      "t": "Silver-Lined Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        179,
        196,
        68
      ],
      "id": "TR-11-24",
      "t": "Silver-Lined Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        42,
        165,
        120
      ],
      "id": "TR-11-24B",
      "t": "Silver-Lined Dk Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        64,
        172,
        142
      ],
      "id": "TR-11-24BF",
      "t": "Silver-Lined Frosted Dk Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        234,
        75,
        67
      ],
      "id": "TR-11-25",
      "t": "Silver-Lined Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        211,
        38,
        33
      ],
      "id": "TR-11-25F",
      "t": "Silver-Lined Frosted Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        196,
        59,
        55
      ],
      "id": "TR-11-25B",
      "t": "Silver-Lined Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        220,
        48,
        44
      ],
      "id": "TR-11-25BF",
      "t": "Silver-Lined Frosted Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        178,
        49,
        51
      ],
      "id": "TR-11-25C",
      "t": "Silver-Lined Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        112,
        22,
        15
      ],
      "id": "TR-11-25CF",
      "t": "Silver-Lined Frosted Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        129,
        79,
        79
      ],
      "id": "TR-11-25D",
      "t": "Silver-Lined Garnet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        206,
        172,
        169
      ],
      "id": "TR-11-26",
      "t": "Silver-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        161,
        116,
        119
      ],
      "id": "TR-11-26B",
      "t": "Silver-Lined Med Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        163,
        114,
        126
      ],
      "id": "TR-11-26BF",
      "t": "Silver-Lined Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        116,
        92,
        93
      ],
      "id": "TR-11-26C",
      "t": "Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        159,
        114,
        114
      ],
      "id": "TR-11-26CF",
      "t": "Silver-Lined Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        70,
        169,
        56
      ],
      "id": "TR-11-27",
      "t": "Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        126,
        189,
        88
      ],
      "id": "TR-11-27F",
      "t": "Silver-Lined Frosted Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        61,
        138,
        74
      ],
      "id": "TR-11-27B",
      "t": "Silver-Lined Grass Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        28,
        62,
        62
      ],
      "id": "TR-11-27BD",
      "t": "Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        48,
        56,
        158
      ],
      "id": "TR-11-28",
      "t": "Silver-Lined Cobalt",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        84,
        66,
        159
      ],
      "id": "TR-11-28F",
      "t": "Silver-Lined Frosted Dk Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        98,
        70,
        163
      ],
      "id": "TR-11-28DF",
      "t": "Silver-Lined Frosted Cobalt",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        184,
        181,
        166
      ],
      "id": "TR-11-29AF",
      "t": "Silver-Lined Frosted Black Diamond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        139,
        142,
        136
      ],
      "id": "TR-11-29B",
      "t": "Silver-Lined Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        144,
        139,
        117
      ],
      "id": "TR-11-29BF",
      "t": "Silver-Lined Frosted Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        208,
        138,
        17
      ],
      "id": "TR-11-30",
      "t": "Silver-Lined Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        242,
        90,
        13
      ],
      "id": "TR-11-30B",
      "t": "Silver-Lined Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        238,
        122,
        54
      ],
      "id": "TR-11-30BF",
      "t": "Silver-Lined Frosted Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        231,
        193,
        168
      ],
      "id": "TR-11-31",
      "t": "Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        234,
        200,
        190
      ],
      "id": "TR-11-31F",
      "t": "Silver-Lined Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        232,
        215,
        34
      ],
      "id": "TR-11-32",
      "t": "Silver-Lined Lemon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        224,
        202,
        32
      ],
      "id": "TR-11-32F",
      "t": "Silver-Lined Frosted Lemon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        139,
        156,
        184
      ],
      "id": "TR-11-33",
      "t": "Silver-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        157,
        181,
        228
      ],
      "id": "TR-11-33F",
      "t": "Silver-Lined Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        85,
        43,
        23
      ],
      "id": "TR-11-34",
      "t": "Silver-Lined Smoky Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        202,
        126,
        37
      ],
      "id": "TR-11-34F",
      "t": "Silver-Lined Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        96,
        94,
        197
      ],
      "id": "TR-11-35",
      "t": "Silver-Lined Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        125,
        134,
        215
      ],
      "id": "TR-11-35F",
      "t": "Silver-Lined Frosted Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        81,
        159,
        110
      ],
      "id": "TR-11-36",
      "t": "Silver-Lined Green Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        67,
        160,
        103
      ],
      "id": "TR-11-36F",
      "t": "Silver-Lined Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        108,
        129,
        81
      ],
      "id": "TR-11-37",
      "t": "Silver-Lined Olivine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        136,
        152,
        82
      ],
      "id": "TR-11-37F",
      "t": "Silver-Lined Frosted Olive",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        248,
        123,
        171
      ],
      "id": "TR-11-38",
      "t": "Silver-Lined Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        181,
        168,
        172
      ],
      "id": "TR-11-39",
      "t": "Silver-Lined Tanzanite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        162,
        148,
        153
      ],
      "id": "TR-11-39F",
      "t": "Silver-Lined Frosted Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        242,
        242,
        238
      ],
      "id": "TR-11-41",
      "t": "Opaque White",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        240,
        240,
        239
      ],
      "id": "TR-11-41F",
      "t": "Opaque-Frosted White",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        227,
        210,
        29
      ],
      "id": "TR-11-42",
      "t": "Opaque Dandelion",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        245,
        224,
        53
      ],
      "id": "TR-11-42F",
      "t": "Opaque-Frosted Dandelion",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        241,
        174,
        7
      ],
      "id": "TR-11-42B",
      "t": "Opaque Sunshine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        250,
        223,
        25
      ],
      "id": "TR-11-42BF",
      "t": "Opaque-Frosted Sunshine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        249,
        132,
        13
      ],
      "id": "TR-11-42DF",
      "t": "Opaque-Frosted Cantaloupe",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        128,
        215,
        240
      ],
      "id": "TR-11-43",
      "t": "Opaque Blue Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        107,
        212,
        243
      ],
      "id": "TR-11-43F",
      "t": "Opaque-Frosted Blue Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        87,
        123,
        231
      ],
      "id": "TR-11-43D",
      "t": "Opaque Cornflower",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        102,
        135,
        202
      ],
      "id": "TR-11-43DF",
      "t": "Opaque-Frosted Cornflower",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        192,
        220,
        114
      ],
      "id": "TR-11-44",
      "t": "Opaque Sour Apple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        187,
        219,
        122
      ],
      "id": "TR-11-44F",
      "t": "Opaque-Frosted Sour Apple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        137,
        41,
        32
      ],
      "id": "TR-11-45",
      "t": "Opaque Pepper Red",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        147,
        53,
        44
      ],
      "id": "TR-11-45F",
      "t": "Opaque-Frosted Pepper Red",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        236,
        58,
        59
      ],
      "id": "TR-11-45A",
      "t": "Opaque Cherry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        236,
        23,
        26
      ],
      "id": "TR-11-45AF",
      "t": "Opaque-Frosted Cherry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        94,
        51,
        40
      ],
      "id": "TR-11-46",
      "t": "Opaque Oxblood",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        91,
        54,
        50
      ],
      "id": "TR-11-46F",
      "t": "Opaque-Frosted Oxblood",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        184,
        93,
        60
      ],
      "id": "TR-11-46L",
      "t": "Opaque Terra Cotta",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        171,
        59,
        24
      ],
      "id": "TR-11-46LF",
      "t": "Opaque-Frosted Terra Cotta",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        68,
        202,
        90
      ],
      "id": "TR-11-47",
      "t": "Opaque Mint Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        92,
        202,
        108
      ],
      "id": "TR-11-47F",
      "t": "Opaque-Frosted Mint Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        46,
        200,
        130
      ],
      "id": "TR-11-47D",
      "t": "Opaque Shamrock",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        59,
        199,
        124
      ],
      "id": "TR-11-47DF",
      "t": "Opaque-Frosted Shamrock",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        53,
        133,
        88
      ],
      "id": "TR-11-47H",
      "t": "Opaque Pine Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        62,
        128,
        72
      ],
      "id": "TR-11-47HF",
      "t": "Opaque-Frosted Pine Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        65,
        57,
        160
      ],
      "id": "TR-11-48",
      "t": "Opaque Navy Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        68,
        58,
        171
      ],
      "id": "TR-11-48F",
      "t": "Opaque-Frosted Navy Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        114,
        129,
        229
      ],
      "id": "TR-11-48L",
      "t": "Opaque Periwinkle",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        19,
        20,
        23
      ],
      "id": "TR-11-49",
      "t": "Opaque Jet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        60,
        60,
        61
      ],
      "id": "TR-11-49F",
      "t": "Opaque-Frosted Jet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        252,
        71,
        33
      ],
      "id": "TR-11-50",
      "t": "Opaque Sunset Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        248,
        73,
        36
      ],
      "id": "TR-11-50F",
      "t": "Opaque-Frosted Sunset Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        235,
        97,
        23
      ],
      "id": "TR-11-50A",
      "t": "Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        254,
        93,
        66
      ],
      "id": "TR-11-50AF",
      "t": "Opaque-Frosted Pumpkin",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        242,
        232,
        217
      ],
      "id": "TR-11-51",
      "t": "Opaque Lt Beige",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        240,
        233,
        215
      ],
      "id": "TR-11-51F",
      "t": "Opaque-Frosted Lt Beige",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        122,
        105,
        121
      ],
      "id": "TR-11-52",
      "t": "Opaque Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        199,
        174,
        188
      ],
      "id": "TR-11-52F",
      "t": "Opaque-Frosted Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        196,
        199,
        198
      ],
      "id": "TR-11-53",
      "t": "Opaque Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        195,
        198,
        198
      ],
      "id": "TR-11-53F",
      "t": "Opaque-Frosted Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        62,
        182,
        167
      ],
      "id": "TR-11-55",
      "t": "Opaque Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        91,
        215,
        207
      ],
      "id": "TR-11-55F",
      "t": "Opaque-Frosted Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        21,
        165,
        114
      ],
      "id": "TR-11-72",
      "t": "Transparent Beach Glass Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        4,
        166,
        108
      ],
      "id": "TR-11-72F",
      "t": "Transparent-Frosted Dk Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        106,
        114,
        132
      ],
      "id": "TR-11-81",
      "t": "Metallic Hematite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        72,
        58,
        136
      ],
      "id": "TR-11-82",
      "t": "Metallic Nebula",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        74,
        86,
        110
      ],
      "id": "TR-11-82F",
      "t": "Frosted Metallic Nebula",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        130,
        125,
        97
      ],
      "id": "TR-11-83",
      "t": "Metallic Iris - Brown",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        134,
        121,
        93
      ],
      "id": "TR-11-83F",
      "t": "Frosted Metallic Iris - Brown",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        135,
        159,
        130
      ],
      "id": "TR-11-84",
      "t": "Metallic Iris - Green/Brown",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        127,
        146,
        130
      ],
      "id": "TR-11-84F",
      "t": "Frosted Metallic Iris - Green/Brown",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        128,
        92,
        96
      ],
      "id": "TR-11-85",
      "t": "Metallic Iris - Purple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        111,
        79,
        82
      ],
      "id": "TR-11-85F",
      "t": "Frosted Metallic Iris - Purple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        115,
        101,
        121
      ],
      "id": "TR-11-86",
      "t": "Metallic Rainbow Iris",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        138,
        135,
        154
      ],
      "id": "TR-11-86F",
      "t": "Opaque-Frosted-Rainbow Iris",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        140,
        127,
        208
      ],
      "id": "TR-11-87",
      "t": "Transparent-Rainbow Cobalt",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        112,
        101,
        218
      ],
      "id": "TR-11-87F",
      "t": "Transparent-Rainbow Frosted Dk Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        126,
        136,
        193
      ],
      "id": "TR-11-87DF",
      "t": "Transparent-Rainbow Frosted Cobalt",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        99,
        129,
        167
      ],
      "id": "TR-11-88",
      "t": "Metallic Cosmos",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        99,
        112,
        98
      ],
      "id": "TR-11-89",
      "t": "Metallic Moss",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        132,
        113,
        133
      ],
      "id": "TR-11-90",
      "t": "Metallic Amethyst Gun Metal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        229,
        229,
        227
      ],
      "id": "TR-11-101",
      "t": "Transparent-Lustered Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        203,
        167,
        96
      ],
      "id": "TR-11-103B",
      "t": "Transparent-Lustered Med Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        97,
        211,
        245
      ],
      "id": "TR-11-104",
      "t": "Transparent-Lustered Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        184,
        205,
        118
      ],
      "id": "TR-11-105",
      "t": "Transparent-Lustered Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        225,
        199,
        197
      ],
      "id": "TR-11-106",
      "t": "Transparent-Lustered Rosaline",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        62,
        171,
        117
      ],
      "id": "TR-11-108",
      "t": "Transparent-Lustered Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        117,
        179,
        195
      ],
      "id": "TR-11-108BD",
      "t": "Transparent-Lustered Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        202,
        115,
        138
      ],
      "id": "TR-11-109",
      "t": "Luster Crystal/Tropical Sunset-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        187,
        169,
        180
      ],
      "id": "TR-11-110B",
      "t": "Transparent-Lustered Med Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        161,
        172,
        175
      ],
      "id": "TR-11-112",
      "t": "Transparent-Lustered Black Diamond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        155,
        133,
        137
      ],
      "id": "TR-11-114",
      "t": "Transparent-Lustered Smoky Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        128,
        109,
        123
      ],
      "id": "TR-11-115",
      "t": "Transparent-Lustered Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        137,
        142,
        226
      ],
      "id": "TR-11-116",
      "t": "Transparent-Lustered Cobalt",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        100,
        99,
        234
      ],
      "id": "TR-11-117",
      "t": "Transparent-Lustered Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        38,
        77,
        75
      ],
      "id": "TR-11-118",
      "t": "Transparent-Lustered Green Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        103,
        131,
        125
      ],
      "id": "TR-11-119",
      "t": "Transparent-Lustered Olivine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        248,
        247,
        249
      ],
      "id": "TR-11-121",
      "t": "Opaque-Lustered White",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        230,
        222,
        201
      ],
      "id": "TR-11-122",
      "t": "Opaque-Lustered Navajo White",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        225,
        205,
        179
      ],
      "id": "TR-11-123",
      "t": "Opaque-Lustered Lt Beige",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        218,
        168,
        111
      ],
      "id": "TR-11-123D",
      "t": "Opaque-Lustered Dk Beige",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        168,
        208,
        223
      ],
      "id": "TR-11-124",
      "t": "Opaque-Lustered Pale Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        202,
        78,
        81
      ],
      "id": "TR-11-125",
      "t": "Opaque-Lustered Cherry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        241,
        197,
        204
      ],
      "id": "TR-11-126",
      "t": "Opaque-Lustered Baby Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        203,
        165,
        186
      ],
      "id": "TR-11-127",
      "t": "Opaque-Lustered Pale Mauve",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        225,
        212,
        88
      ],
      "id": "TR-11-128",
      "t": "Opaque-Lustered Dandelion",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        252,
        144,
        50
      ],
      "id": "TR-11-128D",
      "t": "Opaque Lustered-Tangerine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        231,
        144,
        113
      ],
      "id": "TR-11-129",
      "t": "Opaque-Lustered Pumpkin",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        130,
        192,
        147
      ],
      "id": "TR-11-130",
      "t": "Opaque-Lustered Mint Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        186,
        212,
        149
      ],
      "id": "TR-11-131",
      "t": "Opaque-Lustered Sour Apple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        88,
        189,
        182
      ],
      "id": "TR-11-132",
      "t": "Opaque-Lustered Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        152,
        136,
        149
      ],
      "id": "TR-11-133",
      "t": "Opaque-Lustered Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        92,
        91,
        117
      ],
      "id": "TR-11-136",
      "t": "Transparent-Lustered Sugar Plum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        238,
        237,
        237
      ],
      "id": "TR-11-141",
      "t": "Ceylon Snowflake",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        215,
        215,
        215
      ],
      "id": "TR-11-141F",
      "t": "Ceylon Frosted Snowflake",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        230,
        224,
        190
      ],
      "id": "TR-11-142",
      "t": "Ceylon Banana Cream",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        224,
        219,
        179
      ],
      "id": "TR-11-142F",
      "t": "Ceylon Frosted Banana Cream",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        180,
        216,
        226
      ],
      "id": "TR-11-143",
      "t": "Ceylon Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        165,
        213,
        226
      ],
      "id": "TR-11-143F",
      "t": "Ceylon Frosted Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        139,
        202,
        182
      ],
      "id": "TR-11-144",
      "t": "Ceylon Celery",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        114,
        211,
        183
      ],
      "id": "TR-11-144F",
      "t": "Ceylon Frosted Celery",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        253,
        200,
        216
      ],
      "id": "TR-11-145",
      "t": "Ceylon Innocent Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        246,
        178,
        193
      ],
      "id": "TR-11-145F",
      "t": "Ceylon Frosted Innocent Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        230,
        205,
        207
      ],
      "id": "TR-11-145L",
      "t": "Ceylon Soft Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        132,
        168,
        210
      ],
      "id": "TR-11-146",
      "t": "Ceylon Glacier",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        140,
        175,
        235
      ],
      "id": "TR-11-146F",
      "t": "Ceylon Frosted Glacier",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        231,
        214,
        193
      ],
      "id": "TR-11-147",
      "t": "Ceylon Lt Ivory",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        222,
        201,
        182
      ],
      "id": "TR-11-147F",
      "t": "Ceylon Frosted Lt Ivory",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        231,
        189,
        135
      ],
      "id": "TR-11-148",
      "t": "Ceylon Peach Cobbler",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        254,
        179,
        46
      ],
      "id": "TR-11-148F",
      "t": "Ceylon Frosted Peach Cobbler",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        121,
        126,
        133
      ],
      "id": "TR-11-150",
      "t": "Ceylon Smoke",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        166,
        175,
        176
      ],
      "id": "TR-11-150F",
      "t": "Ceylon Frosted Smoke",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        168,
        137,
        155
      ],
      "id": "TR-11-151",
      "t": "Ceylon Grape Mist",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        175,
        149,
        162
      ],
      "id": "TR-11-151F",
      "t": "Ceylon Frosted Grape Mist",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        219,
        218,
        215
      ],
      "id": "TR-11-161",
      "t": "Transparent-Rainbow Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        221,
        216,
        217
      ],
      "id": "TR-11-161F",
      "t": "Transparent-Rainbow Frosted Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        224,
        178,
        111
      ],
      "id": "TR-11-162F",
      "t": "Transparent-Rainbow Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        215,
        154,
        96
      ],
      "id": "TR-11-162B",
      "t": "Transparent-Rainbow Med Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        170,
        113,
        87
      ],
      "id": "TR-11-162C",
      "t": "Transparent-Rainbow Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        212,
        169,
        115
      ],
      "id": "TR-11-162CF",
      "t": "Transparent-Rainbow Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        110,
        214,
        240
      ],
      "id": "TR-11-163",
      "t": "Transparent-Rainbow Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        57,
        171,
        236
      ],
      "id": "TR-11-163B",
      "t": "Transparent-Rainbow Dk Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        87,
        183,
        243
      ],
      "id": "TR-11-163BF",
      "t": "Transparent-Rainbow Frosted Dk Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        187,
        223,
        126
      ],
      "id": "TR-11-164",
      "t": "Transparent-Rainbow Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        197,
        216,
        111
      ],
      "id": "TR-11-164F",
      "t": "Transparent-Rainbow Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        37,
        174,
        143
      ],
      "id": "TR-11-164B",
      "t": "Transparent-Rainbow Dk Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        37,
        197,
        176
      ],
      "id": "TR-11-164BF",
      "t": "Transparent-Rainbow Frosted Dk Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        210,
        73,
        105
      ],
      "id": "TR-11-165B",
      "t": "Transparent-Rainbow Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        225,
        130,
        160
      ],
      "id": "TR-11-165BF",
      "t": "Transparent-Rainbow Frosted Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        222,
        72,
        102
      ],
      "id": "TR-11-165C",
      "t": "Transparent-Rainbow Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        218,
        134,
        134
      ],
      "id": "TR-11-165CF",
      "t": "Transparent-Rainbow Frosted Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        199,
        165,
        179
      ],
      "id": "TR-11-166",
      "t": "Transparent Rainbow Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        201,
        172,
        179
      ],
      "id": "TR-11-166F",
      "t": "Transparent Rainbow Frosted Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        161,
        130,
        150
      ],
      "id": "TR-11-166B",
      "t": "Transparent Rainbow Med Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        187,
        158,
        183
      ],
      "id": "TR-11-166BF",
      "t": "Transparent Rainbow Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        129,
        132,
        141
      ],
      "id": "TR-11-166C",
      "t": "Transparent Rainbow Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        156,
        155,
        163
      ],
      "id": "TR-11-166CF",
      "t": "Transparent Rainbow Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        141,
        149,
        155
      ],
      "id": "TR-11-166D",
      "t": "Transparent Rainbow Sugar Plum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        173,
        167,
        183
      ],
      "id": "TR-11-166DF",
      "t": "Transparent Rainbow Frosted Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        102,
        204,
        163
      ],
      "id": "TR-11-167",
      "t": "Transparent-Rainbow Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        97,
        192,
        135
      ],
      "id": "TR-11-167F",
      "t": "Transparent-Rainbow Frosted Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        82,
        166,
        116
      ],
      "id": "TR-11-167B",
      "t": "Transparent-Rainbow Grass Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        47,
        107,
        64
      ],
      "id": "TR-11-167BF",
      "t": "Transparent-Rainbow Frosted Grass Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        60,
        150,
        179
      ],
      "id": "TR-11-167BD",
      "t": "Transparent-Rainbow Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        97,
        158,
        160
      ],
      "id": "TR-11-167BDF",
      "t": "Transparent-Rainbow Frosted Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        156,
        187,
        234
      ],
      "id": "TR-11-168",
      "t": "Transparent-Rainbow Lt Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        154,
        183,
        241
      ],
      "id": "TR-11-168F",
      "t": "Transparent-Rainbow Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        230,
        186,
        189
      ],
      "id": "TR-11-169",
      "t": "Transparent-Rainbow Rosaline",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        237,
        195,
        183
      ],
      "id": "TR-11-169F",
      "t": "Transparent-Rainbow Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        249,
        196,
        208
      ],
      "id": "TR-11-171",
      "t": "Dyed-Rainbow Ballerina Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        201,
        228,
        180
      ],
      "id": "TR-11-173",
      "t": "Dyed-Rainbow Lemon Mist",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        246,
        106,
        31
      ],
      "id": "TR-11-174",
      "t": "Transparent-Rainbow Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        251,
        126,
        81
      ],
      "id": "TR-11-174B",
      "t": "Transparent-Rainbow Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        241,
        83,
        41
      ],
      "id": "TR-11-174BF",
      "t": "Transparent-Rainbow Frosted Hyacinth",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        210,
        161,
        8
      ],
      "id": "TR-11-175",
      "t": "Transparent-Rainbow Lemon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        223,
        211,
        98
      ],
      "id": "TR-11-175F",
      "t": "Transparent-Rainbow Frosted Lemon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        177,
        190,
        189
      ],
      "id": "TR-11-176",
      "t": "Transparent-Rainbow Black Diamond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        119,
        133,
        137
      ],
      "id": "TR-11-176AF",
      "t": "Transparent-Rainbow Frosted Black Diamond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        154,
        174,
        165
      ],
      "id": "TR-11-176B",
      "t": "Transparent-Rainbow Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        165,
        170,
        178
      ],
      "id": "TR-11-176BF",
      "t": "Transparent-Rainbow Frosted Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        156,
        120,
        132
      ],
      "id": "TR-11-177",
      "t": "Transparent-Rainbow Smoky Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        180,
        142,
        142
      ],
      "id": "TR-11-177F",
      "t": "Transparent-Rainbow Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        178,
        170,
        245
      ],
      "id": "TR-11-178",
      "t": "Transparent-Rainbow Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        137,
        119,
        254
      ],
      "id": "TR-11-178F",
      "t": "Transparent-Rainbow Frosted Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        111,
        174,
        153
      ],
      "id": "TR-11-179",
      "t": "Transparent-Rainbow Green Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        122,
        156,
        138
      ],
      "id": "TR-11-179F",
      "t": "Transparent-Rainbow Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        113,
        158,
        152
      ],
      "id": "TR-11-180",
      "t": "Transparent-Rainbow Olivine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        145,
        174,
        151
      ],
      "id": "TR-11-180F",
      "t": "Transparent-Rainbow Frosted Olivine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        128,
        131,
        197
      ],
      "id": "TR-11-181",
      "t": "Inside-Color Rainbow Crystal/Tanzanite-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        226,
        212,
        153
      ],
      "id": "TR-11-182",
      "t": "Inside-Color Luster Crystal/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        114,
        192,
        212
      ],
      "id": "TR-11-183",
      "t": "Inside-Color Luster Crystal/Opaque Aqua-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        102,
        210,
        151
      ],
      "id": "TR-11-184",
      "t": "Inside-Color Luster Crystal/Spearmint-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        243,
        98,
        118
      ],
      "id": "TR-11-185",
      "t": "Inside-Color Luster Crystal/Poppy-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        191,
        118,
        124
      ],
      "id": "TR-11-186",
      "t": "Inside-Color Luster Crystal/Terra Cotta-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        61,
        166,
        134
      ],
      "id": "TR-11-187",
      "t": "Inside-Color Crystal/Shamrock-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        84,
        128,
        145
      ],
      "id": "TR-11-188",
      "t": "Inside-Color Luster Crystal/Capri Blue-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        61,
        103,
        180
      ],
      "id": "TR-11-189FM",
      "t": "Frosted Caribbean Blue-Lined Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        233,
        101,
        120
      ],
      "id": "TR-11-190",
      "t": "Inside-Color Luster Crystal/Tropical Sunset-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        245,
        188,
        192
      ],
      "id": "TR-11-191F",
      "t": "Inside-Color Rainbow Frosted Crystal/Soft Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        252,
        161,
        196
      ],
      "id": "TR-11-191B",
      "t": "Inside-Color Transparent-Rainbow Crystal/Hot Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        235,
        208,
        104
      ],
      "id": "TR-11-192",
      "t": "Inside-Color Crystal/Yellow-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        104,
        140,
        185
      ],
      "id": "TR-11-193",
      "t": "Inside-Color Luster Crystal/Dk Capri-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        204,
        134,
        133
      ],
      "id": "TR-11-201",
      "t": "Gold-Lustered Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        184,
        113,
        120
      ],
      "id": "TR-11-202",
      "t": "Gold-Lustered Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        213,
        168,
        148
      ],
      "id": "TR-11-203",
      "t": "Gold-Lustered Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        203,
        178,
        157
      ],
      "id": "TR-11-204",
      "t": "Gold-Lustered Montana Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        205,
        129,
        183
      ],
      "id": "TR-11-205",
      "t": "Gold-Lustered Dk Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        112,
        116,
        134
      ],
      "id": "TR-11-206",
      "t": "Gold-Lustered Hydrangea",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        170,
        112,
        60
      ],
      "id": "TR-11-221",
      "t": "Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        106,
        81,
        51
      ],
      "id": "TR-11-221F",
      "t": "Frosted Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        155,
        80,
        77
      ],
      "id": "TR-11-222",
      "t": "Dk Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        79,
        45,
        52
      ],
      "id": "TR-11-222F",
      "t": "Frosted Dk Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        186,
        143,
        68
      ],
      "id": "TR-11-223",
      "t": "Antique Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        80,
        67,
        43
      ],
      "id": "TR-11-223F",
      "t": "Frosted Antique Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        150,
        89,
        65
      ],
      "id": "TR-11-224",
      "t": "Olympic Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        119,
        118,
        74
      ],
      "id": "TR-11-225",
      "t": "Bronze Antique Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        218,
        95,
        93
      ],
      "id": "TR-11-241",
      "t": "Inside-Color Rainbow Lt Topaz/Mauve-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        162,
        72,
        70
      ],
      "id": "TR-11-241F",
      "t": "Inside-Color Rainbow Frosted Lt Topaz/Mauve-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        100,
        154,
        122
      ],
      "id": "TR-11-242",
      "t": "Inside-Color Luster Jonquil/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        49,
        134,
        81
      ],
      "id": "TR-11-242F",
      "t": "Inside-Color Frosted Jonquil/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        132,
        139,
        119
      ],
      "id": "TR-11-243",
      "t": "Inside-Color Rainbow Topaz/Opaque Emerald-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        115,
        127,
        108
      ],
      "id": "TR-11-244",
      "t": "Inside-Color Rainbow Lt Topaz/Jet-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        144,
        147,
        157
      ],
      "id": "TR-11-245",
      "t": "Inside-Color Rainbow Jonquil/Jet-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        190,
        187,
        121
      ],
      "id": "TR-11-246",
      "t": "Inside-Color Luster Black Diamond/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        122,
        108,
        95
      ],
      "id": "TR-11-247",
      "t": "Inside-Color Peridot/Oxblood-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        64,
        105,
        146
      ],
      "id": "TR-11-248",
      "t": "Inside-Color Aqua/Jet-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        72,
        110,
        103
      ],
      "id": "TR-11-249",
      "t": "Inside-Color Peridot/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        162,
        155,
        139
      ],
      "id": "TR-11-250",
      "t": "Inside-Color Peridot/Fuchsia-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        121,
        108,
        144
      ],
      "id": "TR-11-251",
      "t": "Inside-Color Luster Lt Amethyst/Jet-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        76,
        71,
        125
      ],
      "id": "TR-11-252",
      "t": "Inside-Color Aqua/Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        86,
        62,
        128
      ],
      "id": "TR-11-252F",
      "t": "Inside-Color Frosted Aqua/Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        185,
        187,
        187
      ],
      "id": "TR-11-261",
      "t": "Inside-Color Rainbow Crystal/Gray-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        175,
        165,
        154
      ],
      "id": "TR-11-262",
      "t": "Inside-Color Crystal/Gold-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        120,
        156,
        179
      ],
      "id": "TR-11-263",
      "t": "Inside-Color Rainbow Crystal/Lt Capri-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        143,
        138,
        186
      ],
      "id": "TR-11-265",
      "t": "Inside-Color Rainbow Crystal/Metallic Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        143,
        144,
        152
      ],
      "id": "TR-11-266",
      "t": "Inside-Color Gold-Luster Crystal/Opaque Gray-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        193,
        156,
        164
      ],
      "id": "TR-11-267",
      "t": "Inside-Color Crystal/Rose Gold-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        159,
        140,
        137
      ],
      "id": "TR-11-268",
      "t": "Inside-Color Rainbow Crystal/Gold-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        48,
        138,
        141
      ],
      "id": "TR-11-270",
      "t": "Inside-Color Crystal/Prairie Green-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        51,
        124,
        156
      ],
      "id": "TR-11-274",
      "t": "Inside-Color Rainbow Crystal/Green Teal-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        143,
        116,
        114
      ],
      "id": "TR-11-276",
      "t": "Inside-Color Rainbow Topaz/Gold-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        141,
        170,
        191
      ],
      "id": "TR-11-277",
      "t": "Inside-Color Aqua/Lavender-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        212,
        177,
        125
      ],
      "id": "TR-11-278",
      "t": "Gold-Lined Rainbow Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        188,
        163,
        133
      ],
      "id": "TR-11-279",
      "t": "Inside-Color Rainbow Lt Topaz/Gray-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        174,
        165,
        146
      ],
      "id": "TR-11-281",
      "t": "Inside-Color Rainbow Topaz/Olivine-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        155,
        159,
        155
      ],
      "id": "TR-11-282",
      "t": "Inside-Color Gray/Gun Metal-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        167,
        185,
        163
      ],
      "id": "TR-11-284",
      "t": "Inside-Color Aqua/Gold-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        136,
        171,
        192
      ],
      "id": "TR-11-285",
      "t": "Inside-Color Aqua/Tin-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        192,
        165,
        134
      ],
      "id": "TR-11-286",
      "t": "Silver-Lined Pale Amber",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        164,
        181,
        184
      ],
      "id": "TR-11-288",
      "t": "Inside-Color Crystal/Metallic Blue-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        241,
        181,
        177
      ],
      "id": "TR-11-290",
      "t": "Transparent-Lustered Rose",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        221,
        129,
        140
      ],
      "id": "TR-11-291",
      "t": "Transparent-Lustered Rose/Mauve-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        112,
        148,
        183
      ],
      "id": "TR-11-294",
      "t": "Inside-Color Blue Raspberry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        240,
        167,
        143
      ],
      "id": "TR-11-301",
      "t": "Inside-Color Lt Topaz/Peach-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        195,
        153,
        25
      ],
      "id": "TR-11-302",
      "t": "Inside-Color Jonquil/Apricot-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        213,
        64,
        43
      ],
      "id": "TR-11-303",
      "t": "Inside-Color Jonquil/Hyacinth-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        198,
        103,
        148
      ],
      "id": "TR-11-304",
      "t": "Inside-Color Lt Sapphire/Hyacinth-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        54,
        181,
        89
      ],
      "id": "TR-11-306",
      "t": "Inside-Color Jonquil/Shamrock-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        156,
        232,
        148
      ],
      "id": "TR-11-307",
      "t": "Inside-Color Aqua/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        31,
        141,
        225
      ],
      "id": "TR-11-309",
      "t": "Inside-Color Lt Sapphire/Opaque Blue-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        101,
        159,
        173
      ],
      "id": "TR-11-321",
      "t": "Gold-Lustered Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        53,
        150,
        106
      ],
      "id": "TR-11-322",
      "t": "Gold-Lustered Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        124,
        127,
        99
      ],
      "id": "TR-11-323",
      "t": "Gold-Lustered Olivine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        148,
        135,
        74
      ],
      "id": "TR-11-324",
      "t": "Gold-Lustered Prairie Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        154,
        117,
        116
      ],
      "id": "TR-11-325",
      "t": "Gold-Lustered Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        138,
        128,
        122
      ],
      "id": "TR-11-326",
      "t": "Gold-Lustered Orion",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        94,
        67,
        97
      ],
      "id": "TR-11-328",
      "t": "Gold-Lustered Moon Shadow",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        77,
        18,
        13
      ],
      "id": "TR-11-329",
      "t": "Gold-Lustered African Sunset",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        166,
        98,
        110
      ],
      "id": "TR-11-331",
      "t": "Gold-Lustered Wild Berry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        217,
        97,
        142
      ],
      "id": "TR-11-332",
      "t": "Gold-Lustered Raspberry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        79,
        91,
        52
      ],
      "id": "TR-11-333",
      "t": "Gold-Lustered Fern",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        247,
        116,
        113
      ],
      "id": "TR-11-341",
      "t": "Inside-Color Crystal/Tomato-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        126,
        176,
        134
      ],
      "id": "TR-11-343",
      "t": "Inside Color-Crystal/Apple Green-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        119,
        123,
        124
      ],
      "id": "TR-11-344",
      "t": "Inside-Color Crystal/Dk Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        119,
        145,
        160
      ],
      "id": "TR-11-347",
      "t": "Inside-Color Crystal/Capri-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        241,
        132,
        192
      ],
      "id": "TR-11-350",
      "t": "Inside-Color Crystal/Fuchsia-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        143,
        209,
        228
      ],
      "id": "TR-11-351",
      "t": "Inside-Color Crystal/Opaque Blue-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        232,
        204,
        168
      ],
      "id": "TR-11-352",
      "t": "Inside-Color Crystal/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        197,
        171,
        176
      ],
      "id": "TR-11-353",
      "t": "Inside-Color Crystal/Lavender-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        157,
        213,
        181
      ],
      "id": "TR-11-354",
      "t": "Inside-Color Crystal/Mint Julep-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        230,
        121,
        133
      ],
      "id": "TR-11-355",
      "t": "Inside-Color Crystal/Siam-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        191,
        112,
        154
      ],
      "id": "TR-11-356",
      "t": "Inside-Color Lt Amethyst/Fushcia-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        110,
        127,
        205
      ],
      "id": "TR-11-361",
      "t": "Inside-Color Dk Aqua/Violet-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        94,
        109,
        136
      ],
      "id": "TR-11-362",
      "t": "Inside-Color/Transparent-Luster - Navy Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        170,
        130,
        126
      ],
      "id": "TR-11-363",
      "t": "Inside-Color Montana Blue/Oxblood-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        135,
        120,
        131
      ],
      "id": "TR-11-364",
      "t": "Inside-Color Lustered Grape",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        209,
        123,
        121
      ],
      "id": "TR-11-365",
      "t": "Inside-Color Lt Topaz/Pomegranate-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        168,
        159,
        166
      ],
      "id": "TR-11-367",
      "t": "Inside-Color Lustered Black Diamond/Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        198,
        183,
        142
      ],
      "id": "TR-11-369",
      "t": "Inside-Color Black Diamond/Orange Creme-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        177,
        184,
        187
      ],
      "id": "TR-11-371",
      "t": "Inside-Color Black Diamond/White-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        71,
        136,
        135
      ],
      "id": "TR-11-374",
      "t": "Transparent-Lustered Emerald Green/Denim Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        189,
        165,
        108
      ],
      "id": "TR-11-375",
      "t": "Inside-Color Topaz/Lt Gray-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        41,
        138,
        132
      ],
      "id": "TR-11-377",
      "t": "Inside-Color Lt Sapphire/Metallic Teal-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        102,
        113,
        164
      ],
      "id": "TR-11-381",
      "t": "Inside-Color Aqua/Oxblood-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        57,
        105,
        99
      ],
      "id": "TR-11-384",
      "t": "Inside-Color Rainbow Montana Blue/Opaque Green-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        226,
        92,
        121
      ],
      "id": "TR-11-388",
      "t": "Inside-Color Lt Topaz/Hyacinth-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        115,
        164,
        83
      ],
      "id": "TR-11-393",
      "t": "Inside-Color Topaz/Opaque Green-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        59,
        111,
        114
      ],
      "id": "TR-11-397",
      "t": "Inside-Color Rainbow Green/Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        224,
        223,
        224
      ],
      "id": "TR-11-401",
      "t": "Opaque-Rainbow White",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        245,
        237,
        85
      ],
      "id": "TR-11-402",
      "t": "Opaque-Rainbow Dandelion",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        221,
        215,
        31
      ],
      "id": "TR-11-402F",
      "t": "Opaque-Rainbow-Frosted Dandelion",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        71,
        162,
        223
      ],
      "id": "TR-11-403",
      "t": "Opaque-Rainbow Blue Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        194,
        231,
        136
      ],
      "id": "TR-11-404",
      "t": "Opaque-Rainbow Sour Apple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        238,
        98,
        86
      ],
      "id": "TR-11-405",
      "t": "Opaque-Rainbow Cherry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        169,
        60,
        66
      ],
      "id": "TR-11-405F",
      "t": "Opaque-Rainbow-Frosted Cherry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        91,
        93,
        83
      ],
      "id": "TR-11-406",
      "t": "Opaque-Rainbow Oxblood",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        80,
        72,
        96
      ],
      "id": "TR-11-406F",
      "t": "Opaque-Rainbow-Frosted Oxblood",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        173,
        235,
        172
      ],
      "id": "TR-11-407",
      "t": "Opaque-Rainbow Mint Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        126,
        147,
        229
      ],
      "id": "TR-11-408",
      "t": "Opaque-Rainbow Navy Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        240,
        231,
        200
      ],
      "id": "TR-11-409",
      "t": "Opaque-Rainbow Lt Beige",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        236,
        125,
        96
      ],
      "id": "TR-11-410",
      "t": "Opaque-Rainbow Pumpkin",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        164,
        135,
        148
      ],
      "id": "TR-11-412",
      "t": "Opaque-Rainbow Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        100,
        219,
        215
      ],
      "id": "TR-11-413",
      "t": "Opaque-Rainbow Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        114,
        51,
        12
      ],
      "id": "TR-11-421",
      "t": "Gold-Lustered Transparent Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        74,
        72,
        32
      ],
      "id": "TR-11-422",
      "t": "Gold-Lustered Dk Antique Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        126,
        105,
        126
      ],
      "id": "TR-11-425",
      "t": "Gold-Lustered Marionberry",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        194,
        189,
        197
      ],
      "id": "TR-11-455",
      "t": "Gold-Lustered Pale Wisteria",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        165,
        156,
        114
      ],
      "id": "TR-11-457",
      "t": "Gold-Lustered Green Tea",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        189,
        166,
        133
      ],
      "id": "TR-11-459",
      "t": "Gold-Lustered Dk Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        154,
        76,
        183
      ],
      "id": "TR-11-461",
      "t": "Higher-Metallic Grape",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        200,
        185,
        202
      ],
      "id": "TR-11-477",
      "t": "Dyed-Rainbow Lavender Mist",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        207,
        185,
        219
      ],
      "id": "TR-11-477D",
      "t": "Transparent-Rainbow Foxglove",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        106,
        55,
        68
      ],
      "id": "TR-11-502",
      "t": "Higher-Metallic Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        121,
        65,
        95
      ],
      "id": "TR-11-503",
      "t": "Higher-Metallic Dk Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        25,
        18,
        28
      ],
      "id": "TR-11-504",
      "t": "Higher-Metallic Iris - Violet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        77,
        111,
        150
      ],
      "id": "TR-11-505",
      "t": "Higher-Metallic Dragonfly",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        50,
        161,
        151
      ],
      "id": "TR-11-506",
      "t": "Higher-Metallic June Bug",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        71,
        99,
        68
      ],
      "id": "TR-11-507",
      "t": "Higher-Metallic Iris - Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        72,
        56,
        30
      ],
      "id": "TR-11-509",
      "t": "Higher-Metallic Iris - Purple/Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        61,
        120,
        153
      ],
      "id": "TR-11-511",
      "t": "Galvanized Peacock Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        83,
        153,
        200
      ],
      "id": "TR-11-511F",
      "t": "Higher-Metallic Frosted Mediterranean Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        164,
        191,
        183
      ],
      "id": "TR-11-512",
      "t": "Galvanized Blue Haze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        193,
        177,
        80
      ],
      "id": "TR-11-513",
      "t": "Galvanized Carnival",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        198,
        172,
        87
      ],
      "id": "TR-11-513F",
      "t": "Higher-Metallic Frosted Carnival",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        167,
        110,
        79
      ],
      "id": "TR-11-514",
      "t": "Higher-Metallic Gypsy Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        129,
        73,
        52
      ],
      "id": "TR-11-514F",
      "t": "Higher-Metallic Frosted Copper Twilight",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        171,
        83,
        162
      ],
      "id": "TR-11-515F",
      "t": "Higher-Metallic Frosted Mardi Gras",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        44,
        81,
        78
      ],
      "id": "TR-11-519",
      "t": "Higher-Metallic Teal Hematite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        78,
        112,
        110
      ],
      "id": "TR-11-519F",
      "t": "Higher-Metallic Frosted Teal Hematite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        187,
        132,
        76
      ],
      "id": "TR-11-PF551F",
      "t": "PermaFinish - Matte Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        234,
        212,
        178
      ],
      "id": "TR-11-PF551",
      "t": "PermaFinish - Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        249,
        211,
        187
      ],
      "id": "TR-11-PF552F",
      "t": "PermaFinish - Matte Galvanized Peach Coral",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        219,
        196,
        174
      ],
      "id": "TR-11-PF552",
      "t": "PermaFinish - Galvanized Sweet Blush",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        214,
        166,
        186
      ],
      "id": "TR-11-553",
      "t": "Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        196,
        129,
        137
      ],
      "id": "TR-11-PF553F",
      "t": "PermaFinish - Matte Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        240,
        167,
        183
      ],
      "id": "TR-11-PF553",
      "t": "PermaFinish - Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        146,
        129,
        135
      ],
      "id": "TR-11-PF554F",
      "t": "PermaFinish - Matte Galvanized Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        195,
        163,
        164
      ],
      "id": "TR-11-PF554",
      "t": "PermaFinish - Galvanized Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        147,
        112,
        99
      ],
      "id": "TR-11-PF556F",
      "t": "PermaFinish - Matte Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        147,
        116,
        99
      ],
      "id": "TR-11-PF556",
      "t": "PermaFinish - Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        224,
        176,
        105
      ],
      "id": "TR-11-557F",
      "t": "Galvanized-Matte Starlight",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        218,
        179,
        87
      ],
      "id": "TR-11-PF557F",
      "t": "PermaFinish - Matte Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        207,
        173,
        102
      ],
      "id": "TR-11-PF557",
      "t": "PermaFinish - Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        199,
        187,
        158
      ],
      "id": "TR-11-PF558F",
      "t": "PermaFinish - Matte Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        195,
        188,
        163
      ],
      "id": "TR-11-PF558",
      "t": "PermaFinish - Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        214,
        202,
        130
      ],
      "id": "TR-11-PF559F",
      "t": "PermaFinish - Frosted Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        237,
        226,
        128
      ],
      "id": "TR-11-PF559",
      "t": "PermaFinish - Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        220,
        230,
        197
      ],
      "id": "TR-11-560",
      "t": "Galvanized Sea Foam",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        178,
        220,
        149
      ],
      "id": "TR-11-PF560",
      "t": "PermaFinish - Galvanized Sea Foam",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        136,
        197,
        163
      ],
      "id": "TR-11-561F",
      "t": "Galvanized-Matte Lt Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        60,
        189,
        159
      ],
      "id": "TR-11-PF561F",
      "t": "PermaFinish - Matte Galvanized Green Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        108,
        210,
        179
      ],
      "id": "TR-11-PF561",
      "t": "ermaFinish - Galvanized Green Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        215,
        159,
        126
      ],
      "id": "TR-11-PF562F",
      "t": "PermaFinish - Matte Galvanized Saffron",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        194,
        99,
        54
      ],
      "id": "TR-11-PF562",
      "t": "PermaFinish - Galvanized Saffron",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        203,
        103,
        120
      ],
      "id": "TR-11-PF563F",
      "t": "PermaFinish - Matte Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        206,
        85,
        129
      ],
      "id": "TR-11-PF563",
      "t": "PermaFinish - Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        154,
        58,
        54
      ],
      "id": "TR-11-PF564F",
      "t": "PermaFinish - Matte Galvanized Brick Red",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        164,
        53,
        61
      ],
      "id": "TR-11-PF564",
      "t": "PermaFinish - Galvanized Brick Red",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        135,
        143,
        140
      ],
      "id": "TR-11-PF565F",
      "t": "PermaFinish - Frosted Galvanized Blue Slate",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        151,
        182,
        141
      ],
      "id": "TR-11-PF565",
      "t": "PermaFinish - Galvanized Blue Slate",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        190,
        181,
        164
      ],
      "id": "TR-11-566",
      "t": "Metallic Frosted Antique Silver",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        119,
        108,
        126
      ],
      "id": "TR-11-PF567F",
      "t": "PermaFinish - Frosted Metallic Polaris",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        104,
        111,
        166
      ],
      "id": "TR-11-PF567",
      "t": "PermaFinish - Metallic Polaris",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        172,
        170,
        195
      ],
      "id": "TR-11-PF568",
      "t": "PermaFinish - Galvanized Gun Metal Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        34,
        206,
        170
      ],
      "id": "TR-11-PF569",
      "t": "PermaFinish - Galvanized Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        109,
        179,
        143
      ],
      "id": "TR-11-PF570F",
      "t": "PermaFinish - Frosted Galvanized Mint Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        155,
        182,
        133
      ],
      "id": "TR-11-PF570",
      "t": "PermaFinish - Galvanized Mint Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        89,
        205,
        195
      ],
      "id": "TR-11-PF578F",
      "t": "PermaFinish - Frosted Galvanized Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        159,
        124,
        152
      ],
      "id": "TR-11-PF579F",
      "t": "PermaFinish - Matte Galvanized Pale Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        166,
        147,
        176
      ],
      "id": "TR-11-PF579",
      "t": "PermaFinish - Galvanized Pale Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        183,
        98,
        169
      ],
      "id": "TR-11-PF580F",
      "t": "PermaFinish - Matte Galvanized Sugar Plum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        193,
        109,
        157
      ],
      "id": "TR-11-PF580",
      "t": "PermaFinish - Galvanized Sugar Plum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        121,
        93,
        180
      ],
      "id": "TR-11-PF581F",
      "t": "PermaFinish - Matte Galvanized Violet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        118,
        99,
        203
      ],
      "id": "TR-11-PF581",
      "t": "PermaFinish - Galvanized Violet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        32,
        178,
        210
      ],
      "id": "TR-11-PF582F",
      "t": "PermaFinish - Matte Galvanized Aqua Sky",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        42,
        113,
        168
      ],
      "id": "TR-11-PF582",
      "t": "PermaFinish - Galvanized Aqua Sky",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        19,
        132,
        191
      ],
      "id": "TR-11-PF583F",
      "t": "PermaFinish - Matte Galvanized Caribbean Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        9,
        161,
        207
      ],
      "id": "TR-11-PF583",
      "t": "PermaFinish - Galvanized Caribbean Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        8,
        102,
        151
      ],
      "id": "TR-11-PF584F",
      "t": "PermaFinish - Matte Galvanized Turkish Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        7,
        89,
        166
      ],
      "id": "TR-11-PF585F",
      "t": "PermaFinish - Matte Galvanized Ocean Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        4,
        100,
        201
      ],
      "id": "TR-11-PF585",
      "t": "PermaFinish - Galvanized Ocean Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        63,
        102,
        179
      ],
      "id": "TR-11-PF586F",
      "t": "PermaFinish - Matte Galvanized Denim Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        63,
        118,
        193
      ],
      "id": "TR-11-PF586",
      "t": "PermaFinish - Galvanized Denim Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        98,
        193,
        99
      ],
      "id": "TR-11-PF587F",
      "t": "PermaFinish - Matte Galvanized Green Apple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        130,
        215,
        113
      ],
      "id": "TR-11-PF587",
      "t": "PermaFinish - Galvanized Green Apple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        62,
        190,
        126
      ],
      "id": "TR-11-PF588F",
      "t": "PermaFinish - Matte Galvanized Spring Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        47,
        182,
        112
      ],
      "id": "TR-11-PF588",
      "t": "PermaFinish - Galvanized Spring Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        114,
        175,
        143
      ],
      "id": "TR-11-PF589F",
      "t": "PermaFinish - Matte Galvanized Jade Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        128,
        169,
        126
      ],
      "id": "TR-11-PF589",
      "t": "PermaFinish - Galvanized Jade Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        197,
        198,
        80
      ],
      "id": "TR-11-PF590F",
      "t": "PermaFinish - Matte Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        185,
        191,
        113
      ],
      "id": "TR-11-PF590",
      "t": "PermaFinish - Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        186,
        129,
        60
      ],
      "id": "TR-11-PF591F",
      "t": "PermaFinish - Matte Galvanized Old Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        220,
        175,
        81
      ],
      "id": "TR-11-PF591",
      "t": "PermaFinish - Galvanized Old Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        184,
        150,
        79
      ],
      "id": "TR-11-PF592F",
      "t": "PermaFinish - Matte Galvanized Golden Fleece",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        208,
        188,
        132
      ],
      "id": "TR-11-PF592",
      "t": "PermaFinish - Galvanized Golden Fleece",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        145,
        118,
        77
      ],
      "id": "TR-11-PF593F",
      "t": "PermaFinish - Matte Galvanized Almond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        171,
        137,
        92
      ],
      "id": "TR-11-PF593",
      "t": "PermaFinish - Galvanized Almond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        116,
        83,
        37
      ],
      "id": "TR-11-PF594F",
      "t": "PermaFinish - Matte Galvanized Medal Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        126,
        89,
        28
      ],
      "id": "TR-11-PF594",
      "t": "PermaFinish - Galvanized Medal Bronze",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        97,
        91,
        85
      ],
      "id": "TR-11-PF595F",
      "t": "PermaFinish - Matte Galvanized Cool Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        74,
        75,
        67
      ],
      "id": "TR-11-PF595",
      "t": "PermaFinish - Galvanized Cool Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        92,
        121,
        113
      ],
      "id": "TR-11-601",
      "t": "Galvanized Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        131,
        131,
        126
      ],
      "id": "TR-11-602",
      "t": "Galvanized Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        87,
        94,
        91
      ],
      "id": "TR-11-602F",
      "t": "Higher-Metallic Frosted Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        133,
        125,
        124
      ],
      "id": "TR-11-604",
      "t": "Galvanized Lt Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        117,
        103,
        109
      ],
      "id": "TR-11-605",
      "t": "Galvanized Dk Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        78,
        55,
        77
      ],
      "id": "TR-11-607",
      "t": "Higher-Metallic Violet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        117,
        133,
        141
      ],
      "id": "TR-11-611",
      "t": "Matte-Color Opaque Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        168,
        177,
        191
      ],
      "id": "TR-11-612",
      "t": "Matte-Color Gun Metal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        183,
        181,
        164
      ],
      "id": "TR-11-613",
      "t": "Matte-Color Iris - Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        109,
        102,
        82
      ],
      "id": "TR-11-614",
      "t": "Matte-Color Iris - Brown",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        155,
        142,
        150
      ],
      "id": "TR-11-615",
      "t": "Matte-Color Iris - Purple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        111,
        116,
        58
      ],
      "id": "TR-11-617",
      "t": "Matte-Color Dk Olive",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        144,
        104,
        65
      ],
      "id": "TR-11-618",
      "t": "Opaque-Pastel-Frosted Mudbrick",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        208,
        129,
        134
      ],
      "id": "TR-11-621",
      "t": "Transparent French Rose",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        199,
        122,
        37
      ],
      "id": "TR-11-622",
      "t": "Transparent Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        158,
        94,
        133
      ],
      "id": "TR-11-625F",
      "t": "Gold-Lustered Matte Plum",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        150,
        216,
        214
      ],
      "id": "TR-11-699",
      "t": "Inside-Color Rainbow Crystal/Shamrock-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        220,
        188,
        121
      ],
      "id": "TR-11-701",
      "t": "24K Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        147,
        118,
        82
      ],
      "id": "TR-11-702",
      "t": "Matte-Color Dk Copper",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        165,
        123,
        120
      ],
      "id": "TR-11-703",
      "t": "Matte-Color Mauve Mocha",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        188,
        143,
        186
      ],
      "id": "TR-11-704",
      "t": "Matte-Color Andromeda",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        101,
        91,
        116
      ],
      "id": "TR-11-705",
      "t": "Matte-Color Iris - Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        124,
        189,
        182
      ],
      "id": "TR-11-706",
      "t": "Matte-Color Iris - Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        93,
        92,
        77
      ],
      "id": "TR-11-708",
      "t": "Matte-Color Cassiopeia",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        135,
        121,
        107
      ],
      "id": "TR-11-709",
      "t": "Matte-Color Iris - Violet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        138,
        199,
        183
      ],
      "id": "TR-11-710",
      "t": "Matte-Color Aquarius",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        189,
        180,
        165
      ],
      "id": "TR-11-711",
      "t": "Nickel",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        231,
        207,
        135
      ],
      "id": "TR-11-712",
      "t": "Metallic 24K Gold Plated",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        233,
        230,
        225
      ],
      "id": "TR-11-713",
      "t": "Olympic Silver",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        218,
        217,
        209
      ],
      "id": "TR-11-714",
      "t": "Metallic Silver",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        136,
        143,
        113
      ],
      "id": "TR-11-721",
      "t": "Galvanized Blue Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        183,
        126,
        78
      ],
      "id": "TR-11-722",
      "t": "Galvanized Midas Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        222,
        155,
        129
      ],
      "id": "TR-11-740",
      "t": "Copper-Lined Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        219,
        188,
        191
      ],
      "id": "TR-11-741",
      "t": "Copper-Lined Alabaster",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        74,
        120,
        39
      ],
      "id": "TR-11-742",
      "t": "Copper-Lined Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        168,
        115,
        46
      ],
      "id": "TR-11-744",
      "t": "Copper-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        189,
        134,
        29
      ],
      "id": "TR-11-745",
      "t": "Copper-Lined Marigold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        168,
        106,
        102
      ],
      "id": "TR-11-746",
      "t": "Copper-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        96,
        89,
        12
      ],
      "id": "TR-11-747",
      "t": "Copper-Lined Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        241,
        242,
        237
      ],
      "id": "TR-11-761",
      "t": "Matte-Color Opaque-Rainbow White",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        242,
        226,
        193
      ],
      "id": "TR-11-762",
      "t": "Opaque-Pastel-Frosted Egg Shell",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        241,
        214,
        182
      ],
      "id": "TR-11-763",
      "t": "Opaque-Pastel-Frosted Apricot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        240,
        194,
        182
      ],
      "id": "TR-11-764",
      "t": "Opaque-Pastel-Frosted Shrimp",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        224,
        179,
        189
      ],
      "id": "TR-11-765",
      "t": "Opaque-Pastel-Frosted Plumeria",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        202,
        156,
        171
      ],
      "id": "TR-11-766",
      "t": "Opaque-Pastel-Frosted Lt Lilac",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        191,
        163,
        175
      ],
      "id": "TR-11-771",
      "t": "Inside-Color Rainbow Crystal/Strawberry-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        166,
        172,
        184
      ],
      "id": "TR-11-773",
      "t": "Inside-Color Rainbow Crystal/Montana Blue-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        97,
        123,
        158
      ],
      "id": "TR-11-774",
      "t": "Inside-Color Rainbow Crystal/Grape-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        81,
        79,
        91
      ],
      "id": "TR-11-774F",
      "t": "Inside-Color Frosted Crystal/Grape-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        126,
        125,
        180
      ],
      "id": "TR-11-776",
      "t": "Inside-Color Rainbow Aqua/Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        236,
        234,
        226
      ],
      "id": "TR-11-777",
      "t": "Inside-Color Rainbow Crystal/Creme-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        251,
        174,
        181
      ],
      "id": "TR-11-779",
      "t": "Inside-Color Rainbow Crystal/Salmon-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        142,
        148,
        158
      ],
      "id": "TR-11-782",
      "t": "Inside-Color Rainbow Crystal/Capri-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        157,
        156,
        159
      ],
      "id": "TR-11-783",
      "t": "Inside-Color Rainbow Crystal/Opaque Gray-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        205,
        164,
        151
      ],
      "id": "TR-11-784",
      "t": "Inside-Color Rainbow Crystal/Sandstone-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        223,
        133,
        170
      ],
      "id": "TR-11-785",
      "t": "Inside-Color Luster Crystal/Hot Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        247,
        204,
        173
      ],
      "id": "TR-11-794",
      "t": "Inside-Color Rainbow Crystal/Apricot-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        252,
        164,
        69
      ],
      "id": "TR-11-801",
      "t": "Luminous Neon Tangerine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        252,
        138,
        79
      ],
      "id": "TR-11-802",
      "t": "Luminous Neon Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        244,
        121,
        98
      ],
      "id": "TR-11-803",
      "t": "Luminous Neon Salmon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        36,
        242,
        132
      ],
      "id": "TR-11-805",
      "t": "Luminous Neon Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        218,
        239,
        140
      ],
      "id": "TR-11-833",
      "t": "Ceylon Neon Yellow",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        243,
        221,
        175
      ],
      "id": "TR-11-901",
      "t": "Ceylon Rice Pudding",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        240,
        224,
        157
      ],
      "id": "TR-11-902",
      "t": "Ceylon Lemon Chiffon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        251,
        223,
        173
      ],
      "id": "TR-11-903",
      "t": "Ceylon Custard",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        243,
        198,
        182
      ],
      "id": "TR-11-904",
      "t": "Ceylon Apricot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        245,
        177,
        174
      ],
      "id": "TR-11-905",
      "t": "Ceylon Peach Blush",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        242,
        167,
        170
      ],
      "id": "TR-11-906",
      "t": "Ceylon Tomato Soup",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        221,
        98,
        101
      ],
      "id": "TR-11-906F",
      "t": "Ceylon Frosted Grapefruit",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        213,
        177,
        183
      ],
      "id": "TR-11-907",
      "t": "Ceylon Petunia",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        243,
        139,
        150
      ],
      "id": "TR-11-909",
      "t": "Ceylon Cotton Candy",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        249,
        134,
        193
      ],
      "id": "TR-11-910",
      "t": "Ceylon Hot Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        245,
        170,
        177
      ],
      "id": "TR-11-911",
      "t": "Ceylon Impatiens Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        151,
        174,
        221
      ],
      "id": "TR-11-917",
      "t": "Ceylon Denim Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        129,
        196,
        224
      ],
      "id": "TR-11-918",
      "t": "Ceylon English Bluebell",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        167,
        214,
        234
      ],
      "id": "TR-11-919",
      "t": "Ceylon Forget-Me-Not",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        124,
        204,
        202
      ],
      "id": "TR-11-920",
      "t": "Ceylon Lt Sea Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        183,
        188,
        227
      ],
      "id": "TR-11-921",
      "t": "Ceylon Virginia Bluebell",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        185,
        170,
        221
      ],
      "id": "TR-11-922",
      "t": "Ceylon Gladiola",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        165,
        157,
        166
      ],
      "id": "TR-11-926",
      "t": "Inside-Color Lt Topaz/Opaque Lavender-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        138,
        102,
        172
      ],
      "id": "TR-11-928",
      "t": "Inside-Color Rainbow Rosaline/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        107,
        128,
        159
      ],
      "id": "TR-11-929",
      "t": "Inside-Color Rainbow Lt Yellow/Capri-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        75,
        167,
        200
      ],
      "id": "TR-11-931",
      "t": "Inside-Color Aqua/White-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        45,
        113,
        181
      ],
      "id": "TR-11-932",
      "t": "Inside-Color Aqua/Capri-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        185,
        201,
        231
      ],
      "id": "TR-11-933",
      "t": "Inside-Color Lt Sapphire/White-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        62,
        71,
        183
      ],
      "id": "TR-11-934",
      "t": "Inside-Color Lt Sapphire/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        188,
        150,
        222
      ],
      "id": "TR-11-935",
      "t": "Inside-Color Crystal/Wisteria-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        200,
        157,
        228
      ],
      "id": "TR-11-937",
      "t": "Inside-Color Aqua/Bubble Gum Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        152,
        162,
        242
      ],
      "id": "TR-11-938",
      "t": "Inside-Color Aqua/Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        77,
        113,
        91
      ],
      "id": "TR-11-939",
      "t": "Transparent Green Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        47,
        86,
        64
      ],
      "id": "TR-11-939F",
      "t": "Transparent-Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        113,
        119,
        92
      ],
      "id": "TR-11-940",
      "t": "Transparent Olivine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        69,
        81,
        57
      ],
      "id": "TR-11-940F",
      "t": "Transparent-Frosted Olivine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        127,
        87,
        81
      ],
      "id": "TR-11-941",
      "t": "Transparent Smoky Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        94,
        51,
        28
      ],
      "id": "TR-11-941F",
      "t": "Transparent-Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        76,
        74,
        185
      ],
      "id": "TR-11-942",
      "t": "Transparent Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        81,
        40,
        211
      ],
      "id": "TR-11-942F",
      "t": "Transparent-Frosted Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        174,
        208,
        119
      ],
      "id": "TR-11-945",
      "t": "Inside-Color Jonquil/Mint Julep-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        175,
        189,
        106
      ],
      "id": "TR-11-946",
      "t": "Inside-Color Jonquil/Opaque Green-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        138,
        190,
        94
      ],
      "id": "TR-11-946F",
      "t": "Inside-Color Frosted Jonquil/Opaque Green-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        74,
        181,
        137
      ],
      "id": "TR-11-947",
      "t": "Inside-Color Lime Green/Opaque Green-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        223,
        197,
        160
      ],
      "id": "TR-11-948",
      "t": "Inside-Color Jonquil/White-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        229,
        185,
        125
      ],
      "id": "TR-11-949",
      "t": "Inside-Color Jonquil/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        239,
        157,
        61
      ],
      "id": "TR-11-950",
      "t": "Inside-Color Jonquil/Burnt Orange-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        184,
        93,
        89
      ],
      "id": "TR-11-951",
      "t": "Inside-Color Jonquil/Brick Red-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        167,
        196,
        168
      ],
      "id": "TR-11-952",
      "t": "Inside-Color Rainbow Lt Topaz/Sea Foam-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        129,
        183,
        154
      ],
      "id": "TR-11-953",
      "t": "Inside-Color Jonquil/Turquoise-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        74,
        200,
        183
      ],
      "id": "TR-11-954",
      "t": "Inside-Color Aqua/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        129,
        191,
        182
      ],
      "id": "TR-11-954F",
      "t": "Inside-Color Frosted Aqua/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        238,
        191,
        146
      ],
      "id": "TR-11-955",
      "t": "Inside-Color Jonquil/Lt Apricot-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        240,
        154,
        132
      ],
      "id": "TR-11-956",
      "t": "Inside-Color Jonquil/Coral-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        239,
        111,
        59
      ],
      "id": "TR-11-957",
      "t": "Inside-Color Hyacinth/White-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        241,
        88,
        61
      ],
      "id": "TR-11-958",
      "t": "Inside-Color Hyacinth/Siam-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        233,
        135,
        181
      ],
      "id": "TR-11-959",
      "t": "Inside-Color Lt Amethyst/Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        178,
        127,
        119
      ],
      "id": "TR-11-960",
      "t": "Inside-Color Lt Topaz/Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        231,
        179,
        102
      ],
      "id": "TR-11-961",
      "t": "Inside-Color Crystal/Butter-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        243,
        167,
        83
      ],
      "id": "TR-11-962",
      "t": "Inside-Color Crystal/Peach-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        248,
        140,
        107
      ],
      "id": "TR-11-963",
      "t": "Inside-Color Crystal/Apricot-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        247,
        130,
        105
      ],
      "id": "TR-11-964",
      "t": "Inside-Color Crystal/Dk Coral-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        242,
        115,
        181
      ],
      "id": "TR-11-965",
      "t": "Inside-Color Crystal/Carnation-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        231,
        199,
        204
      ],
      "id": "TR-11-967",
      "t": "Inside-Color Crystal/Neon Rosaline-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        253,
        169,
        203
      ],
      "id": "TR-11-969",
      "t": "Inside-Color Crystal/Neon Carnation-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        253,
        121,
        183
      ],
      "id": "TR-11-971",
      "t": "Inside-Color Matte Crystal/Neon Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        174,
        231,
        198
      ],
      "id": "TR-11-975",
      "t": "Inside-Color Crystal/Neon Sea Foam-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        155,
        223,
        240
      ],
      "id": "TR-11-976",
      "t": "Inside-Color Crystal/Neon Ice Blue-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        143,
        139,
        220
      ],
      "id": "TR-11-977",
      "t": "Inside-Color Crystal/Neon Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        221,
        86,
        119
      ],
      "id": "TR-11-978",
      "t": "Luminous Neon Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        238,
        95,
        100
      ],
      "id": "TR-11-979",
      "t": "Luminous Lt Topaz/Neon Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        229,
        90,
        193
      ],
      "id": "TR-11-980",
      "t": "Luminous Lt Sapphire/Neon Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        251,
        247,
        241
      ],
      "id": "TR-11-981",
      "t": "Inside-Color Crystal/Snow-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        247,
        169,
        103
      ],
      "id": "TR-11-984",
      "t": "Inside-Color Crystal/Papaya-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        245,
        158,
        128
      ],
      "id": "TR-11-985",
      "t": "Inside-Color Crystal/Salmon-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        251,
        158,
        198
      ],
      "id": "TR-11-987",
      "t": "Inside-Color Crystal/Ballerina Pink-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        146,
        144,
        197
      ],
      "id": "TR-11-988",
      "t": "Inside-Color Crystal/Lupine-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        215,
        195,
        157
      ],
      "id": "TR-11-989",
      "t": "Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        167,
        136,
        84
      ],
      "id": "TR-11-989F",
      "t": "Gold-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        179,
        191,
        176
      ],
      "id": "TR-11-990",
      "t": "Gold-Lined Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        128,
        123,
        33
      ],
      "id": "TR-11-991",
      "t": "Gold-Lined Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        157,
        160,
        166
      ],
      "id": "TR-11-992",
      "t": "Gold-Lined Lt Montana Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        165,
        157,
        148
      ],
      "id": "TR-11-993",
      "t": "Gold-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        212,
        189,
        158
      ],
      "id": "TR-11-994",
      "t": "Gold-Lined Rainbow Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        120,
        162,
        159
      ],
      "id": "TR-11-995",
      "t": "Gold-Lined Rainbow Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        63,
        114,
        94
      ],
      "id": "TR-11-995F",
      "t": "Gold-Lined Frosted Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        197,
        190,
        96
      ],
      "id": "TR-11-996",
      "t": "Gold-Lined Rainbow Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        154,
        168,
        169
      ],
      "id": "TR-11-997",
      "t": "Gold-Lined Rainbow Lt Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        88,
        87,
        86
      ],
      "id": "TR-11-997F",
      "t": "Gold-Lined Rainbow Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        193,
        175,
        138
      ],
      "id": "TR-11-998",
      "t": "Gold-Lined Rainbow Lt Jonquil",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        191,
        159,
        134
      ],
      "id": "TR-11-999",
      "t": "Gold-Lined Rainbow Black Diamond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        91,
        94,
        69
      ],
      "id": "TR-11-999F",
      "t": "Gold-Lined Frosted Black Diamond",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        173,
        172,
        173
      ],
      "id": "TR-11-1010",
      "t": "Silver-Lined Luster - Med Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        158,
        107,
        123
      ],
      "id": "TR-11-1015",
      "t": "Inside-Color Crystal/Blush-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        157,
        177,
        124
      ],
      "id": "TR-11-1046",
      "t": "Inside-Color Luster Peridot/Opaque White-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        114,
        139,
        190
      ],
      "id": "TR-11-1057",
      "t": "Inside-Color Lt Sapphire/Opaque Dk Blue-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        114,
        117,
        125
      ],
      "id": "TR-11-1064",
      "t": "Inside-Color Crystal/Concord Grape-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        154,
        143,
        134
      ],
      "id": "TR-11-1071",
      "t": "Inside-Color Crystal/Antique Plum-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        97,
        57,
        82
      ],
      "id": "TR-11-1075",
      "t": "Inside-Color Crystal/Berry Wine-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        115,
        87,
        103
      ],
      "id": "TR-11-1076",
      "t": "Inside-Color Gray/Magenta-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        226,
        226,
        226
      ],
      "id": "TR-11-1141",
      "t": "Alabaster",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        140,
        217,
        179
      ],
      "id": "TR-11-1144",
      "t": "Milky Kiwi",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        209,
        178,
        192
      ],
      "id": "TR-11-1200",
      "t": "Marbled Opaque White/Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        219,
        180,
        166
      ],
      "id": "TR-11-1201",
      "t": "Marbled Opaque Beige/Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        209,
        160,
        178
      ],
      "id": "TR-11-1202",
      "t": "Marbled Opaque Pink/Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        192,
        170,
        164
      ],
      "id": "TR-11-1203",
      "t": "Marbled Opaque Pink/Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        164,
        156,
        189
      ],
      "id": "TR-11-1204",
      "t": "Marbled Opaque Lt Blue/Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        193,
        204,
        213
      ],
      "id": "TR-11-1205",
      "t": "Marbled Opaque White/Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        143,
        185,
        195
      ],
      "id": "TR-11-1206",
      "t": "Marbled Opaque Turquoise/Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        147,
        172,
        163
      ],
      "id": "TR-11-1207",
      "t": "Marbled Opaque Turquoise/Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        165,
        178,
        186
      ],
      "id": "TR-11-1208",
      "t": "Marbled Opaque Turquoise/Luster - Transparent Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        192,
        174,
        115
      ],
      "id": "TR-11-1209",
      "t": "Marbled Opaque Avocado/Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        166,
        142,
        170
      ],
      "id": "TR-11-1300",
      "t": "Transparent Alexandrite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        220,
        154,
        35
      ],
      "id": "TR-11-1606",
      "t": "Opaque-Lustered Tuscan Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        112,
        173,
        169
      ],
      "id": "TR-11-1611",
      "t": "Opaque-Lustered Lagoon",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        207,
        162,
        69
      ],
      "id": "TR-11-1623F",
      "t": "Opaque-Frosted-Gold-Lustered Yellow",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        132,
        132,
        38
      ],
      "id": "TR-11-1624F",
      "t": "Opaque-Frosted Pea Green Soup",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        171,
        144,
        122
      ],
      "id": "TR-11-1700",
      "t": "Gilded Marble White",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        164,
        137,
        117
      ],
      "id": "TR-11-1701",
      "t": "Gilded Marble Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        174,
        175,
        108
      ],
      "id": "TR-11-1702",
      "t": "Gilded Marble Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        182,
        186,
        166
      ],
      "id": "TR-11-1703",
      "t": "Gilded Marble Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        207,
        174,
        147
      ],
      "id": "TR-11-1704",
      "t": "Gilded Marble Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        159,
        128,
        92
      ],
      "id": "TR-11-1705",
      "t": "Gilded Marble Brown",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        156,
        137,
        104
      ],
      "id": "TR-11-1706",
      "t": "Gilded Marble Black",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        214,
        152,
        103
      ],
      "id": "TR-11-1707",
      "t": "Gilded Marble Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        202,
        142,
        103
      ],
      "id": "TR-11-1708",
      "t": "Gilded Marble Red",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        92,
        65,
        69
      ],
      "id": "TR-11-1809",
      "t": "Copper-Lined Rainbow Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        175,
        226,
        220
      ],
      "id": "TR-11-1812",
      "t": "Transparent-Rainbow Seafoam",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        93,
        95,
        111
      ],
      "id": "TR-11-1820",
      "t": "Inside-Color Rainbow Gray/Opaque Gray-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        123,
        46,
        59
      ],
      "id": "TR-11-1824",
      "t": "Inside-Color Rainbow Alexandrite/Opaque Orange-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        205,
        134,
        121
      ],
      "id": "TR-11-1825",
      "t": "Inside-Color Rainbow Hyacinth/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        138,
        162,
        70
      ],
      "id": "TR-11-1829",
      "t": "Inside-Color Rainbow Jonquil/Forest Green-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        118,
        199,
        134
      ],
      "id": "TR-11-1830",
      "t": "Inside-Color Rainbow Lt Jonquil/Mint-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        62,
        140,
        134
      ],
      "id": "TR-11-1833",
      "t": "Inside-Color Rainbow Lt Sapphire/Opaque Teal-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        119,
        147,
        217
      ],
      "id": "TR-11-1837",
      "t": "Inside-Color Rainbow Aqua/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        224,
        199,
        120
      ],
      "id": "TR-11-1846",
      "t": "Inside-Color/Transparent-Rainbow Orange Creamcicle-Lined",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        167,
        121,
        58
      ],
      "id": "TR-11-1853",
      "t": "Transparent Rainbow Honey Comb",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        140,
        188,
        99
      ],
      "id": "TR-11-2024",
      "t": "Silver-Lined Rainbow Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        61,
        145,
        108
      ],
      "id": "TR-11-2036",
      "t": "Silver-Lined Rainbow Green Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        228,
        227,
        223
      ],
      "id": "TR-11-2100",
      "t": "Silver-Lined Milky White",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        209,
        203,
        199
      ],
      "id": "TR-11-PF2101",
      "t": "PermaFinish - Silver-Lined Milky Cloud",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        142,
        167,
        187
      ],
      "id": "TR-11-PF2102",
      "t": "PermaFinish - Silver-Lined Milky Montana Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        114,
        182,
        167
      ],
      "id": "TR-11-PF2103",
      "t": "PermaFinish - Silver-Lined Milky Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        30,
        192,
        161
      ],
      "id": "TR-11-2104",
      "t": "Silver-Lined Milky Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        73,
        211,
        184
      ],
      "id": "TR-11-PF2104",
      "t": "PermaFinish - Silver-Lined Milky Teal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        213,
        175,
        194
      ],
      "id": "TR-11-PF2105",
      "t": "PermaFinish - Silver-Lined Milky Baby Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        233,
        128,
        143
      ],
      "id": "TR-11-PF2106",
      "t": "PermaFinish - Silver-Lined Milky Mauve",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        171,
        59,
        135
      ],
      "id": "TR-11-2107",
      "t": "Silver-Lined Milky Hot Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        224,
        132,
        187
      ],
      "id": "TR-11-PF2107",
      "t": "PermaFinish - Silver-Lined Milky Electric Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        175,
        134,
        185
      ],
      "id": "TR-11-2108",
      "t": "Silver-Lined Milky Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        174,
        147,
        170
      ],
      "id": "TR-11-PF2108",
      "t": "PermaFinish - Silver-Lined Milky Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        210,
        201,
        162
      ],
      "id": "TR-11-PF2109",
      "t": "PermaFinish - Silver-Lined Milky Jonquil",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        230,
        183,
        112
      ],
      "id": "TR-11-2110",
      "t": "Silver-Lined Milky Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        209,
        153,
        84
      ],
      "id": "TR-11-PF2110",
      "t": "PermaFinish - Silver-Lined Milky Lt Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        218,
        153,
        144
      ],
      "id": "TR-11-2111",
      "t": "Silver-Lined Milky Peach",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        250,
        199,
        176
      ],
      "id": "TR-11-PF2111",
      "t": "PermaFinish - Silver-Lined Milky Peach",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        250,
        177,
        141
      ],
      "id": "TR-11-2112",
      "t": "Silver-Lined Milky Grapefruit",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        239,
        154,
        112
      ],
      "id": "TR-11-PF2112",
      "t": "PermaFinish - Silver-Lined Milky Grapefruit",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        136,
        63,
        54
      ],
      "id": "TR-11-PF2113",
      "t": "PermaFinish - Silver-Lined Milky Pomegranate",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        156,
        127,
        139
      ],
      "id": "TR-11-2114",
      "t": "Silver-Lined Milky Nutmeg",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        151,
        144,
        145
      ],
      "id": "TR-11-PF2115",
      "t": "PermaFinish - Silver-Lined Milky Gray",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        177,
        220,
        208
      ],
      "id": "TR-11-2116",
      "t": "Silver-Lined Milky Lt Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        180,
        221,
        202
      ],
      "id": "TR-11-PF2116",
      "t": "PermaFinish - Silver-Lined Milky Lt Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        46,
        193,
        199
      ],
      "id": "TR-11-2117",
      "t": "Silver-Lined Milky Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        106,
        199,
        188
      ],
      "id": "TR-11-PF2117",
      "t": "PermaFinish - Silver-Lined Milky Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        143,
        207,
        175
      ],
      "id": "TR-11-PF2118",
      "t": "PermaFinish - Silver-Lined Milky Lt Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        64,
        165,
        137
      ],
      "id": "TR-11-2119",
      "t": "Silver-Lined Milky Dk Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        113,
        195,
        153
      ],
      "id": "TR-11-PF2119",
      "t": "PermaFinish - Silver-Lined Milky Dk Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        205,
        160,
        175
      ],
      "id": "TR-11-PF2120",
      "t": "PermaFinish - Silver-Lined Milky Soft Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        216,
        173,
        185
      ],
      "id": "TR-11-PF2121",
      "t": "PermaFinish - Silver-Lined Milky Lt Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        194,
        182,
        201
      ],
      "id": "TR-11-PF2122",
      "t": "PermaFinish - Silver-Lined Milky Alexandrite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        145,
        170,
        203
      ],
      "id": "TR-11-PF2123",
      "t": "PermaFinish - Silver-Lined Milky Sapphire",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        124,
        117,
        141
      ],
      "id": "TR-11-PF2124",
      "t": "PermaFinish - Silver-Lined Milky Tanzanite",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        206,
        195,
        144
      ],
      "id": "TR-11-PF2125",
      "t": "PermaFinish - Silver-Lined Milky Lt Jonquil",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        223,
        194,
        187
      ],
      "id": "TR-11-PF2126",
      "t": "PermaFinish - Silver-Lined Milky Peachy Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        218,
        183,
        90
      ],
      "id": "TR-11-2151",
      "t": "Transparent Champagne",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        223,
        200,
        124
      ],
      "id": "TR-11-2151S",
      "t": "Silver-Lined Champagne",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        153,
        92,
        33
      ],
      "id": "TR-11-2152S",
      "t": "Silver-Lined Sasparilla",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        153,
        71,
        32
      ],
      "id": "TR-11-2154S",
      "t": "Silver-Lined Marmalade",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        181,
        142,
        21
      ],
      "id": "TR-11-2155",
      "t": "Transparent Chamomile",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        173,
        108,
        51
      ],
      "id": "TR-11-2156",
      "t": "Transparent Honey",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        241,
        109,
        111
      ],
      "id": "TR-11-2201",
      "t": "Silver-Lined Almond Blossom",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        96,
        123,
        99
      ],
      "id": "TR-11-2202",
      "t": "Silver-Lined Prairie Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        67,
        69,
        100
      ],
      "id": "TR-11-2203",
      "t": "Silver-Lined Navy",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        106,
        76,
        67
      ],
      "id": "TR-11-2204",
      "t": "Dyed Silver-Lined Pink Frosted Olivine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        59,
        46,
        35
      ],
      "id": "TR-11-2205",
      "t": "Silver-Lined Root Beer",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        37,
        65,
        172
      ],
      "id": "TR-11-2206C",
      "t": "Silver-Lined Dk Aqua",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        142,
        39,
        21
      ],
      "id": "TR-11-2208",
      "t": "Silver-Lined Burnt Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        32,
        33,
        30
      ],
      "id": "TR-11-2209",
      "t": "Silver-Lined Dk Emerald",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        138,
        39,
        114
      ],
      "id": "TR-11-2217",
      "t": "Silver-Lined Milky Fuchsia",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        180,
        67,
        87
      ],
      "id": "TR-11-2218",
      "t": "Silver-Lined Mauve",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        159,
        95,
        138
      ],
      "id": "TR-11-2219",
      "t": "Silver-Lined Lt Grape",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        93,
        60,
        118
      ],
      "id": "TR-11-2224",
      "t": "Silver-Lined Purple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        172,
        175,
        57
      ],
      "id": "TR-11-2600F",
      "t": "Semi Glazed - Lemongrass",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        128,
        130,
        59
      ],
      "id": "TR-11-2601F",
      "t": "Semi Glazed - Olive",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        145,
        163,
        91
      ],
      "id": "TR-11-2602F",
      "t": "Semi Glazed - Honeydew",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        113,
        140,
        80
      ],
      "id": "TR-11-2603F",
      "t": "Semi Glazed - Clover",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        114,
        153,
        149
      ],
      "id": "TR-11-2604F",
      "t": "Semi Glazed - Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        112,
        141,
        151
      ],
      "id": "TR-11-2605F",
      "t": "Semi Glazed - Blue Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        108,
        129,
        182
      ],
      "id": "TR-11-2606F",
      "t": "Semi Glazed - Soft Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        57,
        61,
        120
      ],
      "id": "TR-11-2607F",
      "t": "Semi Glazed - Navy Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        133,
        124,
        132
      ],
      "id": "TR-11-2608F",
      "t": "Semi Glazed - Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        128,
        67,
        60
      ],
      "id": "TR-11-2609F",
      "t": "Semi Glazed - Dk Red",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        150,
        79,
        48
      ],
      "id": "TR-11-2610F",
      "t": "Semi Glazed - Burnt Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        209,
        108,
        57
      ],
      "id": "TR-11-2611F",
      "t": "Semi Glazed - Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        29,
        30,
        30
      ],
      "id": "TR-11-2612F",
      "t": "Semi Glazed - Jet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        167,
        167,
        76
      ],
      "id": "TR-11-2630F",
      "t": "Semi Glazed Rainbow - Lemongrass",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        139,
        142,
        76
      ],
      "id": "TR-11-2631F",
      "t": "Semi Glazed Rainbow - Olive",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        144,
        159,
        99
      ],
      "id": "TR-11-2632F",
      "t": "Semi Glazed Rainbow - Honeydew",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        124,
        146,
        91
      ],
      "id": "TR-11-2633F",
      "t": "Semi Glazed Rainbow - Clover",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        106,
        148,
        142
      ],
      "id": "TR-11-2634F",
      "t": "Semi Glazed Rainbow - Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        110,
        133,
        141
      ],
      "id": "TR-11-2635F",
      "t": "Semi Glazed Rainbow - Blue Turquoise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        118,
        136,
        164
      ],
      "id": "TR-11-2636F",
      "t": "Semi Glazed Rainbow - Soft Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        101,
        100,
        130
      ],
      "id": "TR-11-2637F",
      "t": "Semi Glazed Rainbow - Navy Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        122,
        117,
        117
      ],
      "id": "TR-11-2638F",
      "t": "Semi Glazed Rainbow - Lavender",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        115,
        88,
        87
      ],
      "id": "TR-11-2639F",
      "t": "Semi Glazed Rainbow - Dk Red",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        143,
        97,
        100
      ],
      "id": "TR-11-2640F",
      "t": "Semi Glazed Rainbow - Burnt Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        188,
        123,
        92
      ],
      "id": "TR-11-2641F",
      "t": "Semi Glazed Rainbow - Orange",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        76,
        67,
        76
      ],
      "id": "TR-11-2642F",
      "t": "Semi Glazed Rainbow - Jet",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        176,
        176,
        170
      ],
      "id": "TR-11-2700",
      "t": "Glow In The Dark - Crystal/Glow Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        160,
        158,
        151
      ],
      "id": "TR-11-PF2700S",
      "t": "Glow In The Dark - Silver-Lined Crystal/Glow Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        169,
        169,
        164
      ],
      "id": "TR-11-2701",
      "t": "Glow In The Dark - Crystal/Glow Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        170,
        168,
        157
      ],
      "id": "TR-11-PF2701S",
      "t": "Glow In The Dark - Silver-Lined Crystal/Glow Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        190,
        189,
        180
      ],
      "id": "TR-11-2710",
      "t": "Glow In The Dark - Crystal/Bright Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        189,
        179,
        173
      ],
      "id": "TR-11-2711",
      "t": "Glow In The Dark - Crystal/Bright Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        187,
        164,
        156
      ],
      "id": "TR-11-2720",
      "t": "Glow In The Dark - Pink/Yellow Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        139,
        186,
        112
      ],
      "id": "TR-11-2721",
      "t": "Glow In The Dark - Yellow/Bright Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        139,
        164,
        131
      ],
      "id": "TR-11-2722",
      "t": "Glow In The Dark - Mint Green/Bright Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        140,
        189,
        181
      ],
      "id": "TR-11-2723",
      "t": "Glow In The Dark - Baby Blue/Bright Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        170,
        134,
        167
      ],
      "id": "TR-11-2724",
      "t": "Glow In The Dark - Dark Pink/Green Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        124,
        120,
        128
      ],
      "id": "TR-11-2725",
      "t": "Glow In The Dark - Gray Crystal/Bright Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        31,
        37,
        29
      ],
      "id": "TR-11-Y302",
      "t": "HYBRID Jet - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        43,
        45,
        44
      ],
      "id": "TR-11-Y302F",
      "t": "HYBRID Frosted Jet - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        76,
        42,
        41
      ],
      "id": "TR-11-Y304",
      "t": "HYBRID Pepper Red - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        58,
        40,
        33
      ],
      "id": "TR-11-Y304F",
      "t": "HYBRID Frosted Pepper Red - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        102,
        93,
        18
      ],
      "id": "TR-11-Y310",
      "t": "HYBRID Sour Apple - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        47,
        38,
        33
      ],
      "id": "TR-11-Y313",
      "t": "HYBRID Transparent Lt Topaz - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        42,
        39,
        38
      ],
      "id": "TR-11-Y313F",
      "t": "HYBRID Transparent Frosted Lt Topaz - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        67,
        74,
        64
      ],
      "id": "TR-11-Y314F",
      "t": "HYBRID Transparent Frosted Aquamarine - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        86,
        79,
        36
      ],
      "id": "TR-11-Y315",
      "t": "HYBRID Transparent Lime Green - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        93,
        79,
        37
      ],
      "id": "TR-11-Y315F",
      "t": "HYBRID Transparent Frosted Lime Green - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        41,
        35,
        36
      ],
      "id": "TR-11-Y316F",
      "t": "HYBRID Transparent Frosted Siam Ruby - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        49,
        32,
        27
      ],
      "id": "TR-11-Y317",
      "t": "HYBRID Transparent Lt Amethyst - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        60,
        44,
        33
      ],
      "id": "TR-11-Y317F",
      "t": "HYBRID Transparent Frosted Lt Amethyst - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        61,
        73,
        25
      ],
      "id": "TR-11-Y318",
      "t": "HYBRID Transparent Peridot - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        137,
        131,
        17
      ],
      "id": "TR-11-Y319",
      "t": "HYBRID Opaque Dandelion - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        92,
        82,
        9
      ],
      "id": "TR-11-Y319F",
      "t": "HYBRID Opaque-Frosted Dandelion - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        117,
        151,
        68
      ],
      "id": "TR-11-Y321",
      "t": "HYBRID Opaque Mint Green - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        89,
        109,
        47
      ],
      "id": "TR-11-Y321F",
      "t": "HYBRID Opaque-Frosted Mint Green - Picasso",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        88,
        71,
        113
      ],
      "id": "TR-11-Y612",
      "t": "HYBRID Metallic Suede - Purple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        63,
        94,
        81
      ],
      "id": "TR-11-Y614",
      "t": "HYBRID Metallic Suede - Lt Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        104,
        100,
        63
      ],
      "id": "TR-11-Y615",
      "t": "HYBRID Metallic Suede - Gold",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        105,
        81,
        96
      ],
      "id": "TR-11-Y617",
      "t": "HYBRID Metallic Suede - Pink",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        190,
        157,
        67
      ],
      "id": "TR-11-Y618",
      "t": "HYBRID Sueded Gold Topaz",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        137,
        195,
        254
      ],
      "id": "TR-11-Y619",
      "t": "HYBRID Sueded Gold Transparent Aquamarine",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        154,
        172,
        38
      ],
      "id": "TR-11-Y620",
      "t": "HYBRID Sueded Gold Transparent Lime Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        234,
        221,
        17
      ],
      "id": "TR-11-Y621",
      "t": "HYBRID Sueded Gold Opaque Dandelion",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        205,
        233,
        99
      ],
      "id": "TR-11-Y622",
      "t": "HYBRID Sueded Gold Sour Apple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        224,
        80,
        52
      ],
      "id": "TR-11-Y625",
      "t": "HYBRID Sueded Gold Siam Ruby",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        144,
        121,
        122
      ],
      "id": "TR-11-Y628",
      "t": "HYBRID Sueded Gold Transparent Amethyst",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        74,
        129,
        28
      ],
      "id": "TR-11-Y629",
      "t": "HYBRID Sueded Gold Transparent Peridot",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        216,
        215,
        195
      ],
      "id": "TR-11-Y630",
      "t": "HYBRID Sueded Gold Crystal",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        232,
        218,
        150
      ],
      "id": "TR-11-Y631",
      "t": "HYBRID Lt Sueded Gold Lt Lame'",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        40,
        39,
        32
      ],
      "id": "TR-11-Y633",
      "t": "HYBRID Metallic Suede - Dk Green",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        144,
        140,
        154
      ],
      "id": "TR-11-Y862",
      "t": "HYBRID Oxidized Bronze Purple",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        50,
        56,
        44
      ],
      "id": "TR-11-Y912",
      "t": "HYBRID Polychrome - Olive Mauve",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        224,
        233,
        234
      ],
      "id": "TR-11-Y914",
      "t": "HYBRID Luster Snowflake",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        249,
        217,
        149
      ],
      "id": "TR-11-Y915",
      "t": "HYBRID Sueded Gold Opaque Lt. Beige",
      "dt": ""
    },
    {
      "a": 9,
      "b": 3,
      "c": [
        178,
        206,
        232
      ],
      "id": "TR-11-YPS0011",
      "t": "HYBRID ColorTrends: Metallic - Airy Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        165,
        37,
        38
      ],
      "id": "TR-11-YPS0022",
      "t": "HYBRID ColorTrends: Milky - Aurora Red",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        113,
        98,
        124
      ],
      "id": "TR-11-YPS0023",
      "t": "HYBRID ColorTrends: Milky - Dusty Cedar",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        181,
        206,
        254
      ],
      "id": "TR-11-YPS0024",
      "t": "HYBRID ColorTrends: Milky - Airy Blue",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        168,
        135,
        127
      ],
      "id": "TR-11-YPS0025",
      "t": "HYBRID ColorTrends: Milky - Hazelnut",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        232,
        191,
        60
      ],
      "id": "TR-11-YPS0027",
      "t": "HYBRID ColorTrends: Milky - Primrose Yellow",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        117,
        230,
        254
      ],
      "id": "TR-11-YPS0029",
      "t": "HYBRID ColorTrends: Milky - Island Paradise",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        104,
        132,
        100
      ],
      "id": "TR-11-YPS0033",
      "t": "HYBRID ColorTrends: Milky - Greenery",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        73,
        70,
        136
      ],
      "id": "TR-11-YPS0035",
      "t": "HYBRID ColorTrends: Transparent - Riverside",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        28,
        38,
        136
      ],
      "id": "TR-11-YPS0065",
      "t": "HYBRID ColorTrends: Milky - Riverside",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        64,
        134,
        114
      ],
      "id": "TR-11-YPS0066",
      "t": "HYBRID ColorTrends: Milky - Lush Meadow",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        191,
        159,
        103
      ],
      "id": "TR-11-YPS0067",
      "t": "HYBRID ColorTrends: Milky - Spicy Mustard",
      "dt": ""
    },
    {
      "a": 9,
      "b": 2,
      "c": [
        104,
        70,
        62
      ],
      "id": "TR-11-YPS0069",
      "t": "HYBRID ColorTrends: Milky - Potters Clay",
      "dt": ""
    },
    {
      "a": 9,
      "b": 1,
      "c": [
        195,
        162,
        153
      ],
      "id": "TR-11-YPS0070",
      "t": "HYBRID ColorTrends: Milky - Warm Taupe",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        222,
        221,
        226
      ],
      "id": "TR-15-1",
      "t": "Transparent Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        234,
        234,
        228
      ],
      "id": "TR-15-1F",
      "t": "Transparent-Frosted Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        218,
        140,
        25
      ],
      "id": "TR-15-2",
      "t": "Transparent Lt Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        209,
        144,
        41
      ],
      "id": "TR-15-2F",
      "t": "Transparent-Frosted Lt Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        188,
        90,
        22
      ],
      "id": "TR-15-2C",
      "t": "Transparent Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        194,
        99,
        13
      ],
      "id": "TR-15-2CF",
      "t": "Transparent-Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        23,
        177,
        232
      ],
      "id": "TR-15-3",
      "t": "Transparent Aquamarine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        27,
        189,
        250
      ],
      "id": "TR-15-3F",
      "t": "Transparent-Frosted Aquamarine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        13,
        142,
        238
      ],
      "id": "TR-15-3B",
      "t": "Transparent Dk Aquamarine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        18,
        158,
        235
      ],
      "id": "TR-15-3BF",
      "t": "Transparent-Frosted Med Aquamarine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        148,
        190,
        37
      ],
      "id": "TR-15-4",
      "t": "Transparent Lime Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        155,
        200,
        57
      ],
      "id": "TR-15-4F",
      "t": "Transparent-Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        229,
        51,
        34
      ],
      "id": "TR-15-5",
      "t": "Transparent Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        237,
        32,
        34
      ],
      "id": "TR-15-5F",
      "t": "Transparent-Frosted Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        225,
        27,
        25
      ],
      "id": "TR-15-5B",
      "t": "Transparent Siam Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        224,
        22,
        22
      ],
      "id": "TR-15-5BF",
      "t": "Transparent-Frosted Siam Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        171,
        57,
        62
      ],
      "id": "TR-15-5C",
      "t": "Transparent Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        172,
        60,
        56
      ],
      "id": "TR-15-5CF",
      "t": "Transparent-Frosted Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        164,
        120,
        133
      ],
      "id": "TR-15-6",
      "t": "Transparent Lt Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        163,
        113,
        129
      ],
      "id": "TR-15-6F",
      "t": "Transparent-Frosted Lt Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        103,
        68,
        85
      ],
      "id": "TR-15-6BF",
      "t": "Transparent-Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        56,
        30,
        47
      ],
      "id": "TR-15-6C",
      "t": "Transparent Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        60,
        48,
        49
      ],
      "id": "TR-15-6CF",
      "t": "Transparent-Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        47,
        161,
        70
      ],
      "id": "TR-15-7",
      "t": "Transparent Peridot",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        20,
        164,
        43
      ],
      "id": "TR-15-7F",
      "t": "Transparent-Frosted Peridot",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        28,
        128,
        52
      ],
      "id": "TR-15-7B",
      "t": "Transparent Grass Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        27,
        92,
        105
      ],
      "id": "TR-15-7BD",
      "t": "Transparent Capri Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        16,
        100,
        106
      ],
      "id": "TR-15-7BDF",
      "t": "Transparent Frosted Teal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        38,
        21,
        116
      ],
      "id": "TR-15-8",
      "t": "Transparent Cobalt",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        43,
        33,
        125
      ],
      "id": "TR-15-8F",
      "t": "Transparent-Frosted Dk Sapphire",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        64,
        49,
        105
      ],
      "id": "TR-15-8DF",
      "t": "Transparent-Frosted Cobalt",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        125,
        130,
        133
      ],
      "id": "TR-15-9F",
      "t": "Transparent-Frosted Lt Gray",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        80,
        88,
        86
      ],
      "id": "TR-15-9B",
      "t": "Transparent Gray",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        254,
        84,
        5
      ],
      "id": "TR-15-10B",
      "t": "Transparent Hyacinth",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        254,
        73,
        4
      ],
      "id": "TR-15-10BF",
      "t": "Transparent-Frosted Hyacinth",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        225,
        179,
        174
      ],
      "id": "TR-15-11",
      "t": "Transparent Rosaline",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        229,
        186,
        180
      ],
      "id": "TR-15-11F",
      "t": "Transparent-Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        239,
        226,
        27
      ],
      "id": "TR-15-12",
      "t": "Transparent Lemon",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        242,
        242,
        117
      ],
      "id": "TR-15-12F",
      "t": "Transparent-Frosted Lemon",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        114,
        139,
        213
      ],
      "id": "TR-15-13",
      "t": "Transparent Lt Sapphire",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        120,
        161,
        237
      ],
      "id": "TR-15-13F",
      "t": "Transparent-Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        42,
        40,
        40
      ],
      "id": "TR-15-14",
      "t": "Transparent - Root Beer",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        160,
        147,
        171
      ],
      "id": "TR-15-19",
      "t": "Transparent Sugar Plum",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        140,
        119,
        162
      ],
      "id": "TR-15-19F",
      "t": "Transparent-Frosted Sugar Plum",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        222,
        218,
        212
      ],
      "id": "TR-15-21",
      "t": "Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        222,
        218,
        207
      ],
      "id": "TR-15-21F",
      "t": "Silver-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        230,
        226,
        219
      ],
      "id": "TR-15-PF21F",
      "t": "PermaFinish - Silver-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        237,
        196,
        101
      ],
      "id": "TR-15-22",
      "t": "Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        225,
        188,
        108
      ],
      "id": "TR-15-22B",
      "t": "Silver-Lined Med Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        208,
        139,
        54
      ],
      "id": "TR-15-22C",
      "t": "Silver-Lined Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        172,
        131,
        33
      ],
      "id": "TR-15-22CF",
      "t": "Silver-Lined Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        120,
        204,
        213
      ],
      "id": "TR-15-23",
      "t": "Silver-Lined Aquamarine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        53,
        190,
        210
      ],
      "id": "TR-15-23B",
      "t": "Silver-Lined Dk Aqua",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        95,
        176,
        202
      ],
      "id": "TR-15-23BF",
      "t": "Silver-Lined Frosted Dk Aqua",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        175,
        195,
        66
      ],
      "id": "TR-15-24",
      "t": "Silver-Lined Lime Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        63,
        190,
        152
      ],
      "id": "TR-15-24B",
      "t": "Silver-Lined Dk Peridot",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        230,
        91,
        49
      ],
      "id": "TR-15-25",
      "t": "Silver-Lined Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        220,
        68,
        50
      ],
      "id": "TR-15-25B",
      "t": "Silver-Lined Siam Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        169,
        53,
        52
      ],
      "id": "TR-15-25C",
      "t": "Silver-Lined Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        131,
        42,
        19
      ],
      "id": "TR-15-25CF",
      "t": "Silver-Lined Frosted Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        174,
        140,
        141
      ],
      "id": "TR-15-26",
      "t": "Silver-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        139,
        99,
        99
      ],
      "id": "TR-15-26B",
      "t": "Silver-Lined Med Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        126,
        91,
        95
      ],
      "id": "TR-15-26C",
      "t": "Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        57,
        181,
        60
      ],
      "id": "TR-15-27",
      "t": "Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        34,
        139,
        47
      ],
      "id": "TR-15-27B",
      "t": "Silver-Lined Grass Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        36,
        81,
        85
      ],
      "id": "TR-15-27BD",
      "t": "Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        71,
        128,
        121
      ],
      "id": "TR-15-27BDF",
      "t": "Silver-Lined Frosted Teal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        58,
        57,
        161
      ],
      "id": "TR-15-28",
      "t": "Silver-Lined Cobalt",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        132,
        135,
        117
      ],
      "id": "TR-15-29B",
      "t": "Silver-Lined Gray",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        236,
        76,
        3
      ],
      "id": "TR-15-30B",
      "t": "Silver-Lined Hyacinth",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        233,
        193,
        170
      ],
      "id": "TR-15-31",
      "t": "Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        231,
        217,
        80
      ],
      "id": "TR-15-32",
      "t": "Silver-Lined Lemon",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        138,
        166,
        199
      ],
      "id": "TR-15-33",
      "t": "Silver-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        156,
        101,
        67
      ],
      "id": "TR-15-34",
      "t": "Silver-Lined Smoky Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        198,
        124,
        43
      ],
      "id": "TR-15-34F",
      "t": "Silver-Lined Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        97,
        131,
        214
      ],
      "id": "TR-15-35",
      "t": "Silver-Lined Sapphire",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        36,
        146,
        72
      ],
      "id": "TR-15-36",
      "t": "Silver-Lined Green Emerald",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        123,
        125,
        88
      ],
      "id": "TR-15-37",
      "t": "Silver-Lined Olivine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        132,
        149,
        78
      ],
      "id": "TR-15-37F",
      "t": "Silver-Lined Frosted Olive",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        237,
        132,
        163
      ],
      "id": "TR-15-38",
      "t": "Silver-Lined Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        156,
        145,
        155
      ],
      "id": "TR-15-39",
      "t": "Silver-Lined Tanzanite",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        234,
        235,
        230
      ],
      "id": "TR-15-41",
      "t": "Opaque White",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        243,
        247,
        243
      ],
      "id": "TR-15-41F",
      "t": "Opaque-Frosted White",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        247,
        240,
        40
      ],
      "id": "TR-15-42",
      "t": "Opaque Dandelion",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        137,
        219,
        244
      ],
      "id": "TR-15-43",
      "t": "Opaque Blue Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        75,
        168,
        243
      ],
      "id": "TR-15-43D",
      "t": "Opaque Cornflower",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        186,
        216,
        125
      ],
      "id": "TR-15-44",
      "t": "Opaque Sour Apple",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        201,
        31,
        7
      ],
      "id": "TR-15-45",
      "t": "Opaque Pepper Red",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        173,
        36,
        29
      ],
      "id": "TR-15-45A",
      "t": "Opaque Cherry",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        114,
        72,
        57
      ],
      "id": "TR-15-46",
      "t": "Opaque Oxblood",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        104,
        60,
        46
      ],
      "id": "TR-15-46F",
      "t": "Opaque-Frosted Oxblood",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        187,
        97,
        69
      ],
      "id": "TR-15-46L",
      "t": "Opaque Terra Cotta",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        137,
        59,
        29
      ],
      "id": "TR-15-46LF",
      "t": "Opaque-Frosted Terra Cotta",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        80,
        198,
        94
      ],
      "id": "TR-15-47",
      "t": "Opaque Mint Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        28,
        95,
        32
      ],
      "id": "TR-15-47H",
      "t": "Opaque Pine Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        52,
        41,
        171
      ],
      "id": "TR-15-48",
      "t": "Opaque Navy Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        37,
        40,
        40
      ],
      "id": "TR-15-49",
      "t": "Opaque Jet",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        43,
        44,
        44
      ],
      "id": "TR-15-49F",
      "t": "Opaque-Frosted Jet",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        250,
        87,
        48
      ],
      "id": "TR-15-50",
      "t": "Opaque Sunset Orange",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        245,
        237,
        216
      ],
      "id": "TR-15-51",
      "t": "Opaque Lt Beige",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        165,
        119,
        135
      ],
      "id": "TR-15-52",
      "t": "Opaque Lavender",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        195,
        199,
        198
      ],
      "id": "TR-15-53",
      "t": "Opaque Gray",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        93,
        217,
        205
      ],
      "id": "TR-15-55",
      "t": "Opaque Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        13,
        172,
        130
      ],
      "id": "TR-15-72",
      "t": "Transparent Beach Glass Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        17,
        171,
        132
      ],
      "id": "TR-15-72F",
      "t": "Transparent-Frosted Dk Peridot",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        91,
        97,
        112
      ],
      "id": "TR-15-81",
      "t": "Metallic Hematite",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        48,
        67,
        128
      ],
      "id": "TR-15-82",
      "t": "Metallic Nebula",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        126,
        114,
        103
      ],
      "id": "TR-15-83",
      "t": "Metallic Iris - Brown",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        72,
        89,
        71
      ],
      "id": "TR-15-84",
      "t": "Metallic Iris - Green/Brown",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        150,
        101,
        119
      ],
      "id": "TR-15-85",
      "t": "Metallic Iris - Purple",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        99,
        84,
        84
      ],
      "id": "TR-15-85F",
      "t": "Frosted Metallic Iris - Purple",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        67,
        88,
        106
      ],
      "id": "TR-15-86",
      "t": "Metallic Rainbow Iris",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        83,
        116,
        125
      ],
      "id": "TR-15-86F",
      "t": "Opaque-Frosted-Rainbow Iris",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        84,
        109,
        199
      ],
      "id": "TR-15-87",
      "t": "Transparent-Rainbow Cobalt",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        132,
        152,
        166
      ],
      "id": "TR-15-88",
      "t": "Metallic Cosmos",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        106,
        120,
        112
      ],
      "id": "TR-15-89",
      "t": "Metallic Moss",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        140,
        108,
        139
      ],
      "id": "TR-15-90",
      "t": "Metallic Amethyst Gun Metal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        240,
        205,
        202
      ],
      "id": "TR-15-106",
      "t": "Transparent-Lustered Rosaline",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        92,
        144,
        159
      ],
      "id": "TR-15-108BD",
      "t": "Transparent-Lustered Teal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        159,
        134,
        145
      ],
      "id": "TR-15-115",
      "t": "Transparent-Lustered Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        235,
        234,
        230
      ],
      "id": "TR-15-121",
      "t": "Opaque-Lustered White",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        235,
        229,
        213
      ],
      "id": "TR-15-122",
      "t": "Opaque-Lustered Navajo White",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        232,
        216,
        189
      ],
      "id": "TR-15-123",
      "t": "Opaque-Lustered Lt Beige",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        236,
        194,
        131
      ],
      "id": "TR-15-123D",
      "t": "Opaque-Lustered Dk Beige",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        201,
        228,
        236
      ],
      "id": "TR-15-124",
      "t": "Opaque-Lustered Pale Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        245,
        196,
        204
      ],
      "id": "TR-15-126",
      "t": "Opaque-Lustered Baby Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        210,
        167,
        186
      ],
      "id": "TR-15-127",
      "t": "Opaque-Lustered Pale Mauve",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        120,
        204,
        192
      ],
      "id": "TR-15-132",
      "t": "Opaque-Lustered Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        216,
        225,
        231
      ],
      "id": "TR-15-141",
      "t": "Ceylon Snowflake",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        167,
        223,
        194
      ],
      "id": "TR-15-144",
      "t": "Ceylon Celery",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        245,
        190,
        198
      ],
      "id": "TR-15-145",
      "t": "Ceylon Innocent Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        224,
        213,
        201
      ],
      "id": "TR-15-147",
      "t": "Ceylon Lt Ivory",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        226,
        181,
        104
      ],
      "id": "TR-15-148",
      "t": "Ceylon Peach Cobbler",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        178,
        180,
        181
      ],
      "id": "TR-15-150",
      "t": "Ceylon Smoke",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        185,
        161,
        169
      ],
      "id": "TR-15-151",
      "t": "Ceylon Grape Mist",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        134,
        210,
        168
      ],
      "id": "TR-15-156",
      "t": "Ceylon Jade",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        224,
        225,
        224
      ],
      "id": "TR-15-161",
      "t": "Transparent-Rainbow Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        235,
        234,
        230
      ],
      "id": "TR-15-161F",
      "t": "Transparent-Rainbow Frosted Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        236,
        188,
        83
      ],
      "id": "TR-15-162",
      "t": "Transparent-Rainbow Lt Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        213,
        160,
        95
      ],
      "id": "TR-15-162B",
      "t": "Transparent-Rainbow Med Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        207,
        153,
        96
      ],
      "id": "TR-15-162C",
      "t": "Transparent-Rainbow Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        161,
        110,
        61
      ],
      "id": "TR-15-162CF",
      "t": "Transparent-Rainbow Frosted Dk Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        82,
        208,
        248
      ],
      "id": "TR-15-163",
      "t": "Transparent-Rainbow Aquamarine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        51,
        167,
        234
      ],
      "id": "TR-15-163B",
      "t": "Transparent-Rainbow Dk Aqua",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        191,
        207,
        115
      ],
      "id": "TR-15-164",
      "t": "Transparent-Rainbow Lime Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        213,
        67,
        80
      ],
      "id": "TR-15-165C",
      "t": "Transparent-Rainbow Ruby",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        176,
        157,
        164
      ],
      "id": "TR-15-166",
      "t": "Transparent Rainbow Lt Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        159,
        114,
        145
      ],
      "id": "TR-15-166B",
      "t": "Transparent Rainbow Med Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        135,
        115,
        150
      ],
      "id": "TR-15-166C",
      "t": "Transparent Rainbow Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        125,
        97,
        123
      ],
      "id": "TR-15-166CF",
      "t": "Transparent Rainbow Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        103,
        125,
        168
      ],
      "id": "TR-15-166DF",
      "t": "Transparent Rainbow Frosted Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        65,
        133,
        148
      ],
      "id": "TR-15-167BD",
      "t": "Transparent-Rainbow Teal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        44,
        147,
        182
      ],
      "id": "TR-15-167BDF",
      "t": "Transparent-Rainbow Frosted Teal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        156,
        173,
        237
      ],
      "id": "TR-15-168",
      "t": "Transparent-Rainbow Lt Sapphire",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        225,
        186,
        176
      ],
      "id": "TR-15-169",
      "t": "Transparent-Rainbow Rosaline",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        250,
        206,
        218
      ],
      "id": "TR-15-171",
      "t": "Dyed-Rainbow Ballerina Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        253,
        196,
        208
      ],
      "id": "TR-15-171D",
      "t": "Transparent-Rainbow Ballerina Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        127,
        142,
        138
      ],
      "id": "TR-15-176",
      "t": "Transparent-Rainbow Black Diamond",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        133,
        140,
        142
      ],
      "id": "TR-15-176B",
      "t": "Transparent-Rainbow Gray",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        131,
        122,
        101
      ],
      "id": "TR-15-177",
      "t": "Transparent-Rainbow Smoky Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        165,
        141,
        113
      ],
      "id": "TR-15-177F",
      "t": "Transparent-Rainbow Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        76,
        100,
        222
      ],
      "id": "TR-15-178",
      "t": "Transparent-Rainbow Sapphire",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        121,
        135,
        98
      ],
      "id": "TR-15-180",
      "t": "Transparent-Rainbow Olivine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        116,
        112,
        166
      ],
      "id": "TR-15-181",
      "t": "Inside-Color Rainbow Crystal/Tanzanite-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        96,
        139,
        160
      ],
      "id": "TR-15-188",
      "t": "Inside-Color Luster Crystal/Capri Blue-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        117,
        144,
        180
      ],
      "id": "TR-15-189",
      "t": "Inside-Color Luster Crystal/Caribbean Blue-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        195,
        125,
        132
      ],
      "id": "TR-15-201",
      "t": "Gold-Lustered Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        165,
        141,
        116
      ],
      "id": "TR-15-204",
      "t": "Gold-Lustered Montana Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        165,
        84,
        147
      ],
      "id": "TR-15-205",
      "t": "Gold-Lustered Dk Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        129,
        131,
        161
      ],
      "id": "TR-15-206",
      "t": "Gold-Lustered Hydrangea",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        193,
        128,
        77
      ],
      "id": "TR-15-221",
      "t": "Bronze",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        128,
        102,
        61
      ],
      "id": "TR-15-221F",
      "t": "Frosted Bronze",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        154,
        116,
        111
      ],
      "id": "TR-15-222",
      "t": "Dk Bronze",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        156,
        119,
        51
      ],
      "id": "TR-15-223",
      "t": "Antique Bronze",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        109,
        85,
        44
      ],
      "id": "TR-15-223F",
      "t": "Frosted Antique Bronze",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        100,
        62,
        27
      ],
      "id": "TR-15-224",
      "t": "Olympic Bronze",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        118,
        114,
        62
      ],
      "id": "TR-15-225",
      "t": "Bronze Antique Gold",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        192,
        51,
        78
      ],
      "id": "TR-15-241",
      "t": "Inside-Color Rainbow Lt Topaz/Mauve-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        128,
        146,
        119
      ],
      "id": "TR-15-243",
      "t": "Inside-Color Topaz/Opaque Emerald-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        113,
        119,
        108
      ],
      "id": "TR-15-245",
      "t": "Inside-Color Rainbow Jonquil/Jet-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        179,
        175,
        89
      ],
      "id": "TR-15-246",
      "t": "Inside-Color Luster Black Diamond/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        71,
        91,
        72
      ],
      "id": "TR-15-247",
      "t": "Inside-Color Peridot/Oxblood-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        80,
        134,
        124
      ],
      "id": "TR-15-249",
      "t": "Inside-Color Peridot/Emerald-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        119,
        101,
        115
      ],
      "id": "TR-15-251",
      "t": "Inside-Color Luster Lt Amethyst/Jet-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        153,
        132,
        181
      ],
      "id": "TR-15-252",
      "t": "Inside-Color Aqua/Purple-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        173,
        176,
        169
      ],
      "id": "TR-15-261",
      "t": "Inside-Color Rainbow Crystal/Gray-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        201,
        188,
        162
      ],
      "id": "TR-15-262",
      "t": "Inside-Color Crystal/Gold-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        120,
        206,
        182
      ],
      "id": "TR-15-264",
      "t": "Inside-Color Rainbow Crystal/Teal-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        197,
        158,
        169
      ],
      "id": "TR-15-267",
      "t": "Inside-Color Crystal/Rose Gold-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        76,
        148,
        155
      ],
      "id": "TR-15-270",
      "t": "Inside-Color Crystal/Prairie Green-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        145,
        144,
        124
      ],
      "id": "TR-15-271",
      "t": "Gold-Lined Luster - Black Diamond",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        90,
        143,
        160
      ],
      "id": "TR-15-274",
      "t": "Inside-Color Rainbow Crystal/Green Teal-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        119,
        101,
        96
      ],
      "id": "TR-15-278",
      "t": "Gold-Lined Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        145,
        133,
        89
      ],
      "id": "TR-15-279",
      "t": "Inside-Color Rainbow Lt Topaz/Gray-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        136,
        166,
        139
      ],
      "id": "TR-15-284",
      "t": "Inside-Color Aqua/Gold-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        153,
        175,
        184
      ],
      "id": "TR-15-288",
      "t": "Inside-Color Crystal/Metallic Blue-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        237,
        181,
        187
      ],
      "id": "TR-15-289",
      "t": "Transparent - Lt French Rose",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        222,
        137,
        122
      ],
      "id": "TR-15-303",
      "t": "Inside-Color Jonquil/Hyacinth-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        139,
        203,
        106
      ],
      "id": "TR-15-307",
      "t": "Inside-Color Aqua/Opaque Yellow-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        75,
        110,
        111
      ],
      "id": "TR-15-321",
      "t": "Gold-Lustered Lt Tanzanite",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        87,
        132,
        109
      ],
      "id": "TR-15-322",
      "t": "Gold-Lustered Emerald",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        186,
        106,
        62
      ],
      "id": "TR-15-329",
      "t": "Gold-Lustered African Sunset",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        201,
        118,
        143
      ],
      "id": "TR-15-332",
      "t": "Gold-Lustered Raspberry",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        243,
        108,
        113
      ],
      "id": "TR-15-341",
      "t": "Inside-Color Crystal/Tomato-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        241,
        222,
        182
      ],
      "id": "TR-15-352",
      "t": "Inside-Color Crystal/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        146,
        107,
        106
      ],
      "id": "TR-15-363",
      "t": "Inside-Color Montana Blue/Oxblood-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        214,
        110,
        105
      ],
      "id": "TR-15-365",
      "t": "Inside-Color Lt Topaz/Pomegranate-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        252,
        202,
        212
      ],
      "id": "TR-15-379",
      "t": "Inside-Color Crystal/Cotton Candy-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        133,
        179,
        126
      ],
      "id": "TR-15-380",
      "t": "Inside-Color Topaz/Mint Julep-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        73,
        56,
        54
      ],
      "id": "TR-15-400",
      "t": "Inside-Color Rainbow Ruby/Jet-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        232,
        232,
        227
      ],
      "id": "TR-15-401",
      "t": "Opaque-Rainbow White",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        133,
        110,
        132
      ],
      "id": "TR-15-406",
      "t": "Opaque-Rainbow Oxblood",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        105,
        133,
        232
      ],
      "id": "TR-15-408",
      "t": "Opaque-Rainbow Navy Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        121,
        208,
        199
      ],
      "id": "TR-15-413",
      "t": "Opaque-Rainbow Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        213,
        167,
        112
      ],
      "id": "TR-15-421",
      "t": "Gold-Lustered Transparent Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        110,
        110,
        70
      ],
      "id": "TR-15-422",
      "t": "Gold-Lustered Dk Antique Bronze",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        150,
        151,
        160
      ],
      "id": "TR-15-455",
      "t": "Gold-Lustered Pale Wisteria",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        170,
        168,
        137
      ],
      "id": "TR-15-457",
      "t": "Gold-Lustered Green Tea",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        190,
        158,
        116
      ],
      "id": "TR-15-459",
      "t": "Gold-Lustered Dk Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        171,
        95,
        188
      ],
      "id": "TR-15-461",
      "t": "Higher-Metallic Grape",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        207,
        192,
        218
      ],
      "id": "TR-15-477D",
      "t": "Transparent-Rainbow Foxglove",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        166,
        98,
        101
      ],
      "id": "TR-15-502",
      "t": "Higher-Metallic Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        130,
        68,
        110
      ],
      "id": "TR-15-503",
      "t": "Higher-Metallic Dk Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        84,
        58,
        84
      ],
      "id": "TR-15-504",
      "t": "Higher-Metallic Iris - Violet",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        81,
        148,
        164
      ],
      "id": "TR-15-505",
      "t": "Higher-Metallic Dragonfly",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        47,
        166,
        162
      ],
      "id": "TR-15-506",
      "t": "Higher-Metallic June Bug",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        141,
        163,
        107
      ],
      "id": "TR-15-508",
      "t": "Higher-Metallic Iris - Olivine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        145,
        114,
        81
      ],
      "id": "TR-15-509",
      "t": "Higher-Metallic Iris - Purple/Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        157,
        138,
        64
      ],
      "id": "TR-15-513F",
      "t": "Higher-Metallic Frosted Carnival",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        220,
        182,
        140
      ],
      "id": "TR-15-PF551",
      "t": "PermaFinish - Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        238,
        208,
        202
      ],
      "id": "TR-15-PF552",
      "t": "PermaFinish - Galvanized Sweet Blush",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        218,
        152,
        185
      ],
      "id": "TR-15-553",
      "t": "Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        219,
        164,
        180
      ],
      "id": "TR-15-PF553",
      "t": "PermaFinish - Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        155,
        134,
        125
      ],
      "id": "TR-15-556",
      "t": "Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        150,
        115,
        99
      ],
      "id": "TR-15-PF556",
      "t": "PermaFinish - Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        222,
        196,
        123
      ],
      "id": "TR-15-557",
      "t": "Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        224,
        180,
        93
      ],
      "id": "TR-15-PF557F",
      "t": "PermaFinish - Matte Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        199,
        173,
        93
      ],
      "id": "TR-15-PF557",
      "t": "PermaFinish - Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        233,
        223,
        189
      ],
      "id": "TR-15-558",
      "t": "Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        194,
        183,
        144
      ],
      "id": "TR-15-PF558F",
      "t": "PermaFinish - Matte Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        201,
        195,
        157
      ],
      "id": "TR-15-PF558",
      "t": "PermaFinish - Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        234,
        102,
        33
      ],
      "id": "TR-15-PF562",
      "t": "PermaFinish - Galvanized Saffron",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        120,
        124,
        104
      ],
      "id": "TR-15-566",
      "t": "Metallic Frosted Antique Silver",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        164,
        167,
        208
      ],
      "id": "TR-15-PF567",
      "t": "PermaFinish - Metallic Polaris",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        174,
        212,
        171
      ],
      "id": "TR-15-PF570",
      "t": "PermaFinish - Galvanized Mint Green",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        38,
        185,
        166
      ],
      "id": "TR-15-PF578F",
      "t": "PermaFinish - Frosted Galvanized Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        115,
        123,
        128
      ],
      "id": "TR-15-611",
      "t": "Matte-Color Opaque Gray",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        131,
        149,
        155
      ],
      "id": "TR-15-612",
      "t": "Matte-Color Gun Metal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        151,
        147,
        132
      ],
      "id": "TR-15-613",
      "t": "Matte-Color Iris - Gray",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        158,
        146,
        124
      ],
      "id": "TR-15-614",
      "t": "Matte-Color Iris - Brown",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        134,
        114,
        140
      ],
      "id": "TR-15-615",
      "t": "Matte-Color Iris - Purple",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        129,
        134,
        93
      ],
      "id": "TR-15-617",
      "t": "Matte-Color Dk Olive",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        218,
        175,
        101
      ],
      "id": "TR-15-701",
      "t": "24K Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        116,
        90,
        56
      ],
      "id": "TR-15-702",
      "t": "Matte-Color Dk Copper",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        157,
        107,
        114
      ],
      "id": "TR-15-703",
      "t": "Matte-Color Mauve Mocha",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        149,
        82,
        117
      ],
      "id": "TR-15-704",
      "t": "Matte-Color Andromeda",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        124,
        144,
        168
      ],
      "id": "TR-15-705",
      "t": "Matte-Color Iris - Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        104,
        175,
        164
      ],
      "id": "TR-15-706",
      "t": "Matte-Color Iris - Teal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        119,
        148,
        112
      ],
      "id": "TR-15-707",
      "t": "Matte-Color Iris - Peridot",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        128,
        143,
        129
      ],
      "id": "TR-15-708",
      "t": "Matte-Color Cassiopeia",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        125,
        112,
        96
      ],
      "id": "TR-15-709",
      "t": "Matte-Color Iris - Violet",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        212,
        204,
        187
      ],
      "id": "TR-15-711",
      "t": "Nickel",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        242,
        212,
        140
      ],
      "id": "TR-15-712",
      "t": "Metallic 24K Gold Plated",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        190,
        192,
        170
      ],
      "id": "TR-15-714",
      "t": "Metallic Silver",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        116,
        135,
        106
      ],
      "id": "TR-15-721",
      "t": "Galvanized Blue Gold",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        225,
        166,
        126
      ],
      "id": "TR-15-740",
      "t": "Copper-Lined Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        236,
        190,
        177
      ],
      "id": "TR-15-741",
      "t": "Copper-Lined Alabaster",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        237,
        239,
        245
      ],
      "id": "TR-15-761",
      "t": "Matte-Color Opaque-Rainbow White",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        240,
        225,
        190
      ],
      "id": "TR-15-762",
      "t": "Opaque-Pastel-Frosted Egg Shell",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        241,
        217,
        186
      ],
      "id": "TR-15-763",
      "t": "Opaque-Pastel-Frosted Apricot",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        233,
        202,
        191
      ],
      "id": "TR-15-764",
      "t": "Opaque-Pastel-Frosted Shrimp",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        228,
        176,
        189
      ],
      "id": "TR-15-765",
      "t": "Opaque-Pastel-Frosted Plumeria",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        225,
        178,
        189
      ],
      "id": "TR-15-766",
      "t": "Opaque-Pastel-Frosted Lt Lilac",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        243,
        244,
        248
      ],
      "id": "TR-15-767",
      "t": "Opaque-Pastel-Frosted Lt Gray",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        198,
        157,
        160
      ],
      "id": "TR-15-771",
      "t": "Inside-Color Rainbow Crystal/Strawberry-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        161,
        194,
        205
      ],
      "id": "TR-15-773",
      "t": "Inside-Color Rainbow Crystal/Montana Blue-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        113,
        124,
        147
      ],
      "id": "TR-15-774",
      "t": "Inside-Color Rainbow Crystal/Grape-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        237,
        152,
        149
      ],
      "id": "TR-15-779",
      "t": "Inside-Color Rainbow Crystal/Salmon-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        183,
        124,
        126
      ],
      "id": "TR-15-784",
      "t": "Inside-Color Rainbow Crystal/Sandstone-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        251,
        103,
        141
      ],
      "id": "TR-15-910",
      "t": "Ceylon Hot Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        247,
        166,
        174
      ],
      "id": "TR-15-911",
      "t": "Ceylon Impatiens Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        136,
        140,
        185
      ],
      "id": "TR-15-922",
      "t": "Ceylon Gladiola",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        198,
        177,
        190
      ],
      "id": "TR-15-926",
      "t": "Inside-Color Lt Topaz/Opaque Lavender-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        172,
        131,
        218
      ],
      "id": "TR-15-928",
      "t": "Inside-Color Rainbow Rosaline/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        68,
        89,
        111
      ],
      "id": "TR-15-929",
      "t": "Inside-Color Rainbow Lt Yellow/Capri-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        45,
        104,
        161
      ],
      "id": "TR-15-932",
      "t": "Inside-Color Aqua/Capri-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        151,
        143,
        228
      ],
      "id": "TR-15-934",
      "t": "Inside-Color Lt Sapphire/Opaque Purple-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        35,
        94,
        69
      ],
      "id": "TR-15-939",
      "t": "Transparent Green Emerald",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        21,
        88,
        54
      ],
      "id": "TR-15-939F",
      "t": "Transparent-Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        78,
        88,
        62
      ],
      "id": "TR-15-940",
      "t": "Transparent Olivine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        72,
        88,
        55
      ],
      "id": "TR-15-940F",
      "t": "Transparent-Frosted Olivine",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        36,
        25,
        17
      ],
      "id": "TR-15-941",
      "t": "Transparent Smoky Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        91,
        51,
        24
      ],
      "id": "TR-15-941F",
      "t": "Transparent Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        72,
        76,
        213
      ],
      "id": "TR-15-942F",
      "t": "Transparent-Frosted Sapphire",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        176,
        189,
        163
      ],
      "id": "TR-15-952",
      "t": "Inside-Color Rainbow Lt Topaz/Sea Foam-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        89,
        203,
        159
      ],
      "id": "TR-15-954",
      "t": "Inside-Color Aqua/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        127,
        197,
        188
      ],
      "id": "TR-15-954F",
      "t": "Inside-Color Frosted Aqua/Lt Jonquil-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        145,
        105,
        109
      ],
      "id": "TR-15-960",
      "t": "Inside-Color Lt Topaz/Pink-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        206,
        82,
        163
      ],
      "id": "TR-15-980",
      "t": "Luminous Lt Sapphire/Neon Pink-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        242,
        240,
        233
      ],
      "id": "TR-15-981",
      "t": "Inside-Color Crystal/Snow-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        197,
        190,
        141
      ],
      "id": "TR-15-989",
      "t": "Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        121,
        110,
        88
      ],
      "id": "TR-15-989F",
      "t": "Gold-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        208,
        175,
        151
      ],
      "id": "TR-15-994",
      "t": "Gold-Lined Rainbow Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        184,
        191,
        170
      ],
      "id": "TR-15-995",
      "t": "Gold-Lined Rainbow Aqua",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        127,
        119,
        75
      ],
      "id": "TR-15-998",
      "t": "Gold-Lined Rainbow Lt Jonquil",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        190,
        167,
        137
      ],
      "id": "TR-15-999",
      "t": "Gold-Lined Rainbow Black Diamond",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        99,
        90,
        60
      ],
      "id": "TR-15-999F",
      "t": "Gold-Lined Frosted Black Diamond",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        196,
        179,
        186
      ],
      "id": "TR-15-1010",
      "t": "Silver-Lined Luster - Med Amethyst",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        121,
        82,
        93
      ],
      "id": "TR-15-1076",
      "t": "Inside-Color Gray/Magenta-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        117,
        192,
        140
      ],
      "id": "TR-15-1144",
      "t": "Milky Kiwi",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        84,
        123,
        110
      ],
      "id": "TR-15-1829",
      "t": "Inside-Color Rainbow Jonquil/Forest Green-Lined",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        221,
        217,
        206
      ],
      "id": "TR-15-2100",
      "t": "Silver-Lined Milky White",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        121,
        165,
        200
      ],
      "id": "TR-15-2102",
      "t": "Silver-Lined Milky Montana Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        189,
        83,
        162
      ],
      "id": "TR-15-2107",
      "t": "Silver-Lined Milky Hot Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        197,
        95,
        152
      ],
      "id": "TR-15-PF2107",
      "t": "PermaFinish - Translucent Silver-Lined Hot Pink",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        227,
        180,
        110
      ],
      "id": "TR-15-2110",
      "t": "Silver-Lined Milky Lt Topaz",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        129,
        58,
        63
      ],
      "id": "TR-15-2113",
      "t": "Silver-Lined Milky Pomegranate",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        172,
        77,
        17
      ],
      "id": "TR-15-2208",
      "t": "Silver-Lined Burnt Orange",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        190,
        62,
        89
      ],
      "id": "TR-15-2218",
      "t": "Silver-Lined Mauve",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        122,
        85,
        107
      ],
      "id": "TR-15-2219",
      "t": "Silver-Lined Lt Grape",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        83,
        39,
        61
      ],
      "id": "TR-15-2223",
      "t": "Silver-Lined Dragonfruit",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        85,
        50,
        111
      ],
      "id": "TR-15-2224",
      "t": "Silver-Lined Purple",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        155,
        152,
        26
      ],
      "id": "TR-15-2600F",
      "t": "Semi Glazed - Lemongrass",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        121,
        119,
        21
      ],
      "id": "TR-15-2601F",
      "t": "Semi Glazed - Olive",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        144,
        154,
        80
      ],
      "id": "TR-15-2602F",
      "t": "Semi Glazed - Honeydew",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        93,
        121,
        60
      ],
      "id": "TR-15-2603F",
      "t": "Semi Glazed - Clover",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        105,
        145,
        151
      ],
      "id": "TR-15-2604F",
      "t": "Semi Glazed - Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        127,
        151,
        162
      ],
      "id": "TR-15-2605F",
      "t": "Semi Glazed - Blue Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        95,
        109,
        170
      ],
      "id": "TR-15-2606F",
      "t": "Semi Glazed - Soft Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        37,
        42,
        100
      ],
      "id": "TR-15-2607F",
      "t": "Semi Glazed - Navy Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        111,
        98,
        108
      ],
      "id": "TR-15-2608F",
      "t": "Semi Glazed - Lavender",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        72,
        19,
        16
      ],
      "id": "TR-15-2609F",
      "t": "Semi Glazed - Dk Red",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        136,
        49,
        21
      ],
      "id": "TR-15-2610F",
      "t": "Semi Glazed - Burnt Orange",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        166,
        68,
        31
      ],
      "id": "TR-15-2611F",
      "t": "Semi Glazed - Orange",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        25,
        27,
        27
      ],
      "id": "TR-15-2612F",
      "t": "Semi Glazed - Jet",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        156,
        153,
        55
      ],
      "id": "TR-15-2630F",
      "t": "Semi Glazed Rainbow - Lemongrass",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        138,
        140,
        84
      ],
      "id": "TR-15-2631F",
      "t": "Semi Glazed Rainbow - Olive",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        136,
        145,
        81
      ],
      "id": "TR-15-2632F",
      "t": "Semi Glazed Rainbow - Honeydew",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        103,
        117,
        74
      ],
      "id": "TR-15-2633F",
      "t": "Semi Glazed Rainbow - Clover",
      "dt": ""
    },
    {
      "a": 10,
      "b": 1,
      "c": [
        145,
        174,
        165
      ],
      "id": "TR-15-2634F",
      "t": "Semi Glazed Rainbow - Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        121,
        140,
        140
      ],
      "id": "TR-15-2635F",
      "t": "Semi Glazed Rainbow - Blue Turquoise",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        113,
        128,
        164
      ],
      "id": "TR-15-2636F",
      "t": "Semi Glazed Rainbow - Soft Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        54,
        64,
        116
      ],
      "id": "TR-15-2637F",
      "t": "Semi Glazed Rainbow - Navy Blue",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        137,
        127,
        128
      ],
      "id": "TR-15-2638F",
      "t": "Semi Glazed Rainbow - Lavender",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        111,
        81,
        95
      ],
      "id": "TR-15-2639F",
      "t": "Semi Glazed Rainbow - Dk Red",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        151,
        102,
        72
      ],
      "id": "TR-15-2640F",
      "t": "Semi Glazed Rainbow - Burnt Orange",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        168,
        99,
        85
      ],
      "id": "TR-15-2641F",
      "t": "Semi Glazed Rainbow - Orange",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        48,
        48,
        73
      ],
      "id": "TR-15-2642F",
      "t": "Semi Glazed Rainbow - Jet",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        234,
        234,
        228
      ],
      "id": "TR-15-Y610",
      "t": "HYBRID Sueded Crystal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        87,
        165,
        209
      ],
      "id": "TR-15S-23B",
      "t": "Silver-Lined Dk Aqua",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        48,
        83,
        76
      ],
      "id": "TR-15S-27BD",
      "t": "Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 10,
      "b": 2,
      "c": [
        250,
        209,
        6
      ],
      "id": "TR-15S-30",
      "t": "Silver-Lined Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 10,
      "b": 3,
      "c": [
        139,
        157,
        190
      ],
      "id": "TR-15S-33",
      "t": "Silver-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        221,
        220,
        223
      ],
      "id": "TT-01-1",
      "t": "Transparent Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        231,
        231,
        225
      ],
      "id": "TT-01-1F",
      "t": "Transparent Frosted Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        214,
        152,
        56
      ],
      "id": "TT-01-2",
      "t": "Transparent Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        204,
        96,
        28
      ],
      "id": "TT-01-2C",
      "t": "Transparent Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        144,
        81,
        4
      ],
      "id": "TT-01-2CF",
      "t": "Transparent Frosted Dark Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        12,
        168,
        224
      ],
      "id": "TT-01-3",
      "t": "Transparent Aquamarine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        0,
        110,
        213
      ],
      "id": "TT-01-3B",
      "t": "Transparent Dark Aquamarine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        0,
        109,
        211
      ],
      "id": "TT-01-3BF",
      "t": "Transparent Frosted Dark Aquamarine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        153,
        186,
        1
      ],
      "id": "TT-01-4",
      "t": "Transparent Lime Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        175,
        205,
        0
      ],
      "id": "TT-01-4F",
      "t": "Transparent Frosted Lime Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        223,
        30,
        14
      ],
      "id": "TT-01-5F",
      "t": "Transparent Frosted Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        168,
        16,
        41
      ],
      "id": "TT-01-5B",
      "t": "Transparent Siam Ruby",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        134,
        40,
        46
      ],
      "id": "TT-01-5CF",
      "t": "Transparent Frosted Ruby",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        77,
        27,
        23
      ],
      "id": "TT-01-5D",
      "t": "Transparent Garnet",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        135,
        120,
        130
      ],
      "id": "TT-01-6",
      "t": "Transparent Lt Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        89,
        65,
        68
      ],
      "id": "TT-01-6F",
      "t": "Transparent Frosted Lt Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        107,
        72,
        87
      ],
      "id": "TT-01-6B",
      "t": "Transparent Med Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        115,
        72,
        96
      ],
      "id": "TT-01-6BF",
      "t": "Transparent Frosted Med Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        59,
        42,
        52
      ],
      "id": "TT-01-6CF",
      "t": "Transparent Frosted Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        31,
        156,
        52
      ],
      "id": "TT-01-7",
      "t": "Transparent Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        4,
        98,
        31
      ],
      "id": "TT-01-7F",
      "t": "Transparent Frosted Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        2,
        89,
        9
      ],
      "id": "TT-01-7B",
      "t": "Transparent Grass Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        43,
        149,
        81
      ],
      "id": "TT-01-7BF",
      "t": "Transparent Frosted Grass Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        43,
        97,
        109
      ],
      "id": "TT-01-7BD",
      "t": "Transparent Capri Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        26,
        113,
        122
      ],
      "id": "TT-01-7BDF",
      "t": "Transparent Frosted Teal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        25,
        37,
        142
      ],
      "id": "TT-01-8",
      "t": "Transparent Cobalt",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        46,
        79,
        73
      ],
      "id": "TT-01-9",
      "t": "Transparent Black Diamond",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        131,
        136,
        136
      ],
      "id": "TT-01-9F",
      "t": "Transparent Frosted Lt Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        115,
        125,
        123
      ],
      "id": "TT-01-9B",
      "t": "Transparent Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        82,
        83,
        82
      ],
      "id": "TT-01-9BF",
      "t": "Transparent Frosted Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        251,
        167,
        10
      ],
      "id": "TT-01-10",
      "t": "Transparent Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        236,
        120,
        48
      ],
      "id": "TT-01-10F",
      "t": "Transparent Frosted Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        238,
        183,
        168
      ],
      "id": "TT-01-11",
      "t": "Transparent Rosaline",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        225,
        175,
        148
      ],
      "id": "TT-01-11F",
      "t": "Transparent Frosted Rosaline",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        199,
        221,
        52
      ],
      "id": "TT-01-12F",
      "t": "Transparent Frosted Lemon",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        89,
        99,
        233
      ],
      "id": "TT-01-13",
      "t": "Transparent Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        86,
        97,
        214
      ],
      "id": "TT-01-13F",
      "t": "Transparent Frosted Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        42,
        40,
        40
      ],
      "id": "TT-01-14F",
      "t": "Transparent Frosted Root Beer",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        196,
        232,
        141
      ],
      "id": "TT-01-15F",
      "t": "Transparent Frosted Citrus Spritz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        0,
        73,
        196
      ],
      "id": "TT-01-16",
      "t": "Transparent Kyanite",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        15,
        90,
        203
      ],
      "id": "TT-01-16F",
      "t": "Transparent Frosted Kyanite",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        232,
        229,
        216
      ],
      "id": "TT-01-21",
      "t": "Transparent Silver-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        213,
        203,
        182
      ],
      "id": "TT-01-PF21",
      "t": "PermaFinish Silver-Lined Transparent Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        213,
        188,
        100
      ],
      "id": "TT-01-22",
      "t": "Transparent Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        179,
        143,
        79
      ],
      "id": "TT-01-22F",
      "t": "Matte Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        215,
        178,
        86
      ],
      "id": "TT-01-22B",
      "t": "Silver-Lined Med Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        169,
        94,
        30
      ],
      "id": "TT-01-22C",
      "t": "Transparent Silver-Lined Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        159,
        98,
        45
      ],
      "id": "TT-01-22CF",
      "t": "Matte Silver-Lined Dark Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        195,
        147,
        44
      ],
      "id": "TT-01-PF22",
      "t": "PermaFinish Silver-Lined Transparent Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        57,
        178,
        206
      ],
      "id": "TT-01-23",
      "t": "Transparent Silver-Lined Aquamarine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        51,
        139,
        162
      ],
      "id": "TT-01-23B",
      "t": "Transparent Silver-Lined Dark Aquamarine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        193,
        203,
        22
      ],
      "id": "TT-01-24",
      "t": "Transparent Silver-Lined Lime Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        237,
        118,
        40
      ],
      "id": "TT-01-25",
      "t": "Transparent Silver-Lined Lt Siam Ruby",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        178,
        25,
        16
      ],
      "id": "TT-01-25B",
      "t": "Transparent Silver-Lined Siam Ruby",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        127,
        64,
        43
      ],
      "id": "TT-01-25C",
      "t": "Transparent Silver-Lined Ruby",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        107,
        61,
        51
      ],
      "id": "TT-01-25D",
      "t": "Transparent Silver-Lined Garnet",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        133,
        93,
        87
      ],
      "id": "TT-01-26B",
      "t": "Transparent Silver-Lined Med Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        26,
        130,
        41
      ],
      "id": "TT-01-27",
      "t": "Transparent Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        77,
        142,
        48
      ],
      "id": "TT-01-27F",
      "t": "Frosted Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        17,
        105,
        22
      ],
      "id": "TT-01-27B",
      "t": "Transparent Silver-Lined Grass Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        28,
        71,
        68
      ],
      "id": "TT-01-27BD",
      "t": "Transparent Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        32,
        99,
        103
      ],
      "id": "TT-01-27BDF",
      "t": "Matte Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        46,
        55,
        159
      ],
      "id": "TT-01-28",
      "t": "Transparent Silver-Lined Cobalt",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        163,
        167,
        144
      ],
      "id": "TT-01-29",
      "t": "Transparent Silver-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        252,
        89,
        22
      ],
      "id": "TT-01-30B",
      "t": "Silver-Lined Hyacinth",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        216,
        184,
        159
      ],
      "id": "TT-01-31F",
      "t": "Matte Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        223,
        221,
        71
      ],
      "id": "TT-01-32",
      "t": "Transparent Silver-Lined Lemon",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        107,
        55,
        32
      ],
      "id": "TT-01-34",
      "t": "Transparent Silver-Lined Smokey Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        77,
        122,
        192
      ],
      "id": "TT-01-35",
      "t": "Transparent Silver-Lined Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        47,
        142,
        82
      ],
      "id": "TT-01-36",
      "t": "Transparent Silver-Lined Green Emerald",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        250,
        179,
        203
      ],
      "id": "TT-01-38",
      "t": "Silver-Lined Pink",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        242,
        242,
        237
      ],
      "id": "TT-01-41",
      "t": "Opaque White",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        228,
        233,
        226
      ],
      "id": "TT-01-41F",
      "t": "Opaque Frosted White",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        247,
        240,
        29
      ],
      "id": "TT-01-42",
      "t": "Opaque Dandelion",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        149,
        208,
        226
      ],
      "id": "TT-01-43",
      "t": "Opaque Kingman Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        139,
        207,
        228
      ],
      "id": "TT-01-43F",
      "t": "Opaque Frosted Blue Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        63,
        130,
        186
      ],
      "id": "TT-01-43D",
      "t": "Opaque Cornflower",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        89,
        145,
        203
      ],
      "id": "TT-01-43DF",
      "t": "Opaque Frosted Kingman Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        166,
        221,
        86
      ],
      "id": "TT-01-44",
      "t": "Opaque Sour Apple",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        213,
        43,
        52
      ],
      "id": "TT-01-45",
      "t": "Opaque Pepper Red",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        161,
        48,
        44
      ],
      "id": "TT-01-45F",
      "t": "Opaque Frosted Pepper Red",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        221,
        49,
        48
      ],
      "id": "TT-01-45A",
      "t": "Opaque Cherry",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        182,
        48,
        53
      ],
      "id": "TT-01-45AF",
      "t": "Opaque Frosted Cherry",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        93,
        75,
        70
      ],
      "id": "TT-01-46",
      "t": "Opaque Oxblood",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        77,
        58,
        52
      ],
      "id": "TT-01-46F",
      "t": "Opaque Frosted Oxblood",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        139,
        56,
        32
      ],
      "id": "TT-01-46L",
      "t": "Opaque Burnt Orange",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        80,
        198,
        76
      ],
      "id": "TT-01-47",
      "t": "Opaque Mint Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        35,
        162,
        69
      ],
      "id": "TT-01-47D",
      "t": "Opaque Shamrock",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        66,
        169,
        88
      ],
      "id": "TT-01-47DF",
      "t": "Opaque Frosted Shamrock",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        50,
        85,
        48
      ],
      "id": "TT-01-47H",
      "t": "Opaque Pine Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        36,
        98,
        49
      ],
      "id": "TT-01-47HF",
      "t": "Opaque Frosted Pine Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        94,
        94,
        198
      ],
      "id": "TT-01-48",
      "t": "Opaque Navy-Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        116,
        124,
        217
      ],
      "id": "TT-01-48L",
      "t": "Opaque Periwinkle",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        114,
        127,
        218
      ],
      "id": "TT-01-48LF",
      "t": "Opaque Frosted Periwinkle",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        36,
        38,
        38
      ],
      "id": "TT-01-49",
      "t": "Opaque Jet",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        30,
        33,
        32
      ],
      "id": "TT-01-49F",
      "t": "Opaque Matte Jet",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        254,
        70,
        52
      ],
      "id": "TT-01-50",
      "t": "Opaque Sunset Orange",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        231,
        215,
        173
      ],
      "id": "TT-01-51",
      "t": "Opaque Lt Beige",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        220,
        206,
        168
      ],
      "id": "TT-01-51F",
      "t": "Opaque Frosted Lt Beige",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        130,
        94,
        109
      ],
      "id": "TT-01-52",
      "t": "Opaque Lavender",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        159,
        129,
        142
      ],
      "id": "TT-01-52F",
      "t": "Opaque Frosted Lavender",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        128,
        138,
        139
      ],
      "id": "TT-01-53",
      "t": "Opaque Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        172,
        173,
        178
      ],
      "id": "TT-01-53F",
      "t": "Opaque Frosted Cornflower",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        52,
        160,
        144
      ],
      "id": "TT-01-55",
      "t": "Opaque Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        97,
        185,
        185
      ],
      "id": "TT-01-55F",
      "t": "Opaque Frosted Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        58,
        66,
        76
      ],
      "id": "TT-01-81",
      "t": "Metallic Hematite",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        44,
        71,
        98
      ],
      "id": "TT-01-82",
      "t": "Metallic Nebula",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        58,
        66,
        97
      ],
      "id": "TT-01-82F",
      "t": "Metallic Frosted Nebula",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        90,
        78,
        49
      ],
      "id": "TT-01-83",
      "t": "Metallic Brown Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        98,
        97,
        86
      ],
      "id": "TT-01-83F",
      "t": "Metallic Frosted Brown Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        73,
        87,
        64
      ],
      "id": "TT-01-84",
      "t": "Metallic Green-Brown Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        50,
        73,
        77
      ],
      "id": "TT-01-84F",
      "t": "Metallic Frosted Green-Brown Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        130,
        96,
        108
      ],
      "id": "TT-01-85",
      "t": "Metallic Purple Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        62,
        65,
        64
      ],
      "id": "TT-01-85F",
      "t": "Metallic Frosted Purple Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        93,
        118,
        120
      ],
      "id": "TT-01-86",
      "t": "Metallic Iris Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        62,
        59,
        81
      ],
      "id": "TT-01-86F",
      "t": "Metallic Frosted Iris Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        28,
        65,
        175
      ],
      "id": "TT-01-87",
      "t": "Transparent Cobalt Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        28,
        40,
        72
      ],
      "id": "TT-01-88",
      "t": "Metallic Cosmos",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        48,
        65,
        52
      ],
      "id": "TT-01-89",
      "t": "Metallic Moss",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        132,
        129,
        154
      ],
      "id": "TT-01-90",
      "t": "Metallic Gunmetal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        158,
        124,
        98
      ],
      "id": "TT-01-103C",
      "t": "Transparent Topaz Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        67,
        138,
        203
      ],
      "id": "TT-01-104B",
      "t": "Transparent Dark Aqua Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        166,
        200,
        63
      ],
      "id": "TT-01-105",
      "t": "Transparent Lime Green Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        228,
        172,
        144
      ],
      "id": "TT-01-106",
      "t": "Transparent Rosaline Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        126,
        148,
        210
      ],
      "id": "TT-01-107",
      "t": "Transparent Lt Sapphire Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        72,
        135,
        99
      ],
      "id": "TT-01-108B",
      "t": "Transparent Grass Green Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        81,
        108,
        118
      ],
      "id": "TT-01-108BD",
      "t": "Transparent Teal Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        217,
        84,
        65
      ],
      "id": "TT-01-109",
      "t": "Transparent Lt Siam Ruby Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        156,
        59,
        74
      ],
      "id": "TT-01-109B",
      "t": "Transparent Siam Ruby Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        123,
        62,
        72
      ],
      "id": "TT-01-109C",
      "t": "Transparent Ruby Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        91,
        66,
        82
      ],
      "id": "TT-01-110B",
      "t": "Transparent Med Amethyst Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        233,
        120,
        51
      ],
      "id": "TT-01-111",
      "t": "Transparent Lt Hyacinth Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        102,
        115,
        119
      ],
      "id": "TT-01-112",
      "t": "Transparent Black Diamond Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        106,
        112,
        115
      ],
      "id": "TT-01-113",
      "t": "Transparent Gray Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        101,
        72,
        70
      ],
      "id": "TT-01-114",
      "t": "Transparent Smokey Topaz Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        56,
        58,
        135
      ],
      "id": "TT-01-116",
      "t": "Transparent Cobalt Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        77,
        80,
        187
      ],
      "id": "TT-01-117",
      "t": "Transparent Sapphire Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        40,
        94,
        75
      ],
      "id": "TT-01-118",
      "t": "Transparent Green Emerald Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        85,
        107,
        96
      ],
      "id": "TT-01-119",
      "t": "Transparent Olivine Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        244,
        243,
        239
      ],
      "id": "TT-01-121",
      "t": "Opaque White Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        244,
        239,
        223
      ],
      "id": "TT-01-122",
      "t": "Opaque Navajo White Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        246,
        233,
        207
      ],
      "id": "TT-01-123",
      "t": "Opaque Lt Beige Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        202,
        156,
        94
      ],
      "id": "TT-01-123D",
      "t": "Opaque Dark Beige Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        108,
        190,
        240
      ],
      "id": "TT-01-124B",
      "t": "Opaque Baby Blue Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        212,
        178,
        26
      ],
      "id": "TT-01-128",
      "t": "Opaque Dandelion Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        243,
        215,
        50
      ],
      "id": "TT-01-128B",
      "t": "Opaque Sunshine Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        88,
        152,
        98
      ],
      "id": "TT-01-130",
      "t": "Opaque Mint Green Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        65,
        152,
        88
      ],
      "id": "TT-01-130D",
      "t": "Opaque Shamrock Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        171,
        189,
        76
      ],
      "id": "TT-01-131",
      "t": "Opaque Sour Apple Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        155,
        142,
        158
      ],
      "id": "TT-01-133",
      "t": "Opaque Lavender Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        128,
        143,
        203
      ],
      "id": "TT-01-134",
      "t": "Opaque Periwinkle Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        193,
        212,
        124
      ],
      "id": "TT-01-135",
      "t": "Transparent Lemon-Lime Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        110,
        99,
        129
      ],
      "id": "TT-01-136",
      "t": "Transparent Sugar Plum Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        218,
        215,
        207
      ],
      "id": "TT-01-141",
      "t": "Ceylon Snowflake",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        233,
        233,
        228
      ],
      "id": "TT-01-141F",
      "t": "Ceylon Frosted Snowflake",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        244,
        230,
        117
      ],
      "id": "TT-01-142F",
      "t": "Ceylon Frosted Banana Creme",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        131,
        211,
        234
      ],
      "id": "TT-01-143F",
      "t": "Ceylon Frosted Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        138,
        208,
        154
      ],
      "id": "TT-01-144",
      "t": "Ceylon Celery Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        123,
        206,
        139
      ],
      "id": "TT-01-144F",
      "t": "Ceylon Frosted Celery",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        253,
        201,
        207
      ],
      "id": "TT-01-145",
      "t": "Ceylon Innocent Pink",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        254,
        151,
        164
      ],
      "id": "TT-01-145F",
      "t": "Ceylon Frosted Innocent Pink",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        147,
        166,
        221
      ],
      "id": "TT-01-146F",
      "t": "Ceylon Frosted Glacier",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        244,
        226,
        199
      ],
      "id": "TT-01-147",
      "t": "Ceylon Light Ivory",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        239,
        183,
        39
      ],
      "id": "TT-01-148F",
      "t": "Ceylon Frosted Peach Cobbler",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        131,
        139,
        143
      ],
      "id": "TT-01-150",
      "t": "Ceylon Smoke",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        114,
        114,
        111
      ],
      "id": "TT-01-150F",
      "t": "Ceylon Frosted Smoke",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        151,
        126,
        134
      ],
      "id": "TT-01-151",
      "t": "Ceylon Grape Mist",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        152,
        110,
        116
      ],
      "id": "TT-01-151F",
      "t": "Ceylon Frosted Grape Mist",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        237,
        237,
        235
      ],
      "id": "TT-01-161",
      "t": "Transparent Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        238,
        196,
        134
      ],
      "id": "TT-01-162",
      "t": "Transparent Lt Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        17,
        147,
        208
      ],
      "id": "TT-01-163B",
      "t": "Transparent Dark Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        196,
        228,
        98
      ],
      "id": "TT-01-164",
      "t": "Transparent Lime Green Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        171,
        64,
        108
      ],
      "id": "TT-01-165B",
      "t": "Transparent Siam Ruby Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        90,
        27,
        48
      ],
      "id": "TT-01-165C",
      "t": "Transparent Ruby Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        103,
        77,
        71
      ],
      "id": "TT-01-165D",
      "t": "Transparent Garnet Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        113,
        81,
        98
      ],
      "id": "TT-01-166",
      "t": "Transparent Lt Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        110,
        69,
        77
      ],
      "id": "TT-01-166B",
      "t": "Transparent Med Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        78,
        69,
        74
      ],
      "id": "TT-01-166C",
      "t": "Transparent Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        45,
        117,
        87
      ],
      "id": "TT-01-167B",
      "t": "Transparent Grass Green Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        41,
        90,
        109
      ],
      "id": "TT-01-167BD",
      "t": "Transparent Teal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        32,
        84,
        90
      ],
      "id": "TT-01-167BDF",
      "t": "Transparent Frosted Teal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        106,
        119,
        197
      ],
      "id": "TT-01-168",
      "t": "Transparent Lt Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        227,
        176,
        155
      ],
      "id": "TT-01-169",
      "t": "Transparent Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        145,
        229,
        232
      ],
      "id": "TT-01-170D",
      "t": "Transparent Frosted Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        185,
        219,
        201
      ],
      "id": "TT-01-170L",
      "t": "Transparent Blue Frost Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        252,
        163,
        187
      ],
      "id": "TT-01-171D",
      "t": "Transparent Ballerina Pink Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        237,
        165,
        168
      ],
      "id": "TT-01-171L",
      "t": "Transparent Lt Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        182,
        219,
        156
      ],
      "id": "TT-01-172",
      "t": "Transparent Dyed Spring Green Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        187,
        213,
        124
      ],
      "id": "TT-01-173",
      "t": "Transparent Dyed Lemon Mist Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        243,
        134,
        49
      ],
      "id": "TT-01-174",
      "t": "Transparent Lt Hyacinth Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        164,
        170,
        176
      ],
      "id": "TT-01-176",
      "t": "Transparent Black Diamond Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        76,
        91,
        97
      ],
      "id": "TT-01-176B",
      "t": "Transparent Gray Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        65,
        42,
        51
      ],
      "id": "TT-01-177",
      "t": "Transparent Smokey Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        82,
        68,
        198
      ],
      "id": "TT-01-178",
      "t": "Transparent Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        25,
        98,
        100
      ],
      "id": "TT-01-179",
      "t": "Transparent Green Emerald Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        55,
        155,
        182
      ],
      "id": "TT-01-183",
      "t": "Aqua-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        190,
        114,
        100
      ],
      "id": "TT-01-186",
      "t": "Terracotta-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        52,
        88,
        98
      ],
      "id": "TT-01-188",
      "t": "Capri Blue-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        32,
        72,
        142
      ],
      "id": "TT-01-189",
      "t": "Caribbean Blue-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        34,
        76,
        156
      ],
      "id": "TT-01-189FM",
      "t": "Frosted Caribbean Blue-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        246,
        168,
        183
      ],
      "id": "TT-01-191C",
      "t": "Neon Pink-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        245,
        212,
        55
      ],
      "id": "TT-01-192",
      "t": "Dandelion Yellow-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        103,
        59,
        58
      ],
      "id": "TT-01-203",
      "t": "Transparent Lt Amethyst Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        109,
        68,
        48
      ],
      "id": "TT-01-221",
      "t": "Bronze",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        139,
        73,
        64
      ],
      "id": "TT-01-222",
      "t": "Dark Bronze",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        88,
        55,
        44
      ],
      "id": "TT-01-222F",
      "t": "Matte Dark Bronze",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        93,
        58,
        28
      ],
      "id": "TT-01-223",
      "t": "Antique Bronze",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        97,
        83,
        50
      ],
      "id": "TT-01-223F",
      "t": "Matte Antique Bronze",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        191,
        82,
        112
      ],
      "id": "TT-01-241",
      "t": "Mauve-Lined Lt Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        148,
        61,
        35
      ],
      "id": "TT-01-241FM",
      "t": "Frosted Mauve-Lined Lt Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        82,
        97,
        84
      ],
      "id": "TT-01-245",
      "t": "Jet-Lined Jonquil Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        159,
        152,
        44
      ],
      "id": "TT-01-246FM",
      "t": "Frosted Yellow-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        96,
        128,
        165
      ],
      "id": "TT-01-248",
      "t": "Jet-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        26,
        50,
        60
      ],
      "id": "TT-01-248FM",
      "t": "Frosted Jet-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        11,
        81,
        36
      ],
      "id": "TT-01-249",
      "t": "Emerald-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        37,
        82,
        56
      ],
      "id": "TT-01-249FM",
      "t": "Frosted Emerald-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        60,
        49,
        49
      ],
      "id": "TT-01-250",
      "t": "Fuchsia-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        56,
        53,
        36
      ],
      "id": "TT-01-250FM",
      "t": "Frosted Fuchsia-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        106,
        74,
        122
      ],
      "id": "TT-01-252",
      "t": "Royal Purple-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        57,
        35,
        105
      ],
      "id": "TT-01-252FM",
      "t": "Frosted Royal Purple-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        151,
        152,
        149
      ],
      "id": "TT-01-261",
      "t": "Light Gray-Lined Crystal Luster Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        103,
        92,
        78
      ],
      "id": "TT-01-262",
      "t": "Gold-Lined Clear Crystal Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        97,
        131,
        142
      ],
      "id": "TT-01-263",
      "t": "Light Capri-Lined Crystal Luster Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        97,
        85,
        131
      ],
      "id": "TT-01-265FM",
      "t": "Frosted Metallic Purple-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        85,
        87,
        93
      ],
      "id": "TT-01-266",
      "t": "Granite-Lined Crystal Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        147,
        115,
        115
      ],
      "id": "TT-01-267",
      "t": "Rose Gold-Lined Crystal Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        141,
        97,
        106
      ],
      "id": "TT-01-267FM",
      "t": "Frosted Rose Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        75,
        105,
        96
      ],
      "id": "TT-01-270F",
      "t": "Teal-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        85,
        80,
        61
      ],
      "id": "TT-01-271",
      "t": "Gold-Lined Black Diamond Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        90,
        85,
        65
      ],
      "id": "TT-01-271FM",
      "t": "Frosted Gold-Lined Black Diamond Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        183,
        157,
        131
      ],
      "id": "TT-01-278",
      "t": "Gold-Lined Topaz Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        83,
        83,
        84
      ],
      "id": "TT-01-282",
      "t": "Gunmetal-Lined Crystal Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        82,
        82,
        80
      ],
      "id": "TT-01-282FM",
      "t": "Frosted Gunmetal-Lined Crystal Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        244,
        199,
        195
      ],
      "id": "TT-01-290",
      "t": "Soft Pink-Lined Crystal Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        189,
        168,
        85
      ],
      "id": "TT-01-295",
      "t": "Gold-Lined Lt Topaz Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        212,
        197,
        111
      ],
      "id": "TT-01-296",
      "t": "Silver-Lined Jonquil Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        115,
        46,
        76
      ],
      "id": "TT-01-304",
      "t": "Hyacinth-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        61,
        164,
        6
      ],
      "id": "TT-01-306",
      "t": "Shamrock-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        68,
        157,
        14
      ],
      "id": "TT-01-306FM",
      "t": "Frosted Shamrock-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        120,
        178,
        76
      ],
      "id": "TT-01-307",
      "t": "Opaque Yellow-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        67,
        147,
        102
      ],
      "id": "TT-01-322",
      "t": "Emerald Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        107,
        100,
        90
      ],
      "id": "TT-01-323",
      "t": "Olivine Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        112,
        98,
        38
      ],
      "id": "TT-01-324",
      "t": "Prairie Green Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        110,
        94,
        75
      ],
      "id": "TT-01-325",
      "t": "Lt Tanzanite Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        73,
        80,
        73
      ],
      "id": "TT-01-326",
      "t": "Spinach Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        56,
        65,
        97
      ],
      "id": "TT-01-327",
      "t": "Mystic Purple Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        201,
        138,
        96
      ],
      "id": "TT-01-329",
      "t": "African Sunset Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        150,
        142,
        141
      ],
      "id": "TT-01-330",
      "t": "Rust Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        97,
        46,
        41
      ],
      "id": "TT-01-331",
      "t": "Wild Berry Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        174,
        88,
        116
      ],
      "id": "TT-01-332",
      "t": "Raspberry Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        219,
        86,
        77
      ],
      "id": "TT-01-341",
      "t": "Tomato-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        92,
        94,
        99
      ],
      "id": "TT-01-344",
      "t": "Jet-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        62,
        60,
        58
      ],
      "id": "TT-01-344FM",
      "t": "Frosted Charcoal-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        179,
        161,
        102
      ],
      "id": "TT-01-369",
      "t": "Orange Creme-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        146,
        137,
        85
      ],
      "id": "TT-01-369FM",
      "t": "Frosted Orange Creme-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        170,
        175,
        172
      ],
      "id": "TT-01-376",
      "t": "White-Lined Med Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        104,
        144,
        112
      ],
      "id": "TT-01-380",
      "t": "Mint Julep-Lined Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        89,
        51,
        66
      ],
      "id": "TT-01-381",
      "t": "Oxblood-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        75,
        64,
        80
      ],
      "id": "TT-01-381FM",
      "t": "Frosted Oxblood-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        181,
        69,
        41
      ],
      "id": "TT-01-388",
      "t": "Hyacinth-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        178,
        66,
        41
      ],
      "id": "TT-01-388FM",
      "t": "Frosted Hyacinth-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        76,
        61,
        72
      ],
      "id": "TT-01-400",
      "t": "Jet-Lined Siam Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        232,
        235,
        236
      ],
      "id": "TT-01-401",
      "t": "Opaque White Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        253,
        240,
        64
      ],
      "id": "TT-01-402",
      "t": "Opaque Dandelion Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        143,
        188,
        197
      ],
      "id": "TT-01-403",
      "t": "Opaque Blue Turquoise Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        186,
        233,
        122
      ],
      "id": "TT-01-404",
      "t": "Opaque Sour Apple Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        184,
        43,
        62
      ],
      "id": "TT-01-405",
      "t": "Opaque Cherry Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        90,
        68,
        88
      ],
      "id": "TT-01-406F",
      "t": "Opaque Matte Oxblood Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        90,
        184,
        109
      ],
      "id": "TT-01-407",
      "t": "Opaque Mint-Green Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        36,
        30,
        165
      ],
      "id": "TT-01-408",
      "t": "Opaque Navy-Blue Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        250,
        80,
        61
      ],
      "id": "TT-01-410",
      "t": "Opaque Pumpkin Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        114,
        188,
        191
      ],
      "id": "TT-01-413",
      "t": "Opaque Turquoise Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        177,
        127,
        67
      ],
      "id": "TT-01-421",
      "t": "Transparent Pink Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        92,
        65,
        68
      ],
      "id": "TT-01-425",
      "t": "Marionberry Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        164,
        87,
        20
      ],
      "id": "TT-01-429",
      "t": "Transparent Lt Amber Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        77,
        55,
        56
      ],
      "id": "TT-01-454",
      "t": "Root beer Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        196,
        189,
        194
      ],
      "id": "TT-01-455",
      "t": "Pale Wisteria Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        152,
        152,
        109
      ],
      "id": "TT-01-457",
      "t": "Green Tea Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        94,
        73,
        74
      ],
      "id": "TT-01-460",
      "t": "Opaque Brown Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        127,
        89,
        198
      ],
      "id": "TT-01-461",
      "t": "Royal Purple Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        191,
        164,
        204
      ],
      "id": "TT-01-477",
      "t": "Transparent Dyed Lavender Mist Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        50,
        50,
        61
      ],
      "id": "TT-01-478",
      "t": "Transparent Americano Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        35,
        105,
        183
      ],
      "id": "TT-01-479",
      "t": "Transparent Kyanite Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        175,
        90,
        87
      ],
      "id": "TT-01-501",
      "t": "High-Metallic Cinnamon Bronze",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        180,
        93,
        134
      ],
      "id": "TT-01-503",
      "t": "High-Metallic Dark Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        68,
        51,
        84
      ],
      "id": "TT-01-504",
      "t": "High-Metallic Violet Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        77,
        171,
        187
      ],
      "id": "TT-01-505",
      "t": "High-Metallic Dragonfly",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        65,
        138,
        115
      ],
      "id": "TT-01-506",
      "t": "High-Metallic June Bug",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        116,
        177,
        143
      ],
      "id": "TT-01-507",
      "t": "High-Metallic Green Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        95,
        91,
        71
      ],
      "id": "TT-01-508",
      "t": "High-Metallic Olivine Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        73,
        113,
        145
      ],
      "id": "TT-01-511F",
      "t": "High-Metallic Matte Mediterranean Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        147,
        116,
        62
      ],
      "id": "TT-01-513",
      "t": "Galvanized Carnival",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        127,
        78,
        64
      ],
      "id": "TT-01-514F",
      "t": "High-Metallic Matte Copper Twilight",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        251,
        200,
        154
      ],
      "id": "TT-01-551",
      "t": "Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        202,
        136,
        87
      ],
      "id": "TT-01-PF551F",
      "t": "PermaFinish Galvanized Matte Rose Gold",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        216,
        153,
        85
      ],
      "id": "TT-01-PF551",
      "t": "PermaFinish Galvanized Rose Gold",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        210,
        174,
        155
      ],
      "id": "TT-01-PF552",
      "t": "PermaFinish Galvanized Sweet Blush",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        212,
        119,
        139
      ],
      "id": "TT-01-PF553F",
      "t": "PermaFinish Galvanized Matte Vintage Rose",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        192,
        116,
        136
      ],
      "id": "TT-01-PF553",
      "t": "PermaFinish Galvanized Pink Lilac",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        175,
        133,
        143
      ],
      "id": "TT-01-PF554F",
      "t": "PermaFinish Galvanized Matte Lavender",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        157,
        119,
        115
      ],
      "id": "TT-01-PF554",
      "t": "PermaFinish Galvanized Lilac",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        138,
        104,
        94
      ],
      "id": "TT-01-556",
      "t": "Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        126,
        91,
        81
      ],
      "id": "TT-01-PF556F",
      "t": "PermaFinish Galvanized Matte Mocha Frost",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        121,
        80,
        66
      ],
      "id": "TT-01-PF556",
      "t": "PermaFinish Galvanized Mauve",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        211,
        169,
        85
      ],
      "id": "TT-01-557",
      "t": "Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        206,
        151,
        69
      ],
      "id": "TT-01-PF557F",
      "t": "PermaFinish Galvanized Matte Starlight",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        218,
        187,
        103
      ],
      "id": "TT-01-PF557",
      "t": "PermaFinish Galvanized Starlight",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        194,
        186,
        147
      ],
      "id": "TT-01-558",
      "t": "Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        203,
        188,
        144
      ],
      "id": "TT-01-PF558F",
      "t": "PermaFinish Galvanized Matte Aluminum",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        213,
        203,
        160
      ],
      "id": "TT-01-PF558",
      "t": "PermaFinish Galvanized Aluminum",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        209,
        196,
        124
      ],
      "id": "TT-01-PF559F",
      "t": "PermaFinish Galvanized Matte Yellow Gold",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        209,
        198,
        122
      ],
      "id": "TT-01-PF559",
      "t": "PermaFinish Galvanized Yellow Gold",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        131,
        181,
        118
      ],
      "id": "TT-01-PF560F",
      "t": "PermaFinish Galvanized Matte Seafoam",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        128,
        176,
        115
      ],
      "id": "TT-01-PF560",
      "t": "PermaFinish Galvanized Sea Foam",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        96,
        183,
        156
      ],
      "id": "TT-01-PF561F",
      "t": "PermaFinish Galvanized Matte Lt Teal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        85,
        174,
        135
      ],
      "id": "TT-01-PF561",
      "t": "PermaFinish Galvanized Green Teal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        196,
        86,
        48
      ],
      "id": "TT-01-PF562F",
      "t": "PermaFinish Galvanized Matte Saffron",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        204,
        69,
        27
      ],
      "id": "TT-01-PF562",
      "t": "PermaFinish Galvanized Saffron",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        213,
        55,
        102
      ],
      "id": "TT-01-PF563F",
      "t": "PermaFinish Galvanized Matte Orchid",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        218,
        57,
        128
      ],
      "id": "TT-01-PF563",
      "t": "PermaFinish Galvanized Orchid",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        186,
        58,
        63
      ],
      "id": "TT-01-564",
      "t": "Galvanized Brick Red",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        149,
        60,
        33
      ],
      "id": "TT-01-PF564F",
      "t": "PermaFinish Galvanized Matte Burgundy Frost",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        137,
        49,
        40
      ],
      "id": "TT-01-PF564",
      "t": "PermaFinish Galvanized Brick Red",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        117,
        124,
        115
      ],
      "id": "TT-01-PF565F",
      "t": "PermaFinish Galvanized Matte Blue Slate",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        125,
        132,
        128
      ],
      "id": "TT-01-PF565",
      "t": "PermaFinish Galvanized Blue Slate",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        209,
        201,
        186
      ],
      "id": "TT-01-566",
      "t": "Metallic Matte Antique Silver",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        119,
        104,
        145
      ],
      "id": "TT-01-PF567F",
      "t": "PermaFinish Metallic Matte Polaris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        133,
        115,
        153
      ],
      "id": "TT-01-PF567",
      "t": "PermaFinish Metallic Polaris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        148,
        125,
        150
      ],
      "id": "TT-01-PF568",
      "t": "PermaFinish Metallic Pink Pewter",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        22,
        148,
        144
      ],
      "id": "TT-01-PF569F",
      "t": "PermaFinish Galvanized Matte Teal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        20,
        177,
        160
      ],
      "id": "TT-01-PF569",
      "t": "PermaFinish Galvanized Teal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        123,
        179,
        126
      ],
      "id": "TT-01-PF570F",
      "t": "PermaFinish Galvanized Matte Mint Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        132,
        170,
        117
      ],
      "id": "TT-01-PF570",
      "t": "PermaFinish Galvanized Mint Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        196,
        190,
        174
      ],
      "id": "TT-01-602",
      "t": "Galvanized Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        118,
        94,
        94
      ],
      "id": "TT-01-605",
      "t": "Galvanized Lavender",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        124,
        133,
        131
      ],
      "id": "TT-01-611",
      "t": "Metallic Frosted Gray Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        180,
        198,
        213
      ],
      "id": "TT-01-612",
      "t": "Opaque Matte Tahitian Pearl",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        97,
        97,
        74
      ],
      "id": "TT-01-613",
      "t": "Opaque Matte Gray Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        139,
        126,
        112
      ],
      "id": "TT-01-614",
      "t": "Opaque Matte Brown Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        165,
        134,
        149
      ],
      "id": "TT-01-615",
      "t": "Opaque Matte Purple Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        86,
        82,
        43
      ],
      "id": "TT-01-617",
      "t": "Matte Black Olive",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        178,
        99,
        88
      ],
      "id": "TT-01-621",
      "t": "Transparent French Rose Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        168,
        98,
        23
      ],
      "id": "TT-01-622F",
      "t": "Transparent Frosted Pink Champagne Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        107,
        104,
        184
      ],
      "id": "TT-01-623F",
      "t": "Transparent Frosted Lt Tanzanite Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        138,
        78,
        96
      ],
      "id": "TT-01-624F",
      "t": "Transparent Frosted Amethyst Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        112,
        68,
        103
      ],
      "id": "TT-01-625F",
      "t": "Transparent Frosted Blackberry Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        96,
        81,
        84
      ],
      "id": "TT-01-626F",
      "t": "Transparent Frosted Purple Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        91,
        108,
        90
      ],
      "id": "TT-01-627F",
      "t": "Transparent Frosted Sugar Plum Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        120,
        166,
        124
      ],
      "id": "TT-01-660",
      "t": "Transparent Peridot Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        138,
        116,
        160
      ],
      "id": "TT-01-661",
      "t": "Transparent Milky Alexandrite Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        155,
        110,
        119
      ],
      "id": "TT-01-662",
      "t": "Transparent Milky Lilac Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        119,
        154,
        133
      ],
      "id": "TT-01-699",
      "t": "Shamrock-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        151,
        122,
        65
      ],
      "id": "TT-01-702",
      "t": "Matte Dark Copper",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        99,
        56,
        54
      ],
      "id": "TT-01-703",
      "t": "Matte Mauve",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        159,
        103,
        140
      ],
      "id": "TT-01-704",
      "t": "Matte Andromeda",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        99,
        93,
        145
      ],
      "id": "TT-01-705",
      "t": "Matte Blue Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        44,
        132,
        133
      ],
      "id": "TT-01-706",
      "t": "Matte Dark Emerald Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        107,
        146,
        122
      ],
      "id": "TT-01-707",
      "t": "Matte Peridot Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        174,
        148,
        130
      ],
      "id": "TT-01-708",
      "t": "Matte Cassiopeia",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        141,
        122,
        118
      ],
      "id": "TT-01-709",
      "t": "Matte Peacock Iris",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        29,
        100,
        83
      ],
      "id": "TT-01-710",
      "t": "Matte Aquarius",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        152,
        144,
        131
      ],
      "id": "TT-01-711",
      "t": "Metallic Antique Silver",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        248,
        219,
        115
      ],
      "id": "TT-01-712",
      "t": "24K Gold Plate",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        234,
        231,
        225
      ],
      "id": "TT-01-714",
      "t": "Metallic Chrome Silver",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        198,
        169,
        91
      ],
      "id": "TT-01-715",
      "t": "24K Bright Gold Plate",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        205,
        166,
        98
      ],
      "id": "TT-01-715F",
      "t": "Frosted 24K Bright Gold Plate",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        173,
        183,
        128
      ],
      "id": "TT-01-721",
      "t": "Metallic Blue Steel",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        158,
        105,
        86
      ],
      "id": "TT-01-740",
      "t": "Copper-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        243,
        187,
        168
      ],
      "id": "TT-01-741",
      "t": "Copper-Lined Alabaster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        70,
        108,
        14
      ],
      "id": "TT-01-742",
      "t": "Copper-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        65,
        55,
        138
      ],
      "id": "TT-01-743",
      "t": "Copper-Lined Dark Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        166,
        117,
        50
      ],
      "id": "TT-01-744",
      "t": "Copper-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        116,
        152,
        102
      ],
      "id": "TT-01-755",
      "t": "Gold-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        40,
        98,
        90
      ],
      "id": "TT-01-756",
      "t": "Gold-Lined Tahitian Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        103,
        95,
        54
      ],
      "id": "TT-01-758",
      "t": "Gold-Lined Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        250,
        250,
        248
      ],
      "id": "TT-01-761",
      "t": "Opaque Matte White Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        244,
        231,
        188
      ],
      "id": "TT-01-762",
      "t": "Opaque Matte Ivory",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        253,
        221,
        184
      ],
      "id": "TT-01-763",
      "t": "Opaque Matte Bone",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        240,
        183,
        172
      ],
      "id": "TT-01-764",
      "t": "Opaque Matte Ebi",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        225,
        172,
        188
      ],
      "id": "TT-01-765",
      "t": "Opaque Matte Pastel Plumeria",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        203,
        160,
        172
      ],
      "id": "TT-01-766",
      "t": "Opaque Matte Pastel Lt Lilac",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        234,
        240,
        245
      ],
      "id": "TT-01-767",
      "t": "Opaque Matte Cumulus Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        250,
        232,
        128
      ],
      "id": "TT-01-770",
      "t": "Yellow-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        161,
        123,
        125
      ],
      "id": "TT-01-771",
      "t": "Strawberry-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        125,
        73,
        74
      ],
      "id": "TT-01-771FM",
      "t": "Frosted Strawberry-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        144,
        176,
        184
      ],
      "id": "TT-01-773",
      "t": "Montana Blue-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        85,
        105,
        113
      ],
      "id": "TT-01-773FM",
      "t": "Frosted Montana Blue-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        134,
        163,
        172
      ],
      "id": "TT-01-774",
      "t": "Grape-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        82,
        59,
        104
      ],
      "id": "TT-01-774FM",
      "t": "Frosted Grape-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        136,
        144,
        175
      ],
      "id": "TT-01-776",
      "t": "Purple-Lined Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        254,
        251,
        242
      ],
      "id": "TT-01-777",
      "t": "Creme-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        231,
        126,
        112
      ],
      "id": "TT-01-779",
      "t": "Salmon-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        210,
        91,
        84
      ],
      "id": "TT-01-779FM",
      "t": "Frosted Salmon-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        253,
        196,
        201
      ],
      "id": "TT-01-780",
      "t": "Bubble Gum-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        121,
        143,
        168
      ],
      "id": "TT-01-782",
      "t": "Capri-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        73,
        99,
        98
      ],
      "id": "TT-01-783",
      "t": "Gray-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        154,
        114,
        109
      ],
      "id": "TT-01-784",
      "t": "Sandstone-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        217,
        96,
        169
      ],
      "id": "TT-01-785",
      "t": "Hot Pink-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        204,
        187,
        193
      ],
      "id": "TT-01-786",
      "t": "Pale Lavender-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        109,
        203,
        216
      ],
      "id": "TT-01-787",
      "t": "Blue Turquoise-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        110,
        98,
        118
      ],
      "id": "TT-01-788",
      "t": "Tanzanite-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        162,
        90,
        175
      ],
      "id": "TT-01-790",
      "t": "Fuchsia-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        129,
        224,
        223
      ],
      "id": "TT-01-793",
      "t": "Pale Turquoise-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        29,
        89,
        50
      ],
      "id": "TT-01-796",
      "t": "Dark Emerald-Lined Emerald",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        218,
        37,
        64
      ],
      "id": "TT-01-798",
      "t": "Light Topaz-Lined Siam",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        252,
        180,
        26
      ],
      "id": "TT-01-801",
      "t": "Luminous Neon Tangerine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        251,
        198,
        217
      ],
      "id": "TT-01-811",
      "t": "Opaque Pastel Peach Blossom Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        233,
        206,
        157
      ],
      "id": "TT-01-812",
      "t": "Opaque Pastel Cantaloupe Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        225,
        237,
        171
      ],
      "id": "TT-01-813",
      "t": "Opaque Pastel Duckling Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        220,
        251,
        220
      ],
      "id": "TT-01-814",
      "t": "Opaque Pastel Mint Julep Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        190,
        217,
        219
      ],
      "id": "TT-01-815",
      "t": "Opaque Pastel Winter Sky Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        223,
        181,
        207
      ],
      "id": "TT-01-816",
      "t": "Opaque Pastel Pansy Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        254,
        111,
        95
      ],
      "id": "TT-01-830",
      "t": "Neon Nectarine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        225,
        234,
        93
      ],
      "id": "TT-01-833",
      "t": "Neon Canary",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        155,
        199,
        209
      ],
      "id": "TT-01-835",
      "t": "Neon Polar Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        254,
        119,
        192
      ],
      "id": "TT-01-837",
      "t": "Neon Fuchsia",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        235,
        208,
        22
      ],
      "id": "TT-01-902F",
      "t": "Ceylon Frosted Lemon Chiffon",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        238,
        165,
        69
      ],
      "id": "TT-01-904",
      "t": "Ceylon Cantaloupe",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        218,
        106,
        99
      ],
      "id": "TT-01-906",
      "t": "Ceylon Tomato Soup",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        161,
        95,
        90
      ],
      "id": "TT-01-907",
      "t": "Ceylon Petunia",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        251,
        174,
        199
      ],
      "id": "TT-01-909",
      "t": "Ceylon Cotton Candy",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        254,
        126,
        171
      ],
      "id": "TT-01-910",
      "t": "Ceylon Hot Pink",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        112,
        148,
        201
      ],
      "id": "TT-01-917",
      "t": "Ceylon Denim Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        106,
        161,
        189
      ],
      "id": "TT-01-918",
      "t": "Ceylon English Bluebell",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        125,
        180,
        200
      ],
      "id": "TT-01-919",
      "t": "Ceylon Forget-Me-Not",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        135,
        131,
        198
      ],
      "id": "TT-01-921",
      "t": "Ceylon Virginia Bluebell",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        112,
        94,
        131
      ],
      "id": "TT-01-922",
      "t": "Ceylon Gladiola",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        243,
        169,
        162
      ],
      "id": "TT-01-924",
      "t": "Peach-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        248,
        134,
        95
      ],
      "id": "TT-01-925",
      "t": "Coral Pink-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        136,
        94,
        167
      ],
      "id": "TT-01-928",
      "t": "Purple-Lined Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        87,
        57,
        104
      ],
      "id": "TT-01-928FM",
      "t": "Frosted Purple-Lined Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        40,
        47,
        75
      ],
      "id": "TT-01-929",
      "t": "Capri-Lined Lt Yellow Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        99,
        174,
        188
      ],
      "id": "TT-01-930",
      "t": "White-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        65,
        163,
        199
      ],
      "id": "TT-01-931",
      "t": "White-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        37,
        73,
        128
      ],
      "id": "TT-01-932",
      "t": "Capri-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        5,
        83,
        126
      ],
      "id": "TT-01-932FM",
      "t": "Frosted Capri-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        142,
        162,
        194
      ],
      "id": "TT-01-933",
      "t": "White-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        60,
        67,
        147
      ],
      "id": "TT-01-934",
      "t": "Purple-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        133,
        101,
        152
      ],
      "id": "TT-01-936",
      "t": "Dark Lilac-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        152,
        108,
        207
      ],
      "id": "TT-01-937",
      "t": "Bubble Gum Pink-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        113,
        85,
        187
      ],
      "id": "TT-01-938",
      "t": "Pink-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        8,
        58,
        39
      ],
      "id": "TT-01-939",
      "t": "Transparent Green Emerald",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        24,
        81,
        58
      ],
      "id": "TT-01-939F",
      "t": "Transparent Frosted Green Emerald",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        90,
        109,
        79
      ],
      "id": "TT-01-940",
      "t": "Transparent Olivine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        94,
        50,
        15
      ],
      "id": "TT-01-941F",
      "t": "Transparent Frosted Smoky Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        81,
        76,
        193
      ],
      "id": "TT-01-942",
      "t": "Transparent Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        52,
        55,
        163
      ],
      "id": "TT-01-942F",
      "t": "Transparent Frosted Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        131,
        161,
        54
      ],
      "id": "TT-01-945",
      "t": "Mint Julep-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        241,
        208,
        140
      ],
      "id": "TT-01-948",
      "t": "White-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        240,
        163,
        37
      ],
      "id": "TT-01-949",
      "t": "Yellow-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        243,
        184,
        101
      ],
      "id": "TT-01-950",
      "t": "Burnt Orange-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        176,
        84,
        81
      ],
      "id": "TT-01-951",
      "t": "Brick Red-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        145,
        67,
        26
      ],
      "id": "TT-01-951FM",
      "t": "Frosted Brick Red-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        64,
        122,
        92
      ],
      "id": "TT-01-952",
      "t": "Seafoam-Lined Lt Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        132,
        148,
        100
      ],
      "id": "TT-01-952FM",
      "t": "Frosted Seafoam-Lined Lt Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        191,
        92,
        137
      ],
      "id": "TT-01-959",
      "t": "Pink-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        138,
        87,
        97
      ],
      "id": "TT-01-960",
      "t": "Pink-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        248,
        77,
        74
      ],
      "id": "TT-01-979",
      "t": "Luminous Neon Pink-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        206,
        37,
        152
      ],
      "id": "TT-01-980",
      "t": "Luminous Neon Pink-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        242,
        239,
        230
      ],
      "id": "TT-01-981",
      "t": "Snow-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        112,
        105,
        161
      ],
      "id": "TT-01-988",
      "t": "Lupine Purple-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        195,
        176,
        135
      ],
      "id": "TT-01-989",
      "t": "Gold-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        111,
        78,
        47
      ],
      "id": "TT-01-989F",
      "t": "Gold-Lined Frosted Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        141,
        181,
        155
      ],
      "id": "TT-01-990",
      "t": "Gold-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        144,
        128,
        42
      ],
      "id": "TT-01-991",
      "t": "Gold-Lined Olivine Chrysolite",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        124,
        114,
        103
      ],
      "id": "TT-01-992",
      "t": "Gold-Lined Lt Montana Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        136,
        118,
        67
      ],
      "id": "TT-01-993",
      "t": "Gold-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        155,
        129,
        81
      ],
      "id": "TT-01-994",
      "t": "Gold-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        75,
        118,
        99
      ],
      "id": "TT-01-995",
      "t": "Gold-Lined Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        80,
        109,
        101
      ],
      "id": "TT-01-995FM",
      "t": "Frosted Gold-Lined Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        98,
        97,
        63
      ],
      "id": "TT-01-996",
      "t": "Gold-Lined Clover Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        109,
        90,
        20
      ],
      "id": "TT-01-996FM",
      "t": "Frosted Gold-Lined Clover Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        84,
        87,
        93
      ],
      "id": "TT-01-997",
      "t": "Gold-Lined Lt Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        79,
        72,
        65
      ],
      "id": "TT-01-997FM",
      "t": "Frosted Gold-Lined Lt Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        96,
        100,
        80
      ],
      "id": "TT-01-999",
      "t": "Gold-Lined Black Diamond Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        100,
        75,
        56
      ],
      "id": "TT-01-999F",
      "t": "Frosted Gold-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        144,
        144,
        143
      ],
      "id": "TT-01-1000",
      "t": "Silver-Lined Light Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        126,
        126,
        121
      ],
      "id": "TT-01-1001",
      "t": "Silver-Lined Black Diamond",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        144,
        126,
        87
      ],
      "id": "TT-01-1002",
      "t": "Silver-Lined Citrine",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        133,
        121,
        91
      ],
      "id": "TT-01-1003",
      "t": "Gold-Lined Luster Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        154,
        131,
        96
      ],
      "id": "TT-01-1004",
      "t": "Gold-Lined Champagne",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        161,
        147,
        51
      ],
      "id": "TT-01-1005",
      "t": "Gold-Lined Light Daffodil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        124,
        156,
        88
      ],
      "id": "TT-01-1006",
      "t": "Silver-Lined Sour Apple",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        112,
        119,
        62
      ],
      "id": "TT-01-1007",
      "t": "Gold-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        112,
        122,
        150
      ],
      "id": "TT-01-1008",
      "t": "Silver-Lined Montana Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        161,
        159,
        159
      ],
      "id": "TT-01-1009",
      "t": "Silver-Lined Luster Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        154,
        132,
        123
      ],
      "id": "TT-01-1010",
      "t": "Silver-Lined Luster Med Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        153,
        115,
        91
      ],
      "id": "TT-01-1011",
      "t": "Antique Copper-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        154,
        127,
        104
      ],
      "id": "TT-01-1012",
      "t": "Antique Copper-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        141,
        144,
        74
      ],
      "id": "TT-01-1013",
      "t": "Silver-Lined Citrus",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        234,
        229,
        215
      ],
      "id": "TT-01-1030",
      "t": "White-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        139,
        138,
        136
      ],
      "id": "TT-01-1031",
      "t": "Raincloud Gray-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        118,
        119,
        115
      ],
      "id": "TT-01-1032",
      "t": "Graphite-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        230,
        204,
        186
      ],
      "id": "TT-01-1033",
      "t": "White-Lined Luster Lt Rosaline",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        217,
        133,
        100
      ],
      "id": "TT-01-1034",
      "t": "Peach-Lined Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        233,
        151,
        161
      ],
      "id": "TT-01-1035",
      "t": "Cotton Candy-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        197,
        131,
        158
      ],
      "id": "TT-01-1036",
      "t": "Hot Pink-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        208,
        92,
        84
      ],
      "id": "TT-01-1037",
      "t": "Orange-Lined Hyacinth",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        166,
        73,
        68
      ],
      "id": "TT-01-1038",
      "t": "Red-Lined Luster Hyacinth",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        162,
        105,
        89
      ],
      "id": "TT-01-1039",
      "t": "Orange-Lined Lt Hyacinth",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        166,
        106,
        77
      ],
      "id": "TT-01-1040",
      "t": "Orange-Lined Lime",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        177,
        144,
        90
      ],
      "id": "TT-01-1041",
      "t": "Marigold-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        141,
        118,
        90
      ],
      "id": "TT-01-1042",
      "t": "Orange-Lined Lt Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        112,
        106,
        105
      ],
      "id": "TT-01-1043",
      "t": "Brick-Lined Lt Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        123,
        113,
        85
      ],
      "id": "TT-01-1044",
      "t": "Oxblood-Lined Lt Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        182,
        203,
        53
      ],
      "id": "TT-01-1045",
      "t": "Yellow-Lined Lemon Lime",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        146,
        142,
        84
      ],
      "id": "TT-01-1046",
      "t": "Orange-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        99,
        121,
        105
      ],
      "id": "TT-01-1047",
      "t": "Olive-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        98,
        144,
        73
      ],
      "id": "TT-01-1048",
      "t": "Shamrock-Lined Lt Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        95,
        123,
        71
      ],
      "id": "TT-01-1049",
      "t": "Green-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        136,
        168,
        145
      ],
      "id": "TT-01-1050",
      "t": "Moss-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        78,
        147,
        107
      ],
      "id": "TT-01-1051",
      "t": "Shamrock-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        104,
        163,
        115
      ],
      "id": "TT-01-1052",
      "t": "Mint-Lined Lt Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        110,
        184,
        209
      ],
      "id": "TT-01-1053",
      "t": "White-Lined Baby Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        109,
        137,
        151
      ],
      "id": "TT-01-1054",
      "t": "Gray-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        85,
        125,
        173
      ],
      "id": "TT-01-1055",
      "t": "Cornflower-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        96,
        113,
        133
      ],
      "id": "TT-01-1056",
      "t": "Denim-Lined Alexandrite",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        41,
        72,
        146
      ],
      "id": "TT-01-1057",
      "t": "Dk Blue-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        104,
        89,
        154
      ],
      "id": "TT-01-1058",
      "t": "Lavender-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        121,
        115,
        133
      ],
      "id": "TT-01-1059",
      "t": "Eggplant-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        155,
        120,
        151
      ],
      "id": "TT-01-1060",
      "t": "Purple-Lined Crystal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        110,
        88,
        104
      ],
      "id": "TT-01-1061",
      "t": "Fuchsia-Lined Lt Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        124,
        89,
        87
      ],
      "id": "TT-01-1062",
      "t": "Green-Lined Siam",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        102,
        78,
        119
      ],
      "id": "TT-01-1063",
      "t": "Fuchsia-Lined Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        243,
        242,
        238
      ],
      "id": "TT-01-1141",
      "t": "Translucent Alabaster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        122,
        198,
        222
      ],
      "id": "TT-01-1143",
      "t": "Translucent Glacier",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        108,
        193,
        125
      ],
      "id": "TT-01-1144",
      "t": "Translucent Kiwi",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        127,
        146,
        228
      ],
      "id": "TT-01-1146",
      "t": "Translucent Sapphire",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        114,
        117,
        119
      ],
      "id": "TT-01-1150",
      "t": "Translucent Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        147,
        100,
        109
      ],
      "id": "TT-01-1151",
      "t": "Translucent Dusty Rose",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        191,
        158,
        177
      ],
      "id": "TT-01-1200",
      "t": "Marbled Pink Sky White",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        177,
        135,
        120
      ],
      "id": "TT-01-1201",
      "t": "Marbled Pink Stucco",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        157,
        107,
        125
      ],
      "id": "TT-01-1202",
      "t": "Marbled Pink",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        150,
        126,
        116
      ],
      "id": "TT-01-1203",
      "t": "Marbled Light Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        109,
        108,
        143
      ],
      "id": "TT-01-1204",
      "t": "Marbled Lt Blue-Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        182,
        190,
        203
      ],
      "id": "TT-01-1205",
      "t": "Marbled Blue-Tone White",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        112,
        139,
        150
      ],
      "id": "TT-01-1206",
      "t": "Marbled Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        91,
        115,
        107
      ],
      "id": "TT-01-1207",
      "t": "Marbled Dark Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        112,
        123,
        129
      ],
      "id": "TT-01-1208",
      "t": "Marbled Chinese Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        236,
        234,
        230
      ],
      "id": "TT-01-1241",
      "t": "Translucent White Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        157,
        204,
        207
      ],
      "id": "TT-01-1243",
      "t": "Translucent Glacier Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        145,
        205,
        158
      ],
      "id": "TT-01-1244",
      "t": "Translucent Celery Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        138,
        154,
        206
      ],
      "id": "TT-01-1246",
      "t": "Translucent Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        139,
        140,
        131
      ],
      "id": "TT-01-1250",
      "t": "Translucent Shark Fin Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        175,
        146,
        148
      ],
      "id": "TT-01-1251",
      "t": "Translucent Dusty Rose Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        180,
        186,
        189
      ],
      "id": "TT-01-1600",
      "t": "Opaque Lt Gray Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        171,
        184,
        186
      ],
      "id": "TT-01-1600F",
      "t": "Opaque Matte Lt Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        236,
        198,
        205
      ],
      "id": "TT-01-1601",
      "t": "Opaque Carnation Pink Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        243,
        188,
        180
      ],
      "id": "TT-01-1602",
      "t": "Opaque Peachy Pink Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        186,
        121,
        110
      ],
      "id": "TT-01-1603",
      "t": "Opaque Begonia Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        214,
        180,
        41
      ],
      "id": "TT-01-1604F",
      "t": "Opaque Matte Tuscan Orange",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        183,
        141,
        12
      ],
      "id": "TT-01-1605F",
      "t": "Opaque Matte Caramel",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        197,
        144,
        25
      ],
      "id": "TT-01-1606",
      "t": "Opaque Tuscan Orange Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        207,
        197,
        1
      ],
      "id": "TT-01-1607",
      "t": "Opaque Butterscotch Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        193,
        176,
        6
      ],
      "id": "TT-01-1607F",
      "t": "Opaque Matte Butterscotch",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        194,
        160,
        8
      ],
      "id": "TT-01-1608",
      "t": "Opaque Caramel Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        179,
        153,
        5
      ],
      "id": "TT-01-1609F",
      "t": "Opaque Matte Ochre",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        102,
        120,
        58
      ],
      "id": "TT-01-1610",
      "t": "Opaque Olive Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        120,
        148,
        83
      ],
      "id": "TT-01-1610F",
      "t": "Opaque Matte Luster Olive",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        136,
        175,
        171
      ],
      "id": "TT-01-1611",
      "t": "Opaque Lagoon Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        146,
        186,
        171
      ],
      "id": "TT-01-1612F",
      "t": "Opaque Matte Lt Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        126,
        173,
        193
      ],
      "id": "TT-01-1613F",
      "t": "Opaque Matte Lt Blue Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        134,
        187,
        215
      ],
      "id": "TT-01-1614",
      "t": "Opaque Prairie Sky Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        138,
        175,
        199
      ],
      "id": "TT-01-1614F",
      "t": "Opaque Matte Prairie Sky",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        101,
        140,
        163
      ],
      "id": "TT-01-1615",
      "t": "Opaque Larimar Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        134,
        157,
        186
      ],
      "id": "TT-01-1616",
      "t": "Opaque Morning Glory Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        139,
        153,
        170
      ],
      "id": "TT-01-1616F",
      "t": "Opaque Matte Morning Glory",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        122,
        146,
        181
      ],
      "id": "TT-01-1617F",
      "t": "Opaque Matte Sky Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        150,
        153,
        182
      ],
      "id": "TT-01-1618",
      "t": "Opaque French Lavender Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        162,
        166,
        184
      ],
      "id": "TT-01-1618F",
      "t": "Opaque Matte French Lavender",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        206,
        184,
        200
      ],
      "id": "TT-01-1619",
      "t": "Opaque Lavender Cloud Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        199,
        190,
        203
      ],
      "id": "TT-01-1619F",
      "t": "Opaque Matte Lavender Cloud",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        213,
        192,
        215
      ],
      "id": "TT-01-1620",
      "t": "Opaque Wild Lilac Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        178,
        143,
        170
      ],
      "id": "TT-01-1621F",
      "t": "Opaque Matte Lilac",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        147,
        139,
        166
      ],
      "id": "TT-01-1622",
      "t": "Opaque French Lilac Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        190,
        142,
        35
      ],
      "id": "TT-01-1623F",
      "t": "Opaque Matte Yellow-Gold Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        167,
        158,
        0
      ],
      "id": "TT-01-1624F",
      "t": "Opaque Matte Khaki Gold Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        118,
        70,
        51
      ],
      "id": "TT-01-1625F",
      "t": "Opaque Matte Beet Red",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        149,
        103,
        63
      ],
      "id": "TT-01-1626F",
      "t": "Opaque Matte Sunset Rainbow TT-01-1627",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        205,
        191,
        154
      ],
      "id": "TT-01-1627F",
      "t": "Opaque Matte Khaki Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        99,
        121,
        113
      ],
      "id": "TT-01-1628",
      "t": "Opaque Olive Iris Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        127,
        98,
        96
      ],
      "id": "TT-01-1629",
      "t": "Opaque Olive-Amethyst Luster Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        115,
        127,
        142
      ],
      "id": "TT-01-1630",
      "t": "Opaque Plum Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        118,
        113,
        146
      ],
      "id": "TT-01-1631",
      "t": "Opaque Purple Amethyst Luster",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        170,
        122,
        134
      ],
      "id": "TT-01-1632F",
      "t": "Opaque Matte Gold Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        136,
        100,
        131
      ],
      "id": "TT-01-1633F",
      "t": "Opaque Matte Blackberry Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        127,
        98,
        116
      ],
      "id": "TT-01-1634F",
      "t": "Opaque Matte Sugar Plum Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        134,
        118,
        97
      ],
      "id": "TT-01-1703",
      "t": "Gilded Marble Turquoise",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        101,
        112,
        117
      ],
      "id": "TT-01-1800",
      "t": "Silver-Lined Med Gray Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        162,
        148,
        110
      ],
      "id": "TT-01-1801",
      "t": "Gold-Lined Crystal Glacier Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        144,
        117,
        99
      ],
      "id": "TT-01-1802",
      "t": "Gold-Lined Lt Topaz Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        156,
        140,
        29
      ],
      "id": "TT-01-1803",
      "t": "Gold-Lined Lemon Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        74,
        113,
        77
      ],
      "id": "TT-01-1804",
      "t": "Silver-Lined Sour Apple Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        75,
        101,
        74
      ],
      "id": "TT-01-1805",
      "t": "Gold-Lined Peridot Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        92,
        103,
        138
      ],
      "id": "TT-01-1806",
      "t": "Silver-Lined Montana Blue Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        119,
        109,
        104
      ],
      "id": "TT-01-1807",
      "t": "Silver-Lined Gray Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        124,
        110,
        113
      ],
      "id": "TT-01-1808",
      "t": "Silver-Lined Lt Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        95,
        80,
        99
      ],
      "id": "TT-01-1809",
      "t": "Copper-Lined Lt Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        156,
        123,
        92
      ],
      "id": "TT-01-1810",
      "t": "Antique Copper-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        177,
        171,
        99
      ],
      "id": "TT-01-1811",
      "t": "Silver-Lined Citrus Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        182,
        112,
        144
      ],
      "id": "TT-01-1821",
      "t": "Bubble Gum-Lined Lt Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        184,
        53,
        57
      ],
      "id": "TT-01-1822",
      "t": "Siam-Lined Hyacinth Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        147,
        88,
        44
      ],
      "id": "TT-01-1823",
      "t": "Orange-Lined Lime Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        124,
        80,
        48
      ],
      "id": "TT-01-1825",
      "t": "Purple-Lined Hyacinth Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        236,
        95,
        69
      ],
      "id": "TT-01-1826",
      "t": "Opaque Hyacinth-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        223,
        138,
        69
      ],
      "id": "TT-01-1827",
      "t": "Orange-Lined Jonquil Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        112,
        108,
        84
      ],
      "id": "TT-01-1828",
      "t": "Orange-Lined Peridot Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        74,
        105,
        57
      ],
      "id": "TT-01-1829",
      "t": "Forest Green-Lined Jonquil Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        88,
        152,
        97
      ],
      "id": "TT-01-1830",
      "t": "Clover-Lined Lt Jonquil Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        32,
        133,
        84
      ],
      "id": "TT-01-1831",
      "t": "Shamrock-Lined Peridot Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        61,
        189,
        159
      ],
      "id": "TT-01-1832",
      "t": "Mint Julep-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        68,
        138,
        129
      ],
      "id": "TT-01-1833",
      "t": "Teal-Lined Lt Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        39,
        157,
        173
      ],
      "id": "TT-01-1834",
      "t": "Turquoise-Lined Lt Sapphire Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        63,
        152,
        195
      ],
      "id": "TT-01-1835",
      "t": "Aqua-Lined Lt Capri Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        63,
        90,
        118
      ],
      "id": "TT-01-1836",
      "t": "Denim Blue-Lined Lt Amethyst Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        66,
        72,
        135
      ],
      "id": "TT-01-1837",
      "t": "Enchanted Purple-Lined Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        94,
        78,
        155
      ],
      "id": "TT-01-1838",
      "t": "Violet-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        154,
        86,
        141
      ],
      "id": "TT-01-1839",
      "t": "Pink-Lined Alexandrite Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        167,
        115,
        155
      ],
      "id": "TT-01-1840",
      "t": "Pansy-Lined Crystal Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        224,
        143,
        154
      ],
      "id": "TT-01-1841",
      "t": "Pink-Lined Rosaline Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        101,
        113,
        154
      ],
      "id": "TT-01-1843",
      "t": "Lavender-Lined Aqua Rainbow",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        222,
        215,
        197
      ],
      "id": "TT-01-PF2100",
      "t": "PermaFinish Translucent Silver-Lined White",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        204,
        192,
        181
      ],
      "id": "TT-01-PF2101",
      "t": "PermaFinish Translucent Silver-Lined Cloud",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        117,
        121,
        136
      ],
      "id": "TT-01-PF2102",
      "t": "PermaFinish Translucent Silver-Lined Montana Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        126,
        189,
        147
      ],
      "id": "TT-01-PF2103",
      "t": "PermaFinish Translucent Silver-Lined Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        41,
        163,
        159
      ],
      "id": "TT-01-PF2104",
      "t": "PermaFinish Translucent Silver-Lined Teal",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        211,
        141,
        153
      ],
      "id": "TT-01-PF2105",
      "t": "PermaFinish Translucent Silver-Lined Rosaline",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        202,
        117,
        125
      ],
      "id": "TT-01-PF2106",
      "t": "PermaFinish Translucent Silver-Lined Mauve",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        213,
        97,
        146
      ],
      "id": "TT-01-PF2107",
      "t": "PermaFinish Translucent Silver-Lined Hot Pink",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        138,
        101,
        117
      ],
      "id": "TT-01-PF2108",
      "t": "PermaFinish Translucent Silver-Lined Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 4,
      "c": [
        195,
        184,
        107
      ],
      "id": "TT-01-PF2109",
      "t": "PermaFinish Translucent Silver-Lined Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        197,
        163,
        94
      ],
      "id": "TT-01-PF2110",
      "t": "PermaFinish Translucent Silver-Lined Lt Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        203,
        147,
        119
      ],
      "id": "TT-01-PF2111",
      "t": "PermaFinish Translucent Silver-Lined Peach",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        226,
        145,
        107
      ],
      "id": "TT-01-PF2112",
      "t": "PermaFinish Translucent Silver-Lined Grapefruit",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        143,
        68,
        64
      ],
      "id": "TT-01-PF2113",
      "t": "PermaFinish Translucent Silver-Lined Pomegranate",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        93,
        66,
        60
      ],
      "id": "TT-01-PF2114",
      "t": "PermaFinish Translucent Silver-Lined Nutmeg",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        147,
        134,
        130
      ],
      "id": "TT-01-PF2115",
      "t": "PermaFinish Translucent Silver-Lined Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        158,
        184,
        172
      ],
      "id": "TT-01-PF2116",
      "t": "PermaFinish Translucent Silver-Lined Lt Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        106,
        177,
        173
      ],
      "id": "TT-01-PF2117",
      "t": "PermaFinish Translucent Silver-Lined Aqua",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        130,
        176,
        148
      ],
      "id": "TT-01-PF2118",
      "t": "PermaFinish Translucent Silver-Lined Lt Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        99,
        163,
        133
      ],
      "id": "TT-01-PF2119",
      "t": "PermaFinish Translucent Silver-Lined Dk Peridot",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        206,
        158,
        155
      ],
      "id": "TT-01-PF2120",
      "t": "PermaFinish Translucent Silver-Lined Soft Pink",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        177,
        138,
        144
      ],
      "id": "TT-01-PF2121",
      "t": "PermaFinish Translucent Silver-Lined Lt Amethyst",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        141,
        123,
        138
      ],
      "id": "TT-01-PF2122",
      "t": "PermaFinish Translucent Silver-Lined Alexandrite",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        103,
        101,
        154
      ],
      "id": "TT-01-PF2123",
      "t": "PermaFinish Translucent Silver-Lined Indigo",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        117,
        102,
        126
      ],
      "id": "TT-01-PF2124",
      "t": "PermaFinish Translucent Silver-Lined Tanzanite",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        214,
        202,
        162
      ],
      "id": "TT-01-PF2125",
      "t": "PermaFinish Translucent Silver-Lined Lt Jonquil",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        197,
        164,
        129
      ],
      "id": "TT-01-PF2126",
      "t": "PermaFinish Translucent Silver-Lined Peachy Pink",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        82,
        45,
        21
      ],
      "id": "TT-01-2152",
      "t": "Transparent Sarsaparilla",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        57,
        30,
        29
      ],
      "id": "TT-01-2153",
      "t": "Transparent Baltic Amber",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        121,
        59,
        21
      ],
      "id": "TT-01-2154",
      "t": "Transparent Marmalade",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        167,
        111,
        31
      ],
      "id": "TT-01-2156",
      "t": "Transparent Honey",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        65,
        127,
        91
      ],
      "id": "TT-01-2202",
      "t": "Transparent Silver-Lined Jade",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        54,
        79,
        135
      ],
      "id": "TT-01-2203",
      "t": "Transparent Silver-Lined Capri Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        50,
        43,
        37
      ],
      "id": "TT-01-2205",
      "t": "Transparent Silver-Lined Root Beer",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        25,
        123,
        185
      ],
      "id": "TT-01-2206",
      "t": "Transparent Silver-Lined Blue Topaz",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        151,
        185,
        183
      ],
      "id": "TT-01-2243",
      "t": "Transparent Silver-Lined Avalanche",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        142,
        187,
        142
      ],
      "id": "TT-01-2244",
      "t": "Transparent Silver-Lined Mint Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        147,
        158,
        173
      ],
      "id": "TT-01-2246",
      "t": "Transparent Silver-Lined Ice Blue",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        137,
        134,
        119
      ],
      "id": "TT-01-2250",
      "t": "Transparent Silver-Lined Milky Topaz Gray",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        147,
        114,
        104
      ],
      "id": "TT-01-2251",
      "t": "Transparent Silver-Lined Milky Rose",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        162,
        146,
        92
      ],
      "id": "TT-01-Y182",
      "t": "HYBRID Opaque Luster - Transparent Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        179,
        154,
        85
      ],
      "id": "TT-01-Y183",
      "t": "HYBRID Ultra Luster - Opaque Green",
      "dt": ""
    },
    {
      "a": 12,
      "b": 5,
      "c": [
        54,
        69,
        69
      ],
      "id": "TT-01-Y302",
      "t": "HYBRID Jet - Picasso",
      "dt": ""
    },
    {
      "a": 12,
      "b": 6,
      "c": [
        190,
        133,
        109
      ],
      "id": "TT-01-Y851",
      "t": "HYBRID Apollo",
      "dt": ""
    }
  ]